export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Custom Date scalar type */
  Date: any;
}

export interface A3 {
  Enabled?: Maybe<Scalars['Boolean']>;
  Price?: Maybe<Price>;
}

export interface A3Input {
  Enabled?: InputMaybe<Scalars['Boolean']>;
  Price?: InputMaybe<PriceInput>;
}

export interface A4 {
  Enabled?: Maybe<Scalars['Boolean']>;
  Price?: Maybe<Price>;
}

export interface A4Input {
  Enabled?: InputMaybe<Scalars['Boolean']>;
  Price?: InputMaybe<PriceInput>;
}

export interface AadConfigInput {
  ClientId?: InputMaybe<Scalars['String']>;
  ClientSecret?: InputMaybe<Scalars['String']>;
  TenantId?: InputMaybe<Scalars['String']>;
}

export interface AadConfigSchema {
  ClientId?: Maybe<Scalars['String']>;
  ClientSecret?: Maybe<Scalars['String']>;
  TenantId?: Maybe<Scalars['String']>;
}

export interface Abby {
  AggressiveTextExtraction?: Maybe<Scalars['Boolean']>;
  CheckAll?: Maybe<Scalars['Boolean']>;
  CreatedBy?: Maybe<Scalars['String']>;
  CustomerID?: Maybe<Scalars['ID']>;
  CustomerName?: Maybe<Scalars['String']>;
  DetectDocumentStructure?: Maybe<Scalars['Boolean']>;
  FastBinarization?: Maybe<Scalars['Boolean']>;
  FastMode?: Maybe<Scalars['Boolean']>;
  FastObjectsExtraction?: Maybe<Scalars['Boolean']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  Languages?: Maybe<Array<Maybe<Scalars['String']>>>;
  PdfImageOnText?: Maybe<Scalars['Boolean']>;
  PdfMrcCompression?: Maybe<Scalars['Boolean']>;
  PromptForOriginalLanguage?: Maybe<Scalars['Boolean']>;
  Tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  ThirdPartySoftwareName?: Maybe<Scalars['String']>;
  ThirdPartySoftwareType: ThirdPartySoftwareType;
  _id?: Maybe<Scalars['ID']>;
}

export interface AbbyInput {
  AggressiveTextExtraction?: InputMaybe<Scalars['Boolean']>;
  CheckAll?: InputMaybe<Scalars['Boolean']>;
  CustomerID: Scalars['ID'];
  DetectDocumentStructure?: InputMaybe<Scalars['Boolean']>;
  FastBinarization?: InputMaybe<Scalars['Boolean']>;
  FastMode?: InputMaybe<Scalars['Boolean']>;
  FastObjectsExtraction?: InputMaybe<Scalars['Boolean']>;
  IsActive?: InputMaybe<Scalars['Boolean']>;
  Languages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  PdfImageOnText?: InputMaybe<Scalars['Boolean']>;
  PdfMrcCompression?: InputMaybe<Scalars['Boolean']>;
  PromptForOriginalLanguage?: InputMaybe<Scalars['Boolean']>;
  Tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ThirdPartySoftwareName: Scalars['String'];
  ThirdPartySoftwareType: ThirdPartySoftwareType;
}

export interface AccessInput {
  Area?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  BookforOthers?: InputMaybe<Scalars['Boolean']>;
  BookforSelf?: InputMaybe<Scalars['Boolean']>;
  Configuration?: InputMaybe<Scalars['Int']>;
  Location?: InputMaybe<Scalars['String']>;
  PrintRelease?: InputMaybe<Scalars['Boolean']>;
  PrintReleaseDelete?: InputMaybe<Scalars['Boolean']>;
  PrintReleaseOverride?: InputMaybe<Scalars['Boolean']>;
  PrintReleaseforOthers?: InputMaybe<Scalars['Boolean']>;
  RePrint?: InputMaybe<Scalars['Boolean']>;
  RePrintDelete?: InputMaybe<Scalars['Boolean']>;
  RePrintOverride?: InputMaybe<Scalars['Boolean']>;
  RePrintforOthers?: InputMaybe<Scalars['Boolean']>;
  Reports?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
}

export interface AccessSchema {
  Area?: Maybe<Array<Maybe<Scalars['String']>>>;
  BookforOthers?: Maybe<Scalars['Boolean']>;
  BookforSelf?: Maybe<Scalars['Boolean']>;
  Configuration?: Maybe<Scalars['Int']>;
  Location?: Maybe<Scalars['String']>;
  PrintRelease?: Maybe<Scalars['Boolean']>;
  PrintReleaseDelete?: Maybe<Scalars['Boolean']>;
  PrintReleaseOverride?: Maybe<Scalars['Boolean']>;
  PrintReleaseforOthers?: Maybe<Scalars['Boolean']>;
  RePrint?: Maybe<Scalars['Boolean']>;
  RePrintDelete?: Maybe<Scalars['Boolean']>;
  RePrintOverride?: Maybe<Scalars['Boolean']>;
  RePrintforOthers?: Maybe<Scalars['Boolean']>;
  Reports?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export interface Account {
  AccountId?: Maybe<Scalars['String']>;
  AccountName?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['String']>;
  CustomerID?: Maybe<Scalars['ID']>;
  CustomerName?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  Tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  _id?: Maybe<Scalars['ID']>;
}

export interface AccountInfoSchema {
  AccountName?: Maybe<Scalars['String']>;
  Balance?: Maybe<Scalars['Float']>;
  GroupID?: Maybe<Scalars['ID']>;
}

export interface AccountInput {
  AccountId: Scalars['String'];
  AccountName?: InputMaybe<Scalars['String']>;
  CustomerID: Scalars['ID'];
  Description?: InputMaybe<Scalars['String']>;
  IsActive?: InputMaybe<Scalars['Boolean']>;
  Tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
}

export interface AccountSync {
  APIEndpoint?: Maybe<Scalars['String']>;
  ClientId?: Maybe<Scalars['String']>;
  ClientSecret?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['String']>;
  CustomerID?: Maybe<Scalars['ID']>;
  CustomerName?: Maybe<Scalars['String']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  Mappings?: Maybe<Mapping>;
  Tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  ThirdPartySoftwareName?: Maybe<Scalars['String']>;
  ThirdPartySoftwareType?: Maybe<ThirdPartySoftwareType>;
  _id?: Maybe<Scalars['ID']>;
}

export interface AccountSyncInput {
  APIEndpoint: Scalars['String'];
  ClientId: Scalars['String'];
  ClientSecret: Scalars['String'];
  CustomerID: Scalars['ID'];
  IsActive?: InputMaybe<Scalars['Boolean']>;
  Mappings?: InputMaybe<MappingInput>;
  Tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ThirdPartySoftwareName: Scalars['String'];
  ThirdPartySoftwareType: ThirdPartySoftwareType;
}

export interface AccountsResponse {
  accounts?: Maybe<Array<Maybe<Account>>>;
  total?: Maybe<Scalars['Int']>;
}

export interface AddPaperSize {
  Enabled?: Maybe<Scalars['Boolean']>;
  PaperSizeName?: Maybe<Scalars['String']>;
  Price?: Maybe<Price>;
}

export interface AddPaperSizeInput {
  Enabled?: InputMaybe<Scalars['Boolean']>;
  PaperSizeName?: InputMaybe<Scalars['String']>;
  Price?: InputMaybe<PriceInput>;
}

export interface AddValue {
  AccountID?: Maybe<Scalars['ID']>;
  AddToBalance?: Maybe<Scalars['String']>;
  AddValueAmount?: Maybe<Scalars['Float']>;
  Comment?: Maybe<Scalars['String']>;
  SelfAdded?: Maybe<Scalars['Boolean']>;
  StartingBalance?: Maybe<Scalars['Float']>;
  ThingID?: Maybe<Scalars['ID']>;
  ThingName?: Maybe<Scalars['String']>;
  UpdatedBalance?: Maybe<Scalars['Float']>;
  ValueAdded?: Maybe<Scalars['Boolean']>;
  ValueAddedBy?: Maybe<Scalars['String']>;
  ValueAddedByID?: Maybe<Scalars['ID']>;
  ValueAddedFrom?: Maybe<Scalars['String']>;
  ValueAddedMethod?: Maybe<Scalars['String']>;
}

export interface AddValueInput {
  AddToBalance?: InputMaybe<Scalars['String']>;
  AddValueAmount?: InputMaybe<Scalars['Float']>;
  SelfAdded?: InputMaybe<Scalars['Boolean']>;
  StartingBalance?: InputMaybe<Scalars['Float']>;
  ThingID?: InputMaybe<Scalars['ID']>;
  ThingName?: InputMaybe<Scalars['String']>;
  UpdatedBalance?: InputMaybe<Scalars['Float']>;
  ValueAdded?: InputMaybe<Scalars['Boolean']>;
  ValueAddedBy?: InputMaybe<Scalars['String']>;
  ValueAddedByID?: InputMaybe<Scalars['ID']>;
  ValueAddedFrom?: InputMaybe<Scalars['String']>;
  ValueAddedMethod?: InputMaybe<Scalars['String']>;
}

export interface AdminPasswordInput {
  Password: Scalars['String'];
}

export enum AdvanceEmailOptions {
  Bw = 'BW',
  BwOnesided = 'BW_ONESIDED',
  BwOnesidedA3 = 'BW_ONESIDED_A3',
  BwOnesidedA4 = 'BW_ONESIDED_A4',
  BwOnesidedLedger = 'BW_ONESIDED_LEDGER',
  BwOnesidedLegal = 'BW_ONESIDED_LEGAL',
  BwOnesidedLetter = 'BW_ONESIDED_LETTER',
  BwOnesidedTabloid = 'BW_ONESIDED_TABLOID',
  BwTwosided = 'BW_TWOSIDED',
  BwTwosidedA3 = 'BW_TWOSIDED_A3',
  BwTwosidedA4 = 'BW_TWOSIDED_A4',
  BwTwosidedLedger = 'BW_TWOSIDED_LEDGER',
  BwTwosidedLegal = 'BW_TWOSIDED_LEGAL',
  BwTwosidedLetter = 'BW_TWOSIDED_LETTER',
  BwTwosidedTabloid = 'BW_TWOSIDED_TABLOID',
  Color = 'COLOR',
  ColorOnesided = 'COLOR_ONESIDED',
  ColorOnesidedA3 = 'COLOR_ONESIDED_A3',
  ColorOnesidedA4 = 'COLOR_ONESIDED_A4',
  ColorOnesidedLedger = 'COLOR_ONESIDED_LEDGER',
  ColorOnesidedLegal = 'COLOR_ONESIDED_LEGAL',
  ColorOnesidedLetter = 'COLOR_ONESIDED_LETTER',
  ColorOnesidedTabloid = 'COLOR_ONESIDED_TABLOID',
  ColorTwosided = 'COLOR_TWOSIDED',
  ColorTwosidedA3 = 'COLOR_TWOSIDED_A3',
  ColorTwosidedA4 = 'COLOR_TWOSIDED_A4',
  ColorTwosidedLedger = 'COLOR_TWOSIDED_LEDGER',
  ColorTwosidedLegal = 'COLOR_TWOSIDED_LEGAL',
  ColorTwosidedLetter = 'COLOR_TWOSIDED_LETTER',
  ColorTwosidedTabloid = 'COLOR_TWOSIDED_TABLOID'
}

export interface AdvancedEmailAliasInput {
  AdvancedEmailAlias?: InputMaybe<Array<InputMaybe<AdvancedEmailSupport>>>;
  Enabled?: InputMaybe<Scalars['Boolean']>;
}

export interface AdvancedEmailAliasSchema {
  AdvancedEmailAlias?: Maybe<Array<Maybe<AdvancedEmailSupportSchema>>>;
  Enabled?: Maybe<Scalars['Boolean']>;
}

export interface AdvancedEmailConfigurationInput {
  AdvancedEmailAlias?: InputMaybe<Array<InputMaybe<AdvancedEmailSupport>>>;
  Enabled?: InputMaybe<Scalars['Boolean']>;
}

export interface AdvancedEmailConfigurationSchema {
  AdvancedEmailAlias?: Maybe<AdvancesEmailGrouped>;
  Enabled?: Maybe<Scalars['Boolean']>;
}

export interface AdvancedEmailSupport {
  AliasEmail?: InputMaybe<Scalars['String']>;
  CombinationType?: InputMaybe<Scalars['String']>;
  Email?: InputMaybe<Scalars['String']>;
}

export interface AdvancedEmailSupportSchema {
  AliasEmail?: Maybe<Scalars['String']>;
  CombinationType?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
}

export interface AdvancesEmailGrouped {
  bw?: Maybe<Array<Maybe<AdvancedEmailSupportSchema>>>;
  color?: Maybe<Array<Maybe<AdvancedEmailSupportSchema>>>;
}

export interface ApiKeyResponse {
  keys?: Maybe<Array<Maybe<Partner>>>;
  total?: Maybe<Scalars['Int']>;
}

export interface Area {
  Area?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['String']>;
  CustomerID?: Maybe<Scalars['String']>;
  CustomizationID?: Maybe<Scalars['String']>;
  DeletedAt?: Maybe<Scalars['Date']>;
  DeletedBy?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  GroupID?: Maybe<Array<Maybe<Scalars['String']>>>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  Label?: Maybe<Scalars['String']>;
  LocationID?: Maybe<Scalars['String']>;
  Rule?: Maybe<RuleSchema>;
  RulesID?: Maybe<Scalars['String']>;
  Tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  UpdatedBy?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['ID']>;
}

export interface AreaInput {
  Area: Scalars['String'];
  CreatedBy?: InputMaybe<Scalars['String']>;
  CustomerID: Scalars['String'];
  CustomizationID?: InputMaybe<Scalars['String']>;
  DeletedAt?: InputMaybe<Scalars['Date']>;
  DeletedBy?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  GroupID?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  Label?: InputMaybe<Scalars['String']>;
  LocationID: Scalars['String'];
  Rule?: InputMaybe<RuleInput>;
  RulesID?: InputMaybe<Scalars['String']>;
  Tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  UpdatedBy?: InputMaybe<Scalars['String']>;
}

export interface AreasResponse {
  area?: Maybe<Array<Maybe<Area>>>;
  total?: Maybe<Scalars['Int']>;
}

export interface AtriumBalanceResponse {
  Currency?: Maybe<Scalars['String']>;
  Message?: Maybe<Scalars['String']>;
  RemainingAmount?: Maybe<Scalars['Float']>;
  StatusCode?: Maybe<Scalars['Int']>;
  TransactionID?: Maybe<Scalars['String']>;
}

export interface AuditLogs {
  Amount?: Maybe<Scalars['Float']>;
  CreatedAt?: Maybe<Scalars['Date']>;
  CustomerData?: Maybe<CustomerDataSchema>;
  CustomerID?: Maybe<Scalars['ID']>;
  Date?: Maybe<Scalars['Date']>;
  DisconnectReason?: Maybe<Scalars['String']>;
  DuplicateConnectionCount?: Maybe<Scalars['Int']>;
  ErrorMessage?: Maybe<Scalars['String']>;
  FileName?: Maybe<Scalars['String']>;
  GroupData?: Maybe<GroupDataSchema>;
  GroupID?: Maybe<Scalars['ID']>;
  IPAddress?: Maybe<Array<Maybe<Scalars['String']>>>;
  Mobile?: Maybe<Scalars['String']>;
  OfflineDuration?: Maybe<Scalars['Float']>;
  QuotaGroupID?: Maybe<Scalars['ID']>;
  QuotaGroupName?: Maybe<Scalars['String']>;
  ReleaseCode?: Maybe<Scalars['String']>;
  RetryCount?: Maybe<Scalars['Float']>;
  Status?: Maybe<Scalars['String']>;
  ThingID?: Maybe<Scalars['ID']>;
  ThingLabel?: Maybe<Scalars['String']>;
  ThingName?: Maybe<Scalars['String']>;
  ThingType?: Maybe<Scalars['String']>;
  Type?: Maybe<Scalars['String']>;
  UsageID?: Maybe<Scalars['ID']>;
  User?: Maybe<Scalars['String']>;
}

export interface AuditLogsInput {
  Amount?: InputMaybe<Scalars['Float']>;
  CustomerID?: InputMaybe<Scalars['ID']>;
  Date?: InputMaybe<Scalars['Date']>;
  DisconnectReason?: InputMaybe<Scalars['String']>;
  ErrorMessage?: InputMaybe<Scalars['String']>;
  FileName?: InputMaybe<Scalars['String']>;
  GroupID?: InputMaybe<Scalars['ID']>;
  OfflineDuration?: InputMaybe<Scalars['Float']>;
  QuotaGroupID?: InputMaybe<Scalars['ID']>;
  QuotaGroupName?: InputMaybe<Scalars['String']>;
  ReleaseCode?: InputMaybe<Scalars['String']>;
  ThingID?: InputMaybe<Scalars['ID']>;
  ThingLabel?: InputMaybe<Scalars['String']>;
  ThingName?: InputMaybe<Scalars['String']>;
  ThingType?: InputMaybe<Scalars['String']>;
  Type?: InputMaybe<Scalars['String']>;
  User?: InputMaybe<Scalars['String']>;
}

export interface AuditLogsResponse {
  audit?: Maybe<Array<Maybe<AuditLogs>>>;
  total?: Maybe<Scalars['Int']>;
}

export interface AuditLogsTypeSchema {
  title?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
}

export interface AuthProvideDataSchema {
  AuthProvider?: Maybe<Scalars['String']>;
  AuthProviderID?: Maybe<Scalars['ID']>;
  ProviderName?: Maybe<Scalars['String']>;
}

export interface AuthProvider {
  AadConfig?: Maybe<AadConfigSchema>;
  AllowUserCreation?: Maybe<Scalars['Boolean']>;
  AssociatedIdentityProvider?: Maybe<Scalars['ID']>;
  AuthProvider?: Maybe<AuthProviderOptions>;
  CallbackUrl?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['String']>;
  CustomFields?: Maybe<Array<Maybe<CustomFieldSchema>>>;
  CustomFieldsEnabled?: Maybe<Scalars['Boolean']>;
  CustomerData?: Maybe<CustomerDataSchema>;
  CustomerID?: Maybe<Scalars['ID']>;
  CustomerName?: Maybe<Scalars['String']>;
  DefaultGroupData?: Maybe<GroupDataSchema>;
  DefaultGroupID?: Maybe<Scalars['ID']>;
  DefaultGroupName?: Maybe<Scalars['String']>;
  DisplayOnPortal?: Maybe<Scalars['Boolean']>;
  ExternalCardValidationConfig?: Maybe<ExternalCardValidationConfigSchema>;
  GSuiteConfig?: Maybe<GSuiteConfigSchema>;
  GroupAssignmentRules?: Maybe<Array<Maybe<GroupAssignmentRulesSchema>>>;
  GroupId?: Maybe<GroupIdSchema>;
  InnovativeConfig?: Maybe<InnovativeConfigSchema>;
  InternalLoginConfig?: Maybe<InternalLoginConfigSchema>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  LabelText?: Maybe<Scalars['String']>;
  LdapConfig?: Maybe<LdapConfigSchema>;
  Mappings?: Maybe<MappingsSchema>;
  OpenIdConfig?: Maybe<OpenIdConfigSchema>;
  OrgID?: Maybe<Scalars['String']>;
  PolarisConfig?: Maybe<PolarisConfigSchema>;
  ProviderName?: Maybe<Scalars['String']>;
  SamlConfig?: Maybe<SamlConfigSchema>;
  Sip2Config?: Maybe<Sip2ConfigSchema>;
  SirsiConfig?: Maybe<SirsiConfigSchema>;
  Tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  TokenExpiry?: Maybe<Scalars['Int']>;
  _id?: Maybe<Scalars['ID']>;
}

export interface AuthProviderInput {
  AadConfig?: InputMaybe<AadConfigInput>;
  AllowUserCreation?: InputMaybe<Scalars['Boolean']>;
  AssociatedIdentityProvider?: InputMaybe<Scalars['ID']>;
  AuthProvider: AuthProviderOptions;
  CreatedBy?: InputMaybe<Scalars['String']>;
  CustomFields?: InputMaybe<Array<InputMaybe<CustomFieldInput>>>;
  CustomFieldsEnabled?: InputMaybe<Scalars['Boolean']>;
  CustomerID: Scalars['ID'];
  DefaultGroupID: Scalars['ID'];
  DefaultGroupName?: InputMaybe<Scalars['String']>;
  DisplayOnPortal?: InputMaybe<Scalars['Boolean']>;
  ExternalCardValidationConfig?: InputMaybe<ExternalCardValidationInput>;
  GSuiteConfig?: InputMaybe<GSuiteConfigInput>;
  GroupAssignmentRules?: InputMaybe<Array<InputMaybe<GroupAssignmentRulesInput>>>;
  GroupId?: InputMaybe<GroupIdInput>;
  InnovativeConfig?: InputMaybe<InnovativeConfigInput>;
  InternalLoginConfig?: InputMaybe<InternalLoginConfigInput>;
  IsActive?: InputMaybe<Scalars['Boolean']>;
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  LabelText?: InputMaybe<Scalars['String']>;
  LdapConfig?: InputMaybe<LdapConfigInput>;
  Mappings: MappingsInput;
  OpenIdConfig?: InputMaybe<OpenIdConfigInput>;
  OrgID?: InputMaybe<Scalars['String']>;
  PolarisConfig?: InputMaybe<PolarisConfigInput>;
  ProviderName: Scalars['String'];
  SamlConfig?: InputMaybe<SamlConfigInput>;
  Sip2Config?: InputMaybe<Sip2ConfigInput>;
  SirsiConfig?: InputMaybe<SirsiConfigInput>;
  Tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  TokenExpiry?: InputMaybe<Scalars['Int']>;
}

export enum AuthProviderOptions {
  Azuread = 'azuread',
  ExternalCardValidation = 'externalCardValidation',
  Gsuite = 'gsuite',
  Innovative = 'innovative',
  Internal = 'internal',
  Ldap = 'ldap',
  Ldaps = 'ldaps',
  Oidc = 'oidc',
  Polaris = 'polaris',
  Saml = 'saml',
  Sip2 = 'sip2',
  Sirsi = 'sirsi'
}

export interface AuthProvidersResponse {
  authProvider?: Maybe<Array<Maybe<AuthProvider>>>;
  total?: Maybe<Scalars['Int']>;
}

export interface AuthorizeNetInput {
  ApiLogin?: InputMaybe<Scalars['String']>;
  TransactionKey?: InputMaybe<Scalars['String']>;
  WebhookURL?: InputMaybe<Scalars['String']>;
}

export interface AuthorizeNetPaymentResponse {
  message?: Maybe<Scalars['String']>;
  statusCode?: Maybe<Scalars['Int']>;
  token?: Maybe<Scalars['String']>;
}

export interface AuthorizeNetSchema {
  ApiLogin?: Maybe<Scalars['String']>;
  TransactionKey?: Maybe<Scalars['String']>;
  WebhookURL?: Maybe<Scalars['String']>;
}

export interface AuthorizeNetTokenInput {
  ApiLogin?: InputMaybe<Scalars['String']>;
  CancelUrl?: InputMaybe<Scalars['String']>;
  CustomerID: Scalars['String'];
  EnabledGateway?: InputMaybe<Scalars['Boolean']>;
  MerchantHash?: InputMaybe<Scalars['String']>;
  PaymentID?: InputMaybe<Scalars['String']>;
  Price: Scalars['Int'];
  ProductName?: InputMaybe<Scalars['String']>;
  SuccessUrl?: InputMaybe<Scalars['String']>;
  TestMode?: InputMaybe<Scalars['Boolean']>;
  TransactionKey?: InputMaybe<Scalars['String']>;
}

export interface Balance {
  DebitBalance?: Maybe<Scalars['Int']>;
  QuotaBalance?: Maybe<Scalars['Int']>;
}

export interface BalanceInput {
  DebitBalance?: InputMaybe<Scalars['Int']>;
  QuotaBalance?: InputMaybe<Scalars['Int']>;
}

export interface BalanceInputUser {
  DebitBalanceAmount?: InputMaybe<Scalars['Int']>;
  DebitBalanceName?: InputMaybe<Scalars['String']>;
  DebitBalancelabel?: InputMaybe<Scalars['String']>;
  QuotaBalanceAmount?: InputMaybe<Scalars['String']>;
  QuotaBalanceName?: InputMaybe<Scalars['String']>;
  QuotaBalancelabel?: InputMaybe<Scalars['String']>;
}

export interface BalanceSchema {
  DebitBalanceAmount?: Maybe<Scalars['Int']>;
  DebitBalanceName?: Maybe<Scalars['String']>;
  DebitBalancelabel?: Maybe<Scalars['String']>;
  QuotaBalanceAmount?: Maybe<Scalars['String']>;
  QuotaBalanceName?: Maybe<Scalars['String']>;
  QuotaBalancelabel?: Maybe<Scalars['String']>;
}

export enum BalanceType {
  Debit = 'DEBIT',
  Quota = 'QUOTA'
}

export interface BillingService {
  CreatedAt?: Maybe<Scalars['String']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  ServiceID?: Maybe<Scalars['ID']>;
  ServiceName?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['ID']>;
}

export interface BillingServicesResponse {
  services?: Maybe<Array<Maybe<BillingService>>>;
  total?: Maybe<Scalars['Int']>;
}

export interface Booking {
  BookCancelled?: Maybe<Scalars['Boolean']>;
  BookCancelledBy?: Maybe<Scalars['String']>;
  BookCancelledReason?: Maybe<Scalars['String']>;
  BookEndTime?: Maybe<Scalars['Date']>;
  BookExtAmount?: Maybe<Scalars['Int']>;
  BookExtAmountBy?: Maybe<Array<Maybe<Scalars['String']>>>;
  BookExtensions?: Maybe<Scalars['Int']>;
  BookStartTime?: Maybe<Scalars['Date']>;
  BookType?: Maybe<Scalars['String']>;
  BookedBy?: Maybe<Scalars['String']>;
  BookingType?: Maybe<Scalars['String']>;
  BookingTypeBy?: Maybe<Scalars['String']>;
}

export interface BookingInput {
  BookCancelled?: InputMaybe<Scalars['Boolean']>;
  BookCancelledBy?: InputMaybe<Scalars['String']>;
  BookCancelledReason?: InputMaybe<Scalars['String']>;
  BookEndTime?: InputMaybe<Scalars['Date']>;
  BookExtAmount?: InputMaybe<Scalars['Int']>;
  BookExtAmountBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  BookExtensions?: InputMaybe<Scalars['Int']>;
  BookStartTime?: InputMaybe<Scalars['Date']>;
  BookType?: InputMaybe<Scalars['String']>;
  BookedBy?: InputMaybe<Scalars['String']>;
  BookingType?: InputMaybe<Scalars['String']>;
  BookingTypeBy?: InputMaybe<Scalars['String']>;
}

export interface BraintreeInput {
  MerchantId?: InputMaybe<Scalars['String']>;
  PrivateKey?: InputMaybe<Scalars['String']>;
  PublicKey?: InputMaybe<Scalars['String']>;
}

export interface BraintreeSchema {
  MerchantId?: Maybe<Scalars['String']>;
  PrivateKey?: Maybe<Scalars['String']>;
  PublicKey?: Maybe<Scalars['String']>;
}

export interface BraintreeTokenInput {
  CustomerID?: InputMaybe<Scalars['String']>;
  PaymentID?: InputMaybe<Scalars['String']>;
}

export interface BraintreeTokenResponse {
  Message?: Maybe<Scalars['String']>;
  StatusCode?: Maybe<Scalars['Int']>;
  Token?: Maybe<Scalars['String']>;
}

export interface BusyTimeInfoInput {
  Days?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  Time?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
}

export interface BusyTimeInfoSchema {
  Days?: Maybe<Array<Maybe<Scalars['String']>>>;
  Time?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export interface BusyTimeInput {
  BusyTimeInfo?: InputMaybe<BusyTimeInfoInput>;
  BusyTimeType?: InputMaybe<Scalars['String']>;
  Extentions?: InputMaybe<ExtentionsInput>;
  InitalSession?: InputMaybe<Scalars['Int']>;
  LessThanXPCsAvailable?: InputMaybe<Scalars['Int']>;
  LoginWaitTimeBusyTime?: InputMaybe<Scalars['Int']>;
}

export interface BusyTimeSchema {
  BusyTimeInfo?: Maybe<BusyTimeInfoSchema>;
  BusyTimeType?: Maybe<Scalars['String']>;
  Extentions?: Maybe<ExtentionsSchema>;
  InitalSession?: Maybe<Scalars['Int']>;
  LessThanXPCsAvailable?: Maybe<Scalars['Int']>;
  LoginWaitTimeBusyTime?: Maybe<Scalars['Int']>;
}

export interface CertData {
  Certificate?: Maybe<Scalars['String']>;
  Endpoint?: Maybe<Scalars['String']>;
  PrivateKey?: Maybe<Scalars['String']>;
  RootCa?: Maybe<Scalars['String']>;
}

export interface ChargeableInput {
  ChargeAmount?: InputMaybe<Scalars['String']>;
  ChargeSession?: InputMaybe<Scalars['Boolean']>;
  ChargeTime?: InputMaybe<Scalars['Boolean']>;
}

export interface ChargeableSchema {
  ChargeAmount?: Maybe<Scalars['String']>;
  ChargeSession?: Maybe<Scalars['Boolean']>;
  ChargeTime?: Maybe<Scalars['Boolean']>;
}

export interface ChildPermissionSchema {
  Add?: Maybe<Scalars['Boolean']>;
  CustomerLevel?: Maybe<Scalars['Boolean']>;
  InnerParent?: Maybe<Scalars['Boolean']>;
  List?: Maybe<Scalars['Boolean']>;
  ParentPermission?: Maybe<Scalars['Boolean']>;
  PermissionCategoryId?: Maybe<Scalars['String']>;
  PermissionMenuID?: Maybe<Scalars['String']>;
  PermissionName?: Maybe<Scalars['String']>;
  ProductLevel?: Maybe<Scalars['String']>;
  RootLevel?: Maybe<Scalars['Boolean']>;
  _id?: Maybe<Scalars['ID']>;
  childPermissions?: Maybe<Array<Maybe<Permission>>>;
}

export interface ClosingMessageInput {
  MessageID?: InputMaybe<Scalars['String']>;
}

export interface ClosingMessageSchema {
  MessageID?: Maybe<Scalars['String']>;
}

export interface CloudStorageInput {
  Box?: InputMaybe<Scalars['Boolean']>;
  DropBox?: InputMaybe<Scalars['Boolean']>;
  GoogleDrive?: InputMaybe<Scalars['Boolean']>;
  Office365?: InputMaybe<Scalars['Boolean']>;
  OneDrive?: InputMaybe<Scalars['Boolean']>;
}

export interface CloudStorageSchema {
  Box?: Maybe<Scalars['Boolean']>;
  DropBox?: Maybe<Scalars['Boolean']>;
  GoogleDrive?: Maybe<Scalars['Boolean']>;
  Office365?: Maybe<Scalars['Boolean']>;
  OneDrive?: Maybe<Scalars['Boolean']>;
}

export enum CollectionNameType {
  Customers = 'Customers',
  Devices = 'Devices',
  Locations = 'Locations',
  Profiles = 'Profiles',
  Roles = 'Roles',
  Things = 'Things',
  Users = 'Users'
}

export interface Color {
  Color?: Maybe<Scalars['Boolean']>;
  Enabled?: Maybe<Scalars['Boolean']>;
  Grayscale?: Maybe<Scalars['Boolean']>;
}

export interface ColorDeviceInput {
  Color?: InputMaybe<Scalars['Boolean']>;
  GrayScale?: InputMaybe<Scalars['Boolean']>;
}

export interface ColorDeviceSchema {
  Color?: Maybe<Scalars['Boolean']>;
  GrayScale?: Maybe<Scalars['Boolean']>;
}

export interface ColorInput {
  Color?: InputMaybe<Scalars['Boolean']>;
  Enabled?: InputMaybe<Scalars['Boolean']>;
  Grayscale?: InputMaybe<Scalars['Boolean']>;
}

export enum ColorType {
  Color = 'Color',
  Grayscale = 'Grayscale'
}

export interface ConfirmFileUpload {
  DeliveryMethod?: InputMaybe<DeliveryMethodOptionsInput>;
  GenerateAudio?: InputMaybe<Scalars['Boolean']>;
  IsJobProcessed?: InputMaybe<Scalars['Boolean']>;
  JobList?: InputMaybe<Array<InputMaybe<JobListWorkflowInput>>>;
  SourceLanguage?: InputMaybe<Scalars['String']>;
  TargetLanguage?: InputMaybe<Scalars['String']>;
  Username?: InputMaybe<Scalars['String']>;
}

export interface ConfirmFileUploadSchema {
  CustomerID?: Maybe<Scalars['ID']>;
  DeliveryMethod?: Maybe<DeliveryMethodOptionsSchema>;
  IsJobProcessed?: Maybe<Scalars['Boolean']>;
  JobList?: Maybe<Array<Maybe<JobListWorkflowSchema>>>;
  Username?: Maybe<Scalars['String']>;
}

export interface ConfirmFileUploadV2Input {
  AutomaticDelivery?: InputMaybe<Scalars['Boolean']>;
  ComputerName?: InputMaybe<Scalars['ID']>;
  CustomerID?: InputMaybe<Scalars['ID']>;
  CustomerLocation?: InputMaybe<Scalars['String']>;
  DeviceID?: InputMaybe<Scalars['ID']>;
  DeviceName?: InputMaybe<Scalars['String']>;
  GuestName?: InputMaybe<Scalars['String']>;
  JobList?: InputMaybe<Array<InputMaybe<JobListFieldSchemaInput>>>;
  LibraryCard?: InputMaybe<Scalars['String']>;
  LocationID?: InputMaybe<Scalars['ID']>;
  Notification?: InputMaybe<NotificationInput>;
  RecordID?: InputMaybe<Scalars['ID']>;
  TotalCost?: InputMaybe<Scalars['Float']>;
  Username?: InputMaybe<Scalars['String']>;
}

export interface ConfirmFileUploadV2Schema {
  AutomaticDelivery?: Maybe<Scalars['ID']>;
  ComputerName?: Maybe<Scalars['ID']>;
  CustomerID?: Maybe<Scalars['ID']>;
  CustomerLocation?: Maybe<Scalars['String']>;
  DeviceID?: Maybe<Scalars['ID']>;
  DeviceName?: Maybe<Scalars['String']>;
  GuestName?: Maybe<Scalars['String']>;
  JobList?: Maybe<Array<Maybe<JobListFieldSchema>>>;
  LibraryCard?: Maybe<Scalars['String']>;
  LocationID?: Maybe<Scalars['ID']>;
  Notification?: Maybe<NotificationSchema>;
  RecordID?: Maybe<Scalars['ID']>;
  TotalCost?: Maybe<Scalars['Float']>;
  Username?: Maybe<Scalars['String']>;
}

export interface ConfirmationOption {
  ConfirmationType: ConfirmationType;
  Enabled: Scalars['Boolean'];
  IsDefault?: Maybe<Scalars['Boolean']>;
  Message?: Maybe<Scalars['String']>;
  Note?: Maybe<Scalars['String']>;
  Placeholder?: Maybe<Scalars['String']>;
}

export interface ConfirmationOptionInput {
  ConfirmationType: ConfirmationType;
  Enabled: Scalars['Boolean'];
  IsDefault?: InputMaybe<Scalars['Boolean']>;
  Message?: InputMaybe<Scalars['String']>;
  Note?: InputMaybe<Scalars['String']>;
  Placeholder?: InputMaybe<Scalars['String']>;
}

export enum ConfirmationType {
  Email = 'EMAIL',
  NoConfirmation = 'NO_CONFIRMATION',
  Print = 'PRINT'
}

export interface Copies {
  Enabled?: Maybe<Scalars['Boolean']>;
  Limit?: Maybe<Scalars['Int']>;
}

export interface CopiesInput {
  Enabled?: InputMaybe<Scalars['Boolean']>;
  Limit?: InputMaybe<Scalars['Int']>;
}

export interface CostPerPageInput {
  ColorCost?: InputMaybe<Scalars['Float']>;
  Currency?: InputMaybe<Scalars['String']>;
  Grayscale?: InputMaybe<Scalars['Float']>;
}

export interface CostPerPageSchema {
  ColorCost?: Maybe<Scalars['Float']>;
  Currency?: Maybe<Scalars['String']>;
  Grayscale?: Maybe<Scalars['Float']>;
}

export interface CustomFieldInput {
  FieldName?: InputMaybe<Scalars['String']>;
  FieldType?: InputMaybe<CustomValueType>;
  FieldValue?: InputMaybe<Scalars['String']>;
}

export interface CustomFieldSchema {
  FieldName?: Maybe<Scalars['String']>;
  FieldType?: Maybe<CustomValueType>;
  FieldValue?: Maybe<Scalars['String']>;
}

export interface CustomPermission {
  CustomerLevel?: Maybe<Scalars['Boolean']>;
  Enum?: Maybe<Scalars['Int']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  ParentPermissionID?: Maybe<Scalars['String']>;
  PermissionName?: Maybe<Scalars['String']>;
  ProductType?: Maybe<Array<Maybe<Scalars['String']>>>;
  Root?: Maybe<Scalars['Boolean']>;
  _id?: Maybe<Scalars['ID']>;
}

export interface CustomPermissionInput {
  CustomerLevel?: InputMaybe<Scalars['Boolean']>;
  Enum?: InputMaybe<Scalars['Int']>;
  IsActive?: InputMaybe<Scalars['Boolean']>;
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  ParentPermissionID?: InputMaybe<Scalars['String']>;
  PermissionName?: InputMaybe<Scalars['String']>;
  ProductType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  Root?: InputMaybe<Scalars['Boolean']>;
}

export interface CustomPermissionResponse {
  customPermission?: Maybe<Array<Maybe<ParentChildPermission>>>;
  total?: Maybe<Scalars['Int']>;
}

export enum CustomValueType {
  Dynamic = 'dynamic',
  Static = 'static'
}

export interface Customer {
  ApiKey?: Maybe<Scalars['String']>;
  ApprovedBy?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['String']>;
  CustomerName?: Maybe<Scalars['String']>;
  CustomerType?: Maybe<Scalars['String']>;
  DeletedAt?: Maybe<Scalars['Date']>;
  DeletedBy?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  DisplayName?: Maybe<Scalars['String']>;
  DomainName?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsApproved?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['String']>;
  Label?: Maybe<Scalars['String']>;
  LicenseData?: Maybe<LicenseData>;
  LocationCount?: Maybe<Scalars['Int']>;
  MfaEnforce?: Maybe<Scalars['Boolean']>;
  ParentCustomer?: Maybe<MainCustomerData>;
  ParentCustomerData?: Maybe<MainCustomerData>;
  Partner?: Maybe<Scalars['Boolean']>;
  Searchable?: Maybe<Scalars['Boolean']>;
  SubCustomer?: Maybe<Array<Maybe<SubCustomerData>>>;
  Tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  Tier?: Maybe<Scalars['String']>;
  TimeZone?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
}

export interface CustomerDataSchema {
  CustomerName?: Maybe<Scalars['String']>;
  DomainName?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['ID']>;
}

export interface CustomerInput {
  ApiKey?: InputMaybe<Scalars['String']>;
  CustomerName: Scalars['String'];
  CustomerType?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  DisplayName?: InputMaybe<Scalars['String']>;
  DomainName?: InputMaybe<Scalars['String']>;
  Email?: InputMaybe<Scalars['String']>;
  Label?: InputMaybe<Scalars['String']>;
  MfaEnforce?: InputMaybe<Scalars['Boolean']>;
  ParentCustomer?: InputMaybe<Scalars['String']>;
  Partner?: InputMaybe<Scalars['Boolean']>;
  SubCustomerID?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  SubCustomers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  Tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  Tier?: InputMaybe<Scalars['String']>;
  TimeZone?: InputMaybe<Scalars['String']>;
}

export interface CustomersResponse {
  customer?: Maybe<Array<Maybe<Customer>>>;
  total?: Maybe<Scalars['Int']>;
}

export interface Customization {
  CreatedBy?: Maybe<Scalars['String']>;
  CustomerID?: Maybe<Scalars['String']>;
  Customization?: Maybe<Scalars['String']>;
  DeletedAt?: Maybe<Scalars['Date']>;
  DeletedBy?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  Hex50?: Maybe<Scalars['String']>;
  Hex100?: Maybe<Scalars['String']>;
  Hex200?: Maybe<Scalars['String']>;
  Hex300?: Maybe<Scalars['String']>;
  Hex400?: Maybe<Scalars['String']>;
  Hex500?: Maybe<Scalars['String']>;
  Hex600?: Maybe<Scalars['String']>;
  Hex700?: Maybe<Scalars['String']>;
  Hex800?: Maybe<Scalars['String']>;
  Hex900?: Maybe<Scalars['String']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  Logo?: Maybe<Scalars['String']>;
  Rgb50?: Maybe<Scalars['String']>;
  Rgb100?: Maybe<Scalars['String']>;
  Rgb200?: Maybe<Scalars['String']>;
  Rgb300?: Maybe<Scalars['String']>;
  Rgb400?: Maybe<Scalars['String']>;
  Rgb500?: Maybe<Scalars['String']>;
  Rgb600?: Maybe<Scalars['String']>;
  Rgb700?: Maybe<Scalars['String']>;
  Rgb800?: Maybe<Scalars['String']>;
  Rgb900?: Maybe<Scalars['String']>;
  Tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  UpdatedBy?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['ID']>;
  themeCode?: Maybe<Scalars['String']>;
}

export interface CustomizationInput {
  CustomerID?: InputMaybe<Scalars['String']>;
  Customization?: InputMaybe<Scalars['String']>;
  DeletedAt?: InputMaybe<Scalars['Date']>;
  DeletedBy?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  Logo?: InputMaybe<Scalars['String']>;
  Tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  themeCode: Scalars['String'];
}

export interface CustomizationTextsResponse {
  customizationText?: Maybe<Array<Maybe<CustomizationText>>>;
  total?: Maybe<Scalars['Int']>;
}

export interface CustomizationsResponse {
  customization?: Maybe<Array<Maybe<Customization>>>;
  total?: Maybe<Scalars['Int']>;
}

export interface DashboardReports {
  DayWiseData?: Maybe<Array<Maybe<DayWiseData>>>;
  DeliveryByDateWiseData?: Maybe<DeliveryByDateWiseData>;
  DeliveryWiseData?: Maybe<DeliveryWiseData>;
}

export interface DayHoursInput {
  CloseTimes?: InputMaybe<Scalars['String']>;
  Day?: InputMaybe<Scalars['String']>;
  Enable?: InputMaybe<Scalars['Boolean']>;
  OpenTimes?: InputMaybe<Scalars['String']>;
}

export interface DayHoursSchema {
  CloseTimes?: Maybe<Scalars['String']>;
  Day?: Maybe<Scalars['String']>;
  Enable?: Maybe<Scalars['Boolean']>;
  OpenTimes?: Maybe<Scalars['String']>;
}

export interface DayWiseData {
  count?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['String']>;
}

export interface AddedFundsData {
  amount?: Maybe<Scalars['Float']>;
  date?: Maybe<Scalars['String']>;
}

export interface DeductBalanceSchema {
  AccountName?: Maybe<Scalars['String']>;
  AmountDeducted?: Maybe<Scalars['Float']>;
  GroupID?: Maybe<Scalars['ID']>;
  Pages?: Maybe<Scalars['Float']>;
}

export interface DeductValue {
  AccountID?: Maybe<Scalars['ID']>;
  AccountName?: Maybe<Scalars['String']>;
  Deducted?: Maybe<Scalars['Boolean']>;
  DeductedAmount?: Maybe<Scalars['Float']>;
  DeductedMethod?: Maybe<Scalars['String']>;
  JobType?: Maybe<Scalars['String']>;
}

export interface DeductValueInput {
  AccountID?: InputMaybe<Scalars['ID']>;
  AccountName?: InputMaybe<Scalars['String']>;
  Deducted?: InputMaybe<Scalars['Boolean']>;
  DeductedAmount?: InputMaybe<Scalars['Float']>;
  DeductedMethod?: InputMaybe<Scalars['String']>;
  JobType?: InputMaybe<Scalars['String']>;
}

export interface DeleteInfo {
  customerId?: InputMaybe<Scalars['ID']>;
  fileNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publicUploadId?: InputMaybe<Scalars['ID']>;
  releaseCode?: InputMaybe<Scalars['String']>;
}

export interface DeliveryByDateWiseData {
  desktop?: Maybe<Array<Maybe<DayWiseData>>>;
  driver?: Maybe<Array<Maybe<DayWiseData>>>;
  email?: Maybe<Array<Maybe<DayWiseData>>>;
  kiosk?: Maybe<Array<Maybe<DayWiseData>>>;
  mobile?: Maybe<Array<Maybe<DayWiseData>>>;
  web?: Maybe<Array<Maybe<DayWiseData>>>;
}

export interface DeliveryData {
  count?: Maybe<Scalars['Int']>;
}

export interface DeliveryMethodOptionsInput {
  EmailAddress?: InputMaybe<Scalars['String']>;
  SessionID?: InputMaybe<Scalars['String']>;
  ThingID?: InputMaybe<Scalars['ID']>;
}

export interface DeliveryMethodOptionsSchema {
  EmailAddress?: Maybe<Scalars['String']>;
  SessionID?: Maybe<Scalars['String']>;
  ThingID?: Maybe<Scalars['ID']>;
}

export interface DeliveryWiseData {
  desktop?: Maybe<Array<Maybe<DeliveryData>>>;
  driver?: Maybe<Array<Maybe<DeliveryData>>>;
  email?: Maybe<Array<Maybe<DeliveryData>>>;
  kiosk?: Maybe<Array<Maybe<DeliveryData>>>;
  mobile?: Maybe<Array<Maybe<DeliveryData>>>;
  web?: Maybe<Array<Maybe<DeliveryData>>>;
}

export interface DescriptionInput {
  DescriptionBox?: InputMaybe<Scalars['String']>;
  DescriptionTitle?: InputMaybe<Scalars['String']>;
}

export interface DescriptionSchema {
  DescriptionBox?: Maybe<Scalars['String']>;
  DescriptionTitle?: Maybe<Scalars['String']>;
}

export interface Device {
  AreaID?: Maybe<Scalars['String']>;
  Color?: Maybe<ColorDeviceSchema>;
  ColorEnabled?: Maybe<Scalars['Boolean']>;
  CreatedBy?: Maybe<Scalars['String']>;
  CustomerData?: Maybe<CustomerDataSchema>;
  CustomerID?: Maybe<Scalars['ID']>;
  CustomerName?: Maybe<Scalars['String']>;
  DeletedAt?: Maybe<Scalars['Date']>;
  DeletedBy?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  Device?: Maybe<Scalars['String']>;
  DeviceType?: Maybe<Scalars['String']>;
  Duplex?: Maybe<DuplexDeviceSchema>;
  DuplexEnabled?: Maybe<Scalars['Boolean']>;
  Enabled?: Maybe<Scalars['Boolean']>;
  GroupID?: Maybe<Array<Maybe<Scalars['ID']>>>;
  IppPrintOptions?: Maybe<IppPrintOptionsSchema>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  Label?: Maybe<Scalars['String']>;
  Layout?: Maybe<LayoutDeviceSchema>;
  LayoutEnabled?: Maybe<Scalars['Boolean']>;
  LocationData?: Maybe<LocationDataSchema>;
  LocationID?: Maybe<Scalars['ID']>;
  MacAddress?: Maybe<Scalars['String']>;
  NetBiosName?: Maybe<Scalars['String']>;
  PaperSizes?: Maybe<PaperSizesDeviceSchema>;
  PaperSizesEnabled?: Maybe<Scalars['Boolean']>;
  QrCode?: Maybe<Scalars['String']>;
  SupportedPrintOptions?: Maybe<Scalars['Boolean']>;
  Tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  TcpPrintOptions?: Maybe<TcpPrintOptionsSchema>;
  ThingData?: Maybe<ThingDataSchema>;
  ThingID?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['ID']>;
}

export interface DeviceData {
  Device?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['ID']>;
}

export interface DeviceInput {
  AreaID?: InputMaybe<Scalars['String']>;
  Color?: InputMaybe<ColorDeviceInput>;
  ColorEnabled?: InputMaybe<Scalars['Boolean']>;
  CustomerID: Scalars['String'];
  DeletedAt?: InputMaybe<Scalars['Date']>;
  DeletedBy?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  Device: Scalars['String'];
  DeviceType?: InputMaybe<Scalars['String']>;
  Duplex?: InputMaybe<DuplexDeviceInput>;
  DuplexEnabled?: InputMaybe<Scalars['Boolean']>;
  Enabled?: InputMaybe<Scalars['Boolean']>;
  IppPrintOptions?: InputMaybe<IppPrintOptionsInput>;
  IsActive?: InputMaybe<Scalars['Boolean']>;
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  Label?: InputMaybe<Scalars['String']>;
  Layout?: InputMaybe<LayoutDeviceInput>;
  LayoutEnabled?: InputMaybe<Scalars['Boolean']>;
  LocationID?: InputMaybe<Scalars['String']>;
  MacAddress?: InputMaybe<Scalars['String']>;
  NetBiosName?: InputMaybe<Scalars['String']>;
  PaperSizes?: InputMaybe<PaperSizesDeviceInput>;
  PaperSizesEnabled?: InputMaybe<Scalars['Boolean']>;
  QrCode?: InputMaybe<Scalars['String']>;
  SupportedPrintOptions?: InputMaybe<Scalars['Boolean']>;
  Tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  TcpPrintOptions?: InputMaybe<TcpPrintOptionsInput>;
  ThingID?: InputMaybe<Scalars['String']>;
}

export interface DeviceUsagePolicyInput {
  DeviceUsagePolicyURL?: InputMaybe<Scalars['String']>;
}

export interface DeviceUsagePolicySchema {
  DeviceUsagePolicyURL?: Maybe<Scalars['String']>;
}

export interface DevicesLimit {
  DeviceNumber?: Maybe<Scalars['Int']>;
  DeviceType?: Maybe<Scalars['String']>;
}

export interface DevicesLimitInput {
  DeviceNumber?: InputMaybe<Scalars['Int']>;
  DeviceType?: InputMaybe<Scalars['String']>;
}

export interface DevicesResponse {
  device?: Maybe<Array<Maybe<Device>>>;
  total?: Maybe<Scalars['Int']>;
}

export enum DisplayEnum {
  Page = 'page',
  Popup = 'popup',
  Touch = 'touch',
  Wap = 'wap'
}

export interface DriverInput {
  ConfirmationMessagedescription?: InputMaybe<Scalars['String']>;
  Default?: InputMaybe<Scalars['Boolean']>;
  EditDocName?: InputMaybe<Scalars['Boolean']>;
  Identifier?: InputMaybe<Scalars['String']>;
  IdentifierPrompt?: InputMaybe<Scalars['Boolean']>;
  IdentitiyProviderID?: InputMaybe<Scalars['String']>;
  Location?: InputMaybe<Scalars['Boolean']>;
  LocationId?: InputMaybe<Scalars['String']>;
  Locationprompt?: InputMaybe<Scalars['Boolean']>;
  LoginOption?: InputMaybe<Scalars['String']>;
  PasswordEnabled?: InputMaybe<Scalars['Boolean']>;
  PasswordField?: InputMaybe<Scalars['String']>;
  PromptMessage?: InputMaybe<Scalars['String']>;
  RememberMe?: InputMaybe<Scalars['Boolean']>;
  RememberMeDisplay?: InputMaybe<Scalars['Boolean']>;
  RememberMeSet?: InputMaybe<Scalars['Boolean']>;
  ValidationType?: InputMaybe<ProfileValidationType>;
}

export interface DriverSchema {
  ConfirmationMessagedescription?: Maybe<Scalars['String']>;
  Default?: Maybe<Scalars['Boolean']>;
  EditDocName?: Maybe<Scalars['Boolean']>;
  Identifier?: Maybe<Scalars['String']>;
  IdentifierPrompt?: Maybe<Scalars['Boolean']>;
  IdentitiyProviderID?: Maybe<Scalars['String']>;
  Location?: Maybe<Scalars['Boolean']>;
  LocationId?: Maybe<Scalars['String']>;
  Locationprompt?: Maybe<Scalars['Boolean']>;
  LoginOption?: Maybe<Scalars['String']>;
  PasswordEnabled?: Maybe<Scalars['Boolean']>;
  PasswordField?: Maybe<Scalars['String']>;
  PromptMessage?: Maybe<Scalars['String']>;
  RememberMe?: Maybe<Scalars['Boolean']>;
  RememberMeDisplay?: Maybe<Scalars['Boolean']>;
  RememberMeSet?: Maybe<Scalars['Boolean']>;
  ValidationType?: Maybe<ProfileValidationType>;
}

export interface Dropdown {
  AuditLogsType?: Maybe<Array<Maybe<AuditLogsTypeSchema>>>;
  DeviceType?: Maybe<Array<Maybe<Scalars['String']>>>;
  PaperSize?: Maybe<Array<Maybe<Scalars['String']>>>;
  TermsOfService?: Maybe<Scalars['String']>;
  ThingType?: Maybe<Array<Maybe<Scalars['String']>>>;
  ThingTypeUpdateSupport?: Maybe<Array<Maybe<Scalars['String']>>>;
  ThirdPartySoftwareType?: Maybe<Array<Maybe<ThirdPartySoftwareType>>>;
  _id?: Maybe<Scalars['ID']>;
}

export interface Duplex {
  Enabled?: Maybe<Scalars['Boolean']>;
  OneSided?: Maybe<Scalars['Boolean']>;
  TwoSided?: Maybe<Scalars['Boolean']>;
}

export interface DuplexDeviceInput {
  OneSided?: InputMaybe<Scalars['Boolean']>;
  TwoSided?: InputMaybe<Scalars['Boolean']>;
}

export interface DuplexDeviceSchema {
  OneSided?: Maybe<Scalars['Boolean']>;
  TwoSided?: Maybe<Scalars['Boolean']>;
}

export interface DuplexInput {
  Enabled?: InputMaybe<Scalars['Boolean']>;
  OneSided?: InputMaybe<Scalars['Boolean']>;
  TwoSided?: InputMaybe<Scalars['Boolean']>;
}

export enum DuplexTypes {
  OneSided = 'OneSided',
  TwoSided = 'TwoSided'
}

export interface EbBlockedInput {
  EbBlockBy?: InputMaybe<Scalars['String']>;
  EbBlockByDate?: InputMaybe<Scalars['Date']>;
  EbBlockDateEnd?: InputMaybe<Scalars['Date']>;
  EbBlockDateStart?: InputMaybe<Scalars['Date']>;
  EbBlockPermanent?: InputMaybe<Scalars['Boolean']>;
  EbBlockedReason?: InputMaybe<Scalars['String']>;
}

export interface EbBlockedSchema {
  EbBlockBy?: Maybe<Scalars['String']>;
  EbBlockByDate?: Maybe<Scalars['Date']>;
  EbBlockDateEnd?: Maybe<Scalars['Date']>;
  EbBlockDateStart?: Maybe<Scalars['Date']>;
  EbBlockPermanent?: Maybe<Scalars['Boolean']>;
  EbBlockedReason?: Maybe<Scalars['String']>;
}

export interface Email {
  CreatedBy?: Maybe<Scalars['String']>;
  CustomerID?: Maybe<Scalars['ID']>;
  CustomerName?: Maybe<Scalars['String']>;
  DefaultAddress?: Maybe<Scalars['String']>;
  DefaultCC?: Maybe<Scalars['String']>;
  DefaultSubject?: Maybe<Scalars['String']>;
  EmailAuthentication?: Maybe<EmailAuthenticationType>;
  EmailAuthenticationEnabled?: Maybe<Scalars['Boolean']>;
  EmailConnection?: Maybe<EmailConnectionType>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  Login?: Maybe<Scalars['String']>;
  MessageBody?: Maybe<Scalars['String']>;
  Password?: Maybe<Scalars['String']>;
  Port?: Maybe<Scalars['Int']>;
  SMTP?: Maybe<Scalars['String']>;
  SSLType?: Maybe<Scalars['Boolean']>;
  SenderEmail?: Maybe<Scalars['String']>;
  SenderName?: Maybe<Scalars['String']>;
  Tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  ThirdPartySoftwareName?: Maybe<Scalars['String']>;
  ThirdPartySoftwareType?: Maybe<ThirdPartySoftwareType>;
  Username?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['ID']>;
}

export interface EmailAuthenticationInput {
  EmailAuthenticationTitle?: InputMaybe<Scalars['String']>;
  Facebook?: InputMaybe<Scalars['Boolean']>;
  FacebookDisplayText?: InputMaybe<Scalars['String']>;
  Gmail?: InputMaybe<Scalars['Boolean']>;
  GmailDisplayText?: InputMaybe<Scalars['String']>;
  Microsoft?: InputMaybe<Scalars['Boolean']>;
  MicrosoftDisplayText?: InputMaybe<Scalars['String']>;
}

export interface EmailAuthenticationType {
  EmailAuthenticationTitle?: Maybe<Scalars['String']>;
  Facebook?: Maybe<Scalars['Boolean']>;
  FacebookDisplayText?: Maybe<Scalars['String']>;
  Gmail?: Maybe<Scalars['Boolean']>;
  GmailDisplayText?: Maybe<Scalars['String']>;
  Microsoft?: Maybe<Scalars['Boolean']>;
  MicrosoftDisplayText?: Maybe<Scalars['String']>;
}

export interface EmailBodyInput {
  Attachments?: InputMaybe<Array<InputMaybe<FileAttachmentInput>>>;
  BodyMessage?: InputMaybe<Scalars['String']>;
  CC?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  EmailAddress?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  Subject?: InputMaybe<Scalars['String']>;
}

export interface EmailConnectionInput {
  AfterScanning?: InputMaybe<Scalars['Boolean']>;
  AfterSelectingMedia?: InputMaybe<Scalars['Boolean']>;
  BeforeSending?: InputMaybe<Scalars['Boolean']>;
}

export interface EmailConnectionType {
  AfterScanning?: Maybe<Scalars['Boolean']>;
  AfterSelectingMedia?: Maybe<Scalars['Boolean']>;
  BeforeSending?: Maybe<Scalars['Boolean']>;
}

export interface EmailInput {
  CustomerID?: InputMaybe<Scalars['ID']>;
  CustomerName?: InputMaybe<Scalars['String']>;
  DefaultAddress?: InputMaybe<Scalars['String']>;
  DefaultCC?: InputMaybe<Scalars['String']>;
  DefaultSubject?: InputMaybe<Scalars['String']>;
  EmailAuthentication?: InputMaybe<EmailAuthenticationInput>;
  EmailAuthenticationEnabled?: InputMaybe<Scalars['Boolean']>;
  EmailConnection?: InputMaybe<EmailConnectionInput>;
  IsActive?: InputMaybe<Scalars['Boolean']>;
  Login?: InputMaybe<Scalars['String']>;
  MessageBody?: InputMaybe<Scalars['String']>;
  Password?: InputMaybe<Scalars['String']>;
  Port?: InputMaybe<Scalars['Int']>;
  SMTP?: InputMaybe<Scalars['String']>;
  SSLType?: InputMaybe<Scalars['Boolean']>;
  SenderEmail?: InputMaybe<Scalars['String']>;
  SenderName?: InputMaybe<Scalars['String']>;
  Tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ThirdPartySoftwareName: Scalars['String'];
  ThirdPartySoftwareType: ThirdPartySoftwareType;
  Username?: InputMaybe<Scalars['String']>;
}

export interface EndOfDayInput {
  ClosingMessage?: InputMaybe<Array<InputMaybe<ClosingMessageInput>>>;
  NoSessionMinBeforeClosing?: InputMaybe<Scalars['Int']>;
  ShutDownMinutesAfterClosing?: InputMaybe<Scalars['Int']>;
  Shutdown?: InputMaybe<Scalars['Boolean']>;
  Value?: InputMaybe<Scalars['Boolean']>;
}

export interface EndOfDaySchema {
  ClosingMessage?: Maybe<Array<Maybe<ClosingMessageSchema>>>;
  NoSessionMinBeforeClosing?: Maybe<Scalars['Int']>;
  ShutDownMinutesAfterClosing?: Maybe<Scalars['Int']>;
  Shutdown?: Maybe<Scalars['Boolean']>;
  Value?: Maybe<Scalars['Boolean']>;
}

export interface ExtentionsInput {
  AutomaticExtensions?: InputMaybe<Scalars['Boolean']>;
  ExtentionTime?: InputMaybe<Scalars['Int']>;
}

export interface ExtentionsSchema {
  AutomaticExtensions?: Maybe<Scalars['Boolean']>;
  ExtentionTime?: Maybe<Scalars['Int']>;
}

export interface ExternalCardValidationConfigSchema {
  AcrValues?: Maybe<Scalars['String']>;
  AdditionalScope?: Maybe<Scalars['String']>;
  AuthorizationEndpoint?: Maybe<Scalars['String']>;
  ClientId?: Maybe<Scalars['String']>;
  ClientSecret?: Maybe<Scalars['String']>;
  DiscoveryDocument?: Maybe<Scalars['String']>;
  Display?: Maybe<DisplayEnum>;
  MaxAge?: Maybe<Scalars['Int']>;
  NonceEnabled?: Maybe<Scalars['Boolean']>;
  Prompt?: Maybe<Array<Maybe<PromptEnum>>>;
}

export interface ExternalCardValidationInput {
  AcrValues?: InputMaybe<Scalars['String']>;
  AdditionalScope?: InputMaybe<Scalars['String']>;
  AuthorizationEndpoint?: InputMaybe<Scalars['String']>;
  ClientId: Scalars['String'];
  ClientSecret: Scalars['String'];
  DiscoveryDocument?: InputMaybe<Scalars['String']>;
  Display?: InputMaybe<DisplayEnum>;
  MaxAge?: InputMaybe<Scalars['Int']>;
  NonceEnabled?: InputMaybe<Scalars['Boolean']>;
  Prompt?: InputMaybe<Array<InputMaybe<PromptEnum>>>;
}

export interface Ftp {
  CreatedBy?: Maybe<Scalars['String']>;
  CustomerID?: Maybe<Scalars['ID']>;
  CustomerName?: Maybe<Scalars['String']>;
  FTPType?: Maybe<FtpType>;
  HostName?: Maybe<Scalars['String']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  Password?: Maybe<Scalars['String']>;
  PortNumber?: Maybe<Scalars['Int']>;
  Tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  ThirdPartySoftwareName?: Maybe<Scalars['String']>;
  ThirdPartySoftwareType: ThirdPartySoftwareType;
  Username?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['ID']>;
}

export interface FtpInput {
  CustomerID: Scalars['ID'];
  FTPType: FtpType;
  HostName?: InputMaybe<Scalars['String']>;
  IsActive?: InputMaybe<Scalars['Boolean']>;
  Password?: InputMaybe<Scalars['String']>;
  PortNumber?: InputMaybe<Scalars['Int']>;
  Tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ThirdPartySoftwareName: Scalars['String'];
  ThirdPartySoftwareType: ThirdPartySoftwareType;
  Username?: InputMaybe<Scalars['String']>;
}

export enum FtpType {
  Ftp = 'FTP',
  Ftps = 'FTPS',
  Sftp = 'SFTP'
}

export interface Fax {
  AccountCode?: Maybe<Scalars['String']>;
  CreatedAt?: Maybe<Scalars['Date']>;
  CustomerID?: Maybe<Scalars['ID']>;
  DateQueued?: Maybe<Scalars['Date']>;
  DateSent?: Maybe<Scalars['Date']>;
  Duration?: Maybe<Scalars['String']>;
  ErrorCode?: Maybe<Scalars['String']>;
  FaxDetailsID?: Maybe<Scalars['ID']>;
  FaxType?: Maybe<Scalars['String']>;
  FileName?: Maybe<Scalars['String']>;
  Location?: Maybe<Scalars['String']>;
  LocationID?: Maybe<Scalars['ID']>;
  Pages?: Maybe<Scalars['Int']>;
  Platform?: Maybe<Scalars['String']>;
  RemoteID?: Maybe<Scalars['String']>;
  SenderEmail?: Maybe<Scalars['String']>;
  SentStatus?: Maybe<Scalars['String']>;
  ServiceName?: Maybe<Scalars['String']>;
  Size?: Maybe<Scalars['Int']>;
  Thing?: Maybe<Scalars['String']>;
  ThingID?: Maybe<Scalars['ID']>;
  ToFaxNumber?: Maybe<Scalars['String']>;
  UpdatedAt?: Maybe<Scalars['Date']>;
  _id?: Maybe<Scalars['ID']>;
}

export interface FaxInput {
  AccountCode?: InputMaybe<Scalars['String']>;
  CreatedAt?: InputMaybe<Scalars['Date']>;
  CustomerID?: InputMaybe<Scalars['ID']>;
  DateQueued?: InputMaybe<Scalars['Date']>;
  DateSent?: InputMaybe<Scalars['Date']>;
  Duration?: InputMaybe<Scalars['String']>;
  ErrorCode?: InputMaybe<Scalars['String']>;
  FaxDetailsID?: InputMaybe<Scalars['ID']>;
  FaxType?: InputMaybe<Scalars['String']>;
  FileName?: InputMaybe<Scalars['String']>;
  Location?: InputMaybe<Scalars['String']>;
  LocationID?: InputMaybe<Scalars['ID']>;
  Pages?: InputMaybe<Scalars['Int']>;
  Platform?: InputMaybe<Scalars['String']>;
  RemoteID?: InputMaybe<Scalars['String']>;
  SenderEmail?: InputMaybe<Scalars['String']>;
  SentStatus?: InputMaybe<Scalars['String']>;
  ServiceName?: InputMaybe<ServiceNameType>;
  Size?: InputMaybe<Scalars['Int']>;
  Thing?: InputMaybe<Scalars['String']>;
  ThingID?: InputMaybe<Scalars['ID']>;
  ToFaxNumber?: InputMaybe<Scalars['String']>;
  UpdatedAt?: InputMaybe<Scalars['Date']>;
}

export interface FaxInputUsage {
  DocumentName?: InputMaybe<Scalars['String']>;
  DocumentSize?: InputMaybe<Scalars['Int']>;
  Duration?: InputMaybe<Scalars['String']>;
  ErrorCode?: InputMaybe<Scalars['String']>;
  JobDeliveryMethod?: InputMaybe<Scalars['String']>;
  RemoteID?: InputMaybe<Scalars['String']>;
  SentStatus?: InputMaybe<Scalars['String']>;
}

export interface FaxIntegration {
  AdditionalAreaCodes?: Maybe<Scalars['String']>;
  AllowedInternationalAreaCodes?: Maybe<Scalars['String']>;
  AllowedUSCanadaAreaCodes?: Maybe<Scalars['String']>;
  ConfirmationOptions: Array<ConfirmationOption>;
  ConfirmationReceiptOptionText?: Maybe<Scalars['String']>;
  CoverPageOptionText?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['String']>;
  CustomerID?: Maybe<Scalars['ID']>;
  CustomerName?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  EnableConfirmationReceipt?: Maybe<Scalars['Boolean']>;
  EnableCoverPage?: Maybe<Scalars['Boolean']>;
  EnableInternationalFax?: Maybe<Scalars['Boolean']>;
  FaxDestinationText?: Maybe<Scalars['String']>;
  FaxNote?: Maybe<Scalars['String']>;
  FaxProcessScreenTitle?: Maybe<Scalars['String']>;
  FaxStatusChecking?: Maybe<Scalars['Boolean']>;
  InternationalFaxButtonText?: Maybe<Scalars['String']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  LocalFaxButtonText?: Maybe<Scalars['String']>;
  Password?: Maybe<Scalars['String']>;
  Tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  ThirdPartySoftwareName?: Maybe<Scalars['String']>;
  ThirdPartySoftwareType: ThirdPartySoftwareType;
  TimeOutPerPage?: Maybe<Scalars['Int']>;
  Username?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['ID']>;
}

export interface FaxIntegrationInput {
  AdditionalAreaCodes?: InputMaybe<Scalars['String']>;
  AllowedInternationalAreaCodes?: InputMaybe<Scalars['String']>;
  AllowedUSCanadaAreaCodes?: InputMaybe<Scalars['String']>;
  ConfirmationOptions: Array<ConfirmationOptionInput>;
  ConfirmationReceiptOptionText?: InputMaybe<Scalars['String']>;
  CoverPageOptionText?: InputMaybe<Scalars['String']>;
  CustomerID: Scalars['ID'];
  Email?: InputMaybe<Scalars['String']>;
  EnableConfirmationReceipt?: InputMaybe<Scalars['Boolean']>;
  EnableCoverPage?: InputMaybe<Scalars['Boolean']>;
  EnableInternationalFax?: InputMaybe<Scalars['Boolean']>;
  FaxDestinationText?: InputMaybe<Scalars['String']>;
  FaxNote?: InputMaybe<Scalars['String']>;
  FaxProcessScreenTitle?: InputMaybe<Scalars['String']>;
  FaxStatusChecking?: InputMaybe<Scalars['Boolean']>;
  InternationalFaxButtonText?: InputMaybe<Scalars['String']>;
  IsActive?: InputMaybe<Scalars['Boolean']>;
  LocalFaxButtonText?: InputMaybe<Scalars['String']>;
  Password?: InputMaybe<Scalars['String']>;
  Tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ThirdPartySoftwareName: Scalars['String'];
  ThirdPartySoftwareType: ThirdPartySoftwareType;
  TimeOutPerPage?: InputMaybe<Scalars['Int']>;
  Username?: InputMaybe<Scalars['String']>;
}

export interface FaxRequestInput {
  AccountCode?: InputMaybe<Scalars['String']>;
  Base64?: InputMaybe<Scalars['String']>;
  Body?: InputMaybe<Scalars['String']>;
  CoverPageEnabled?: InputMaybe<Scalars['Boolean']>;
  CustomerID?: InputMaybe<Scalars['ID']>;
  Duration?: InputMaybe<Scalars['Int']>;
  FaxType?: InputMaybe<Scalars['String']>;
  FileName?: InputMaybe<Scalars['String']>;
  FromCoverPage?: InputMaybe<Scalars['String']>;
  Location?: InputMaybe<Scalars['String']>;
  LocationID?: InputMaybe<Scalars['ID']>;
  Pages?: InputMaybe<Scalars['Int']>;
  Platform?: InputMaybe<Scalars['String']>;
  SenderEmail?: InputMaybe<Scalars['String']>;
  SenderFaxNumber?: InputMaybe<Scalars['String']>;
  ServiceName?: InputMaybe<ServiceNameType>;
  Size?: InputMaybe<Scalars['Int']>;
  Subject?: InputMaybe<Scalars['String']>;
  SystemFileName?: InputMaybe<Scalars['String']>;
  ThingID?: InputMaybe<Scalars['ID']>;
  ToCoverPage?: InputMaybe<Scalars['String']>;
  ToFaxNumber?: InputMaybe<Scalars['String']>;
}

export interface FaxSchema {
  DocumentName?: Maybe<Scalars['String']>;
  DocumentSize?: Maybe<Scalars['Int']>;
  Duration?: Maybe<Scalars['String']>;
  ErrorCode?: Maybe<Scalars['String']>;
  JobDeliveryMethod?: Maybe<Scalars['String']>;
  RemoteID?: Maybe<Scalars['String']>;
  SentStatus?: Maybe<Scalars['String']>;
}

export interface FaxServiceInput {
  International?: InputMaybe<Scalars['Boolean']>;
  Local?: InputMaybe<Scalars['Boolean']>;
}

export interface FaxServiceSchema {
  International?: Maybe<Scalars['Boolean']>;
  Local?: Maybe<Scalars['Boolean']>;
}

export interface FaxesResponse {
  fax?: Maybe<Array<Maybe<Fax>>>;
  total?: Maybe<Scalars['Int']>;
}

export enum FieldNameType {
  CustomerName = 'CustomerName',
  Device = 'Device',
  DomainName = 'DomainName',
  Label = 'Label',
  Profile = 'Profile',
  RoleName = 'RoleName',
  ShortName = 'ShortName',
  Thing = 'Thing',
  Username = 'Username'
}

export interface File {
  expiryTime?: Maybe<Scalars['String']>;
  newFileName?: Maybe<Scalars['String']>;
  originalFileName?: Maybe<Scalars['String']>;
  postSignedMeta?: Maybe<Scalars['String']>;
  signedUrl?: Maybe<Scalars['String']>;
}

export interface FileAttachmentInput {
  FileName?: InputMaybe<Scalars['String']>;
  SystemFileName?: InputMaybe<Scalars['String']>;
}

export interface FileInput {
  contentType?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['String']>;
  customization?: InputMaybe<Scalars['Boolean']>;
  expiry?: InputMaybe<Scalars['Int']>;
  extension?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  upload?: InputMaybe<Scalars['Boolean']>;
}

export interface FileMetaData {
  contentType?: InputMaybe<Scalars['String']>;
  extension?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
}

export interface FileResponse {
  id?: Maybe<Scalars['ID']>;
  signedUrls?: Maybe<Array<Maybe<File>>>;
}

export interface FilterUsage {
  amount?: InputMaybe<Scalars['Float']>;
  balanceAfter?: InputMaybe<Scalars['Float']>;
  colorType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  device?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  documentName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  documentType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  duplex?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  printType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  reportType?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  transactionBy?: InputMaybe<Scalars['String']>;
  transactionType?: InputMaybe<Array<InputMaybe<TransactionTypes>>>;
  userName?: InputMaybe<Scalars['String']>;
  valueAddedMethod?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
}

export interface Filters {
  colorType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  customerId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  documentType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  duplex?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  orientation?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  paperSize?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  staple?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['String']>;
  submissionType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  timezone?: InputMaybe<Scalars['String']>;
  transactionType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueAddedMethod?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
}

export interface FinePayment {
  CreditCardLast4digits?: Maybe<Scalars['String']>;
  CreditCardType?: Maybe<Scalars['String']>;
  FinePayment?: Maybe<Scalars['Boolean']>;
  FinePaymentAmount?: Maybe<Scalars['Int']>;
  FinePaymentFrom?: Maybe<Scalars['String']>;
  FinePaymentMethod?: Maybe<Scalars['String']>;
  FinePaymentby?: Maybe<Scalars['String']>;
  InvoiceID?: Maybe<Scalars['Int']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  LMSResponse?: Maybe<Scalars['String']>;
  LMSUpdated?: Maybe<Scalars['Boolean']>;
  PaymentGatewayProvider?: Maybe<Scalars['String']>;
  PaymentGatewayTranID?: Maybe<Scalars['Int']>;
  ResponseCode?: Maybe<Scalars['Int']>;
  ResponseDescription?: Maybe<Scalars['String']>;
  ResponseStatus?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  deletedBy?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['String']>;
}

export interface FinePaymentInput {
  CreditCardLast4digits?: InputMaybe<Scalars['String']>;
  CreditCardType?: InputMaybe<Scalars['String']>;
  FinePayment?: InputMaybe<Scalars['Boolean']>;
  FinePaymentAmount?: InputMaybe<Scalars['Int']>;
  FinePaymentFrom?: InputMaybe<Scalars['String']>;
  FinePaymentMethod?: InputMaybe<Scalars['String']>;
  FinePaymentby?: InputMaybe<Scalars['String']>;
  InvoiceID?: InputMaybe<Scalars['Int']>;
  LMSResponse?: InputMaybe<Scalars['String']>;
  LMSUpdated?: InputMaybe<Scalars['Boolean']>;
  PaymentGatewayProvider?: InputMaybe<Scalars['String']>;
  PaymentGatewayTranID?: InputMaybe<Scalars['Int']>;
  ResponseCode?: InputMaybe<Scalars['Int']>;
  ResponseDescription?: InputMaybe<Scalars['String']>;
  ResponseStatus?: InputMaybe<Scalars['String']>;
}

export interface GSuiteConfigInput {
  ClientId?: InputMaybe<Scalars['String']>;
  ClientSecret?: InputMaybe<Scalars['String']>;
}

export interface GSuiteConfigSchema {
  ClientId?: Maybe<Scalars['String']>;
  ClientSecret?: Maybe<Scalars['String']>;
}

export interface GetBalanceInput {
  CardNumber: Scalars['String'];
  CustomerId: Scalars['ID'];
  PaymentType: ThingPaymentOption;
  ThingID: Scalars['ID'];
}

export interface GetBalanceResponse {
  Currency?: Maybe<Scalars['String']>;
  Message?: Maybe<Scalars['String']>;
  RemainingAmount?: Maybe<Scalars['String']>;
  StatusCode?: Maybe<Scalars['Int']>;
  TransactionID?: Maybe<Scalars['String']>;
}

export interface Group {
  Access?: Maybe<AccessSchema>;
  AssociatedQuotaBalance?: Maybe<Array<Maybe<Scalars['ID']>>>;
  CreatedBy?: Maybe<Scalars['String']>;
  CustomerData?: Maybe<CustomerDataSchema>;
  CustomerID?: Maybe<Scalars['ID']>;
  DebitBalancePriority?: Maybe<Scalars['Int']>;
  DeletedAt?: Maybe<Scalars['Date']>;
  DeletedBy?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  DeviceData?: Maybe<Array<Maybe<DeviceData>>>;
  DeviceID?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Enabled?: Maybe<Scalars['Boolean']>;
  GroupName?: Maybe<Scalars['String']>;
  GroupType?: Maybe<Scalars['String']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  LMSRules?: Maybe<LmsRulesSchema>;
  Label?: Maybe<Scalars['String']>;
  ModifyPrintJob?: Maybe<Scalars['Boolean']>;
  Policies?: Maybe<PoliciesSchema>;
  PrintConfig?: Maybe<PrintConfigSchema>;
  PrintConfigurationGroupID?: Maybe<Scalars['ID']>;
  PrintGroups?: Maybe<Array<Maybe<PrintGroupsSchema>>>;
  PrintReview?: Maybe<Scalars['Boolean']>;
  PrinterGroups?: Maybe<Scalars['Boolean']>;
  Priority?: Maybe<Scalars['Int']>;
  Quota?: Maybe<QuotaSchema>;
  QuotaBalance?: Maybe<QuotaBalanceSchema>;
  RoleData?: Maybe<RoleData>;
  RoleType?: Maybe<Scalars['String']>;
  RulesID?: Maybe<Array<Maybe<Scalars['String']>>>;
  Tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  UpdatedBy?: Maybe<Scalars['String']>;
  UserID?: Maybe<Array<Maybe<Scalars['String']>>>;
  _id?: Maybe<Scalars['ID']>;
}

export interface GroupAssignmentRulesInput {
  Enabled?: InputMaybe<Scalars['Boolean']>;
  GroupName: Scalars['String'];
  Priority: Scalars['Int'];
  SubGroups?: InputMaybe<Array<InputMaybe<SubGroupInput>>>;
}

export interface GroupAssignmentRulesSchema {
  Enabled?: Maybe<Scalars['Boolean']>;
  GroupName?: Maybe<Scalars['String']>;
  Priority?: Maybe<Scalars['Int']>;
  SubGroups?: Maybe<Array<Maybe<SubGroupSchema>>>;
}

export interface GroupDataSchema {
  DebitBalancePriority?: Maybe<Scalars['Int']>;
  GroupName?: Maybe<Scalars['String']>;
  GroupType?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['ID']>;
}

export interface GroupIdInput {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
}

export interface GroupIdSchema {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
}

export interface GroupInput {
  Access?: InputMaybe<AccessInput>;
  AssociatedQuotaBalance?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  CustomerID?: InputMaybe<Scalars['String']>;
  DebitBalancePriority?: InputMaybe<Scalars['Int']>;
  DeletedAt?: InputMaybe<Scalars['Date']>;
  DeletedBy?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  DeviceID?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  Enabled?: InputMaybe<Scalars['Boolean']>;
  GroupName?: InputMaybe<Scalars['String']>;
  GroupType?: InputMaybe<Scalars['String']>;
  IsActive?: InputMaybe<Scalars['Boolean']>;
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  LMSRules?: InputMaybe<LmsRulesInput>;
  Label?: InputMaybe<Scalars['String']>;
  ModifyPrintJob?: InputMaybe<Scalars['Boolean']>;
  Policies?: InputMaybe<PoliciesInput>;
  PrintConfig?: InputMaybe<PrintConfigInput>;
  PrintConfigurationGroupID?: InputMaybe<Scalars['ID']>;
  PrintGroups?: InputMaybe<Array<InputMaybe<PrintGroupsInput>>>;
  PrintReview?: InputMaybe<Scalars['Boolean']>;
  PrinterGroups?: InputMaybe<Scalars['Boolean']>;
  Priority?: InputMaybe<Scalars['Int']>;
  Quota?: InputMaybe<QuotaInput>;
  QuotaBalance?: InputMaybe<QuotaBalanceInput>;
  RoleType?: InputMaybe<Scalars['String']>;
  RulesID?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  Tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  UserID?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
}

export interface GroupQuotaInput {
  GroupID?: InputMaybe<Scalars['ID']>;
  QuotaBalance?: InputMaybe<Scalars['Float']>;
}

export interface GroupQuotaSchema {
  GroupID?: Maybe<Scalars['ID']>;
  GroupName?: Maybe<Scalars['String']>;
  QuotaBalance?: Maybe<Scalars['Float']>;
}

export interface GroupsResponse {
  group?: Maybe<Array<Maybe<Group>>>;
  total?: Maybe<Scalars['Int']>;
}

export interface GuestInput {
  EmailConfirmationBox?: InputMaybe<Scalars['Boolean']>;
  EmailConfirmationTextBox?: InputMaybe<Scalars['String']>;
  GuestDisplayText?: InputMaybe<Scalars['String']>;
  TextConfirmationBox?: InputMaybe<Scalars['Boolean']>;
  TextConfirmationTextBox?: InputMaybe<Scalars['String']>;
  UserInformationBox?: InputMaybe<Scalars['String']>;
  UserInformationTextBox?: InputMaybe<Scalars['String']>;
}

export interface GuestSchema {
  EmailConfirmationBox?: Maybe<Scalars['Boolean']>;
  EmailConfirmationTextBox?: Maybe<Scalars['String']>;
  GuestDisplayText?: Maybe<Scalars['String']>;
  TextConfirmationBox?: Maybe<Scalars['Boolean']>;
  TextConfirmationTextBox?: Maybe<Scalars['String']>;
  UserInformationBox?: Maybe<Scalars['String']>;
  UserInformationTextBox?: Maybe<Scalars['String']>;
}

export interface HandWriteRecognition {
  AttachOriginalDocument?: Maybe<Scalars['Boolean']>;
  ConfidenceThreshold?: Maybe<Scalars['Int']>;
  CreatedBy?: Maybe<Scalars['String']>;
  CustomerID?: Maybe<Scalars['ID']>;
  CustomerName?: Maybe<Scalars['String']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  Tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  ThirdPartySoftwareName?: Maybe<Scalars['String']>;
  ThirdPartySoftwareType: ThirdPartySoftwareType;
  _id?: Maybe<Scalars['ID']>;
}

export interface HandWriteRecognitionInput {
  AttachOriginalDocument?: InputMaybe<Scalars['Boolean']>;
  ConfidenceThreshold?: InputMaybe<Scalars['Int']>;
  CustomerID: Scalars['ID'];
  IsActive?: InputMaybe<Scalars['Boolean']>;
  Tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ThirdPartySoftwareName: Scalars['String'];
  ThirdPartySoftwareType: ThirdPartySoftwareType;
}

export interface HeartlandHashInput {
  Amount?: InputMaybe<Scalars['Int']>;
  Currency?: InputMaybe<Scalars['String']>;
  CustomerID?: InputMaybe<Scalars['String']>;
  PaymentID?: InputMaybe<Scalars['String']>;
}

export interface HeartlandInput {
  MerchandID?: InputMaybe<Scalars['String']>;
  SharedSecret?: InputMaybe<Scalars['String']>;
}

export interface HeartlandResponse {
  Amount?: Maybe<Scalars['String']>;
  Currency?: Maybe<Scalars['String']>;
  Hash?: Maybe<Scalars['String']>;
  MerchantID?: Maybe<Scalars['String']>;
  Message?: Maybe<Scalars['String']>;
  OrderID?: Maybe<Scalars['String']>;
  StatusCode?: Maybe<Scalars['Int']>;
  Timestamp?: Maybe<Scalars['String']>;
}

export interface HeartlandSchema {
  MerchandID?: Maybe<Scalars['String']>;
  SharedSecret?: Maybe<Scalars['String']>;
}

export interface HowToLogoSection {
  EmailAddressAssignedColor?: Maybe<Scalars['String']>;
  EmailAddressAssignedColorAlias?: Maybe<Scalars['String']>;
  EmailAddressAssignedCustomer?: Maybe<Scalars['String']>;
  EmailAddressAssignedCustomerAlias?: Maybe<Scalars['String']>;
  EmailAddressAssignedGrayscale?: Maybe<Scalars['String']>;
  EmailAddressAssignedGrayscaleAlias?: Maybe<Scalars['String']>;
  PartnerLogo?: Maybe<Scalars['String']>;
  PartnerUrl?: Maybe<Scalars['String']>;
  PartnerUrlText?: Maybe<Scalars['String']>;
  UploadURL?: Maybe<Scalars['String']>;
}

export interface HowToLogoSectionInput {
  EmailAddressAssignedColor?: InputMaybe<Scalars['String']>;
  EmailAddressAssignedColorAlias?: InputMaybe<Scalars['String']>;
  EmailAddressAssignedCustomer?: InputMaybe<Scalars['String']>;
  EmailAddressAssignedCustomerAlias?: InputMaybe<Scalars['String']>;
  EmailAddressAssignedGrayscale?: InputMaybe<Scalars['String']>;
  EmailAddressAssignedGrayscaleAlias?: InputMaybe<Scalars['String']>;
  PartnerLogo?: InputMaybe<Scalars['String']>;
  PartnerUrl?: InputMaybe<Scalars['String']>;
  PartnerUrlText?: InputMaybe<Scalars['String']>;
}

export interface Illiad {
  CreatedBy?: Maybe<Scalars['String']>;
  CustomerID?: Maybe<Scalars['ID']>;
  CustomerName?: Maybe<Scalars['String']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  Password?: Maybe<Scalars['String']>;
  Path?: Maybe<Scalars['String']>;
  Server?: Maybe<Scalars['String']>;
  Tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  ThirdPartySoftwareName?: Maybe<Scalars['String']>;
  ThirdPartySoftwareType: ThirdPartySoftwareType;
  Username?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['ID']>;
}

export interface IlliadInput {
  CustomerID: Scalars['ID'];
  IsActive?: InputMaybe<Scalars['Boolean']>;
  Password?: InputMaybe<Scalars['String']>;
  Path?: InputMaybe<Scalars['String']>;
  Server?: InputMaybe<Scalars['String']>;
  Tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ThirdPartySoftwareName: Scalars['String'];
  ThirdPartySoftwareType: ThirdPartySoftwareType;
  Username?: InputMaybe<Scalars['String']>;
}

export interface InnovativeConfigInput {
  BarCode?: InputMaybe<Scalars['String']>;
  BarCodeLabelText?: InputMaybe<Scalars['String']>;
  ClientId?: InputMaybe<Scalars['String']>;
  ClientSecret?: InputMaybe<Scalars['String']>;
  LoginType?: InputMaybe<Scalars['String']>;
  Password?: InputMaybe<Scalars['String']>;
  Pin?: InputMaybe<Scalars['String']>;
  PinLabelText?: InputMaybe<Scalars['String']>;
  ServerBaseURL?: InputMaybe<Scalars['String']>;
  Username?: InputMaybe<Scalars['String']>;
}

export interface InnovativeConfigSchema {
  BarCode?: Maybe<Scalars['String']>;
  BarCodeLabelText?: Maybe<Scalars['String']>;
  ClientId?: Maybe<Scalars['String']>;
  ClientSecret?: Maybe<Scalars['String']>;
  LoginType?: Maybe<Scalars['String']>;
  Password?: Maybe<Scalars['String']>;
  Pin?: Maybe<Scalars['String']>;
  PinLabelText?: Maybe<Scalars['String']>;
  ServerBaseURL?: Maybe<Scalars['String']>;
  Username?: Maybe<Scalars['String']>;
}

export interface InternalLoginConfigInput {
  PasswordLabel?: InputMaybe<Scalars['String']>;
  UsernameLabel?: InputMaybe<Scalars['String']>;
}

export interface InternalLoginConfigSchema {
  PasswordLabel?: Maybe<Scalars['String']>;
  UsernameLabel?: Maybe<Scalars['String']>;
}

export interface IotRegionDetails {
  CertificateID?: Maybe<Scalars['String']>;
  EncryptedPrivateKey?: Maybe<Scalars['String']>;
  PolicyName?: Maybe<Scalars['String']>;
  ThingArn?: Maybe<Scalars['String']>;
  ThingID?: Maybe<Scalars['String']>;
  ThingName?: Maybe<Scalars['String']>;
}

export interface IppPrintOptionsInput {
  AppFormat?: InputMaybe<Scalars['String']>;
  BaseUrl?: InputMaybe<Scalars['String']>;
  IpAddress?: InputMaybe<Scalars['String']>;
  IppPrint?: InputMaybe<Scalars['Boolean']>;
  IppVersion?: InputMaybe<Scalars['String']>;
  Password?: InputMaybe<Scalars['String']>;
  Port?: InputMaybe<Scalars['Int']>;
  Tls?: InputMaybe<Scalars['Boolean']>;
  Username?: InputMaybe<Scalars['String']>;
}

export interface IppPrintOptionsSchema {
  AppFormat?: Maybe<Scalars['String']>;
  BaseUrl?: Maybe<Scalars['String']>;
  IpAddress?: Maybe<Scalars['String']>;
  IppPrint?: Maybe<Scalars['Boolean']>;
  IppVersion?: Maybe<Scalars['String']>;
  Password?: Maybe<Scalars['String']>;
  Port?: Maybe<Scalars['Int']>;
  PrintSecureUrl?: Maybe<Scalars['String']>;
  PrintUrl?: Maybe<Scalars['String']>;
  PrinterUUID?: Maybe<Scalars['String']>;
  Tls?: Maybe<Scalars['Boolean']>;
  Username?: Maybe<Scalars['String']>;
}

export interface IppSettingsInput {
  AllowedCIDRorIPs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
}

export interface IppSettingsSchema {
  AllowedCIDRorIPs?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export interface IsProcessedFileNameSchema {
  ErrorMessage?: Maybe<Scalars['String']>;
  FileName?: Maybe<Scalars['String']>;
  IsProcessed?: Maybe<Scalars['Boolean']>;
}

export interface IsProcessedFileNameSchemaInput {
  ErrorMessage?: InputMaybe<Scalars['String']>;
  FileName?: InputMaybe<Scalars['String']>;
  IsProcessed?: InputMaybe<Scalars['Boolean']>;
}

export interface JobList {
  ApiKey?: Maybe<Scalars['String']>;
  AutomaticPrintDelivery?: Maybe<Scalars['Boolean']>;
  ChargeForUsage?: Maybe<Scalars['Boolean']>;
  Color?: Maybe<Color>;
  Copies?: Maybe<Copies>;
  CopyEnabled?: Maybe<Scalars['Boolean']>;
  CopyPaperSize?: Maybe<PaperSize>;
  CreatedBy?: Maybe<Scalars['String']>;
  CustomerID?: Maybe<Scalars['String']>;
  DefaultAutomaticDeliveryLocation?: Maybe<Scalars['ID']>;
  DefaultLmsValidateThing?: Maybe<Scalars['ID']>;
  DefaultValues?: Maybe<JobListDefaultValues>;
  DeleteJobAfterPrint?: Maybe<Scalars['Boolean']>;
  DeletedAt?: Maybe<Scalars['Date']>;
  DeletedBy?: Maybe<Scalars['String']>;
  Duplex?: Maybe<Duplex>;
  FileRetainPeriod?: Maybe<Scalars['Int']>;
  MaxPagesLimit?: Maybe<Scalars['Int']>;
  IppSettings?: Maybe<IppSettingsSchema>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  LmsValidate?: Maybe<Scalars['Boolean']>;
  LocationData?: Maybe<LocationDataSchema>;
  Orientation?: Maybe<Orientation>;
  PageRange?: Maybe<PageRange>;
  PaperSize?: Maybe<PaperSize>;
  QrCodeEnabled?: Maybe<Scalars['Boolean']>;
  ScanEnabled?: Maybe<Scalars['Boolean']>;
  ScanPaperSize?: Maybe<PaperSize>;
  Secret?: Maybe<Scalars['String']>;
  Staple?: Maybe<StapleDataSchema>;
  ThingData?: Maybe<ThingDataSchema>;
  ThingID?: Maybe<Scalars['String']>;
  URL?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['ID']>;
}

export interface JobListDefaultValues {
  Color?: Maybe<Scalars['String']>;
  Copies?: Maybe<Scalars['String']>;
  Duplex?: Maybe<Scalars['Boolean']>;
  Orientation?: Maybe<Scalars['String']>;
  PageRange?: Maybe<Scalars['String']>;
  PaperSize?: Maybe<Scalars['String']>;
  Staple?: Maybe<Scalars['String']>;
}

export interface JobListDefaultValuesInput {
  Color?: InputMaybe<ColorType>;
  Copies?: InputMaybe<Scalars['String']>;
  Duplex?: InputMaybe<Scalars['Boolean']>;
  Orientation?: InputMaybe<LayoutType>;
  PageRange?: InputMaybe<Scalars['String']>;
  PaperSize?: InputMaybe<Scalars['String']>;
  Staple?: InputMaybe<Scalars['String']>;
}

export interface JobListFieldSchema {
  App?: Maybe<Scalars['String']>;
  Color?: Maybe<Scalars['String']>;
  Copies?: Maybe<Scalars['Int']>;
  Duplex?: Maybe<Scalars['Boolean']>;
  ErrorMessage?: Maybe<Scalars['String']>;
  IsDeleted: Scalars['Boolean'];
  IsPrinted: Scalars['Boolean'];
  IsProcessed?: Maybe<Scalars['Boolean']>;
  NewFileNameWithExt?: Maybe<Scalars['String']>;
  Orientation?: Maybe<Scalars['String']>;
  OriginalFileNameWithExt?: Maybe<Scalars['String']>;
  PageRange?: Maybe<Scalars['String']>;
  PaperSize?: Maybe<Scalars['String']>;
  Platform?: Maybe<Scalars['String']>;
  PrintCounter?: Maybe<Scalars['Int']>;
  Staple?: Maybe<Scalars['String']>;
  TotalPagesPerFile?: Maybe<Scalars['Float']>;
  UploadStatus?: Maybe<Scalars['Boolean']>;
  UploadedFrom?: Maybe<Scalars['String']>;
}

export interface JobListFieldSchemaInput {
  App?: InputMaybe<Scalars['String']>;
  Color?: InputMaybe<Scalars['String']>;
  Copies?: InputMaybe<Scalars['Int']>;
  Duplex?: InputMaybe<Scalars['Boolean']>;
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  IsPrinted?: InputMaybe<Scalars['Boolean']>;
  NewFileNameWithExt: Scalars['String'];
  Orientation?: InputMaybe<Scalars['String']>;
  OriginalFileNameWithExt?: InputMaybe<Scalars['String']>;
  PageRange?: InputMaybe<Scalars['String']>;
  PaperSize?: InputMaybe<Scalars['String']>;
  Platform?: InputMaybe<Scalars['String']>;
  PrintCounter?: InputMaybe<Scalars['Int']>;
  Staple?: InputMaybe<Scalars['String']>;
  TotalPagesPerFile?: InputMaybe<Scalars['Float']>;
  UploadStatus?: InputMaybe<Scalars['Boolean']>;
  UploadedFrom?: InputMaybe<Scalars['String']>;
}

export interface JobListInput {
  ApiKey?: InputMaybe<Scalars['String']>;
  AutomaticPrintDelivery?: InputMaybe<Scalars['Boolean']>;
  ChargeForUsage?: InputMaybe<Scalars['Boolean']>;
  Color?: InputMaybe<ColorInput>;
  Copies?: InputMaybe<CopiesInput>;
  CopyEnabled?: InputMaybe<Scalars['Boolean']>;
  CopyPaperSize?: InputMaybe<PaperSizeInput>;
  CreatedBy?: InputMaybe<Scalars['String']>;
  CustomerID?: InputMaybe<Scalars['String']>;
  DefaultAutomaticDeliveryLocation?: InputMaybe<Scalars['ID']>;
  DefaultLmsValidateThing?: InputMaybe<Scalars['ID']>;
  DefaultValues?: InputMaybe<JobListDefaultValuesInput>;
  DeleteJobAfterPrint?: InputMaybe<Scalars['Boolean']>;
  DeletedAt?: InputMaybe<Scalars['Date']>;
  DeletedBy?: InputMaybe<Scalars['String']>;
  Duplex?: InputMaybe<DuplexInput>;
  FileRetainPeriod?: InputMaybe<Scalars['Int']>;
  MaxPagesLimit?: InputMaybe<Scalars['Int']>;
  IppSettings?: InputMaybe<IppSettingsInput>;
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  LmsValidate?: InputMaybe<Scalars['Boolean']>;
  Orientation?: InputMaybe<OrientationInput>;
  PageRange?: InputMaybe<PageRangeInput>;
  PaperSize?: InputMaybe<PaperSizeInput>;
  QrCodeEnabled?: InputMaybe<Scalars['Boolean']>;
  ScanEnabled?: InputMaybe<Scalars['Boolean']>;
  ScanPaperSize?: InputMaybe<PaperSizeInput>;
  Secret?: InputMaybe<Scalars['String']>;
  Staple?: InputMaybe<StapleDataInput>;
  ThingID?: InputMaybe<Scalars['String']>;
  URL?: InputMaybe<Scalars['String']>;
  UpdatedBy?: InputMaybe<Scalars['String']>;
}

export interface JobListWorkflowInput {
  JobExpired?: InputMaybe<Scalars['Boolean']>;
  NewFileNameWithExt?: InputMaybe<Scalars['String']>;
  OriginalFileNameWithExt?: InputMaybe<Scalars['String']>;
  Platform?: InputMaybe<Scalars['String']>;
  UploadedFrom?: InputMaybe<Scalars['String']>;
}

export interface JobListWorkflowSchema {
  NewFileNameWithExt?: Maybe<Scalars['String']>;
  OriginalFileNameWithExt?: Maybe<Scalars['String']>;
  Platform?: Maybe<Scalars['String']>;
  UploadedFrom?: Maybe<Scalars['String']>;
}

export interface JobListsResponse {
  jobList?: Maybe<Array<Maybe<JobList>>>;
  total?: Maybe<Scalars['Int']>;
}

export interface Keys {
  ApiKey?: Maybe<Scalars['String']>;
  CreatedAt?: Maybe<Scalars['Date']>;
}

export interface LmsInformationInput {
  LMSBirthday?: InputMaybe<Scalars['Date']>;
  LMSExpiryDate?: InputMaybe<Scalars['Date']>;
  LMSFineAmount?: InputMaybe<Scalars['Int']>;
  LMSOverdueItems?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  LMSPhoneNumber?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  LMSStatusMessages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
}

export interface LmsInformationSchema {
  LMSBirthday?: Maybe<Scalars['Date']>;
  LMSExpiryDate?: Maybe<Scalars['Date']>;
  LMSFineAmount?: Maybe<Scalars['Int']>;
  LMSOverdueItems?: Maybe<Array<Maybe<Scalars['String']>>>;
  LMSPhoneNumber?: Maybe<Array<Maybe<Scalars['String']>>>;
  LMSStatusMessages?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export interface LmsRulesInput {
  Enabled?: InputMaybe<Scalars['Boolean']>;
  EqualTo?: InputMaybe<Scalars['String']>;
  Field?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  NotEqualto?: InputMaybe<Scalars['String']>;
  OlderThan?: InputMaybe<Scalars['Int']>;
  Priority?: InputMaybe<Scalars['Int']>;
  SingleMatch?: InputMaybe<Scalars['Boolean']>;
  SubGroupName?: InputMaybe<Scalars['String']>;
  YoungerThan?: InputMaybe<Scalars['Int']>;
}

export interface LmsRulesSchema {
  Enabled?: Maybe<Scalars['Boolean']>;
  EqualTo?: Maybe<Scalars['String']>;
  Field?: Maybe<Array<Maybe<Scalars['String']>>>;
  NotEqualto?: Maybe<Scalars['String']>;
  OlderThan?: Maybe<Scalars['Int']>;
  Priority?: Maybe<Scalars['Int']>;
  SingleMatch?: Maybe<Scalars['Boolean']>;
  SubGroupName?: Maybe<Scalars['String']>;
  YoungerThan?: Maybe<Scalars['Int']>;
}

export interface Language {
  Separator?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['ID']>;
  currency?: Maybe<Scalars['String']>;
  currencySymbol?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  flagLang?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
}

export interface LayoutDeviceInput {
  LandScape?: InputMaybe<Scalars['Boolean']>;
  Portrait?: InputMaybe<Scalars['Boolean']>;
}

export interface LayoutDeviceSchema {
  LandScape?: Maybe<Scalars['Boolean']>;
  Portrait?: Maybe<Scalars['Boolean']>;
}

export enum LayoutType {
  AsSaved = 'AsSaved',
  Landscape = 'Landscape',
  Portrait = 'Portrait'
}

export interface LdapConfigInput {
  BindCredential?: InputMaybe<Scalars['String']>;
  BindDn?: InputMaybe<Scalars['String']>;
  CaCert?: InputMaybe<Scalars['String']>;
  Host?: InputMaybe<Scalars['String']>;
  LdapBase?: InputMaybe<Scalars['String']>;
  PasswordLabelText?: InputMaybe<Scalars['String']>;
  Port?: InputMaybe<Scalars['String']>;
  PrimaryKey?: InputMaybe<Scalars['String']>;
  Protocol?: InputMaybe<Scalars['String']>;
  UsernameLabelText?: InputMaybe<Scalars['String']>;
}

export interface LdapConfigSchema {
  BindCredential?: Maybe<Scalars['String']>;
  BindDn?: Maybe<Scalars['String']>;
  CaCert?: Maybe<Scalars['String']>;
  Host?: Maybe<Scalars['String']>;
  LdapBase?: Maybe<Scalars['String']>;
  PasswordLabelText?: Maybe<Scalars['String']>;
  Port?: Maybe<Scalars['String']>;
  PrimaryKey?: Maybe<Scalars['String']>;
  Protocol?: Maybe<Scalars['String']>;
  UsernameLabelText?: Maybe<Scalars['String']>;
}

export interface Ledger {
  Enabled?: Maybe<Scalars['Boolean']>;
  Price?: Maybe<Price>;
}

export interface LedgerInput {
  Enabled?: InputMaybe<Scalars['Boolean']>;
  Price?: InputMaybe<PriceInput>;
}

export interface Legal {
  Enabled?: Maybe<Scalars['Boolean']>;
  Price?: Maybe<Price>;
}

export interface LegalInput {
  Enabled?: InputMaybe<Scalars['Boolean']>;
  Price?: InputMaybe<PriceInput>;
}

export interface Letter {
  Enabled?: Maybe<Scalars['Boolean']>;
  Price?: Maybe<Price>;
}

export interface LetterInput {
  Enabled?: InputMaybe<Scalars['Boolean']>;
  Price?: InputMaybe<PriceInput>;
}

export interface License {
  Copiers?: Maybe<Array<Maybe<Scalars['String']>>>;
  CreatedBy?: Maybe<Scalars['String']>;
  CustomerData?: Maybe<CustomerDataSchema>;
  CustomerEmail?: Maybe<Scalars['String']>;
  CustomerID?: Maybe<Scalars['String']>;
  DeletedAt?: Maybe<Scalars['Date']>;
  DeletedBy?: Maybe<Scalars['String']>;
  DevicesLimit?: Maybe<Array<Maybe<DevicesLimit>>>;
  EmailService?: Maybe<Scalars['Boolean']>;
  Envisionware?: Maybe<Scalars['Boolean']>;
  FaxLicenseOption?: Maybe<FaxServiceSchema>;
  FaxService?: Maybe<Scalars['Boolean']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  ItsMyPc?: Maybe<Scalars['Boolean']>;
  OCRLicenseEnabled?: Maybe<Scalars['Boolean']>;
  OrderNumber?: Maybe<Scalars['String']>;
  RegisterDate?: Maybe<Scalars['Date']>;
  RegisteredTo?: Maybe<Scalars['Date']>;
  ThingsLimit?: Maybe<Array<Maybe<ThingsLimit>>>;
  Translation?: Maybe<Scalars['Boolean']>;
  TranslationLicenseOption?: Maybe<TranslationServiceSchema>;
  _id?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
}

export interface LicenseData {
  OrderNumber?: Maybe<Scalars['String']>;
  RegisterDate?: Maybe<Scalars['Date']>;
  RegisteredTo?: Maybe<Scalars['Date']>;
}

export interface LicenseInput {
  Copiers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  CustomerEmail?: InputMaybe<Scalars['String']>;
  CustomerID?: InputMaybe<Scalars['String']>;
  DevicesLimit?: InputMaybe<Array<InputMaybe<DevicesLimitInput>>>;
  EmailService?: InputMaybe<Scalars['Boolean']>;
  Envisionware?: InputMaybe<Scalars['Boolean']>;
  FaxLicenseOption?: InputMaybe<FaxServiceInput>;
  FaxService?: InputMaybe<Scalars['Boolean']>;
  IsActive?: InputMaybe<Scalars['Boolean']>;
  ItsMyPc?: InputMaybe<Scalars['Boolean']>;
  OCRLicenseEnabled?: InputMaybe<Scalars['Boolean']>;
  OrderNumber?: InputMaybe<Scalars['String']>;
  RegisterDate?: InputMaybe<Scalars['String']>;
  RegisteredTo?: InputMaybe<Scalars['String']>;
  ThingsIDs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ThingsLimit?: InputMaybe<Array<InputMaybe<ThingsLimitInput>>>;
  Translation?: InputMaybe<Scalars['Boolean']>;
  TranslationLicenseOption?: InputMaybe<TranslationServiceInput>;
}

export interface LicensesResponse {
  license?: Maybe<Array<Maybe<License>>>;
  total?: Maybe<Scalars['Int']>;
}

export interface Location {
  Address?: Maybe<Scalars['String']>;
  AdvancedEmails?: Maybe<AdvancedEmailAliasSchema>;
  AreaIDs?: Maybe<Array<Maybe<Scalars['String']>>>;
  City?: Maybe<Scalars['String']>;
  Coordinates?: Maybe<Array<Maybe<Scalars['Float']>>>;
  CreatedBy?: Maybe<Scalars['String']>;
  CurrencyCode?: Maybe<Scalars['String']>;
  CustomerData?: Maybe<CustomerDataSchema>;
  CustomerID?: Maybe<Scalars['String']>;
  Customization?: Maybe<Array<Maybe<Scalars['String']>>>;
  Description?: Maybe<Scalars['String']>;
  Geolocation?: Maybe<Scalars['String']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  Label?: Maybe<Scalars['String']>;
  Latitude?: Maybe<Scalars['Float']>;
  Location?: Maybe<Scalars['String']>;
  Longitude?: Maybe<Scalars['Float']>;
  Rule?: Maybe<RuleSchema>;
  Searchable?: Maybe<Scalars['Boolean']>;
  ShortName?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['String']>;
  Tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  TimeZone?: Maybe<Scalars['String']>;
  Zip?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['ID']>;
  openTimesLocationFormatted?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export interface LocationDataSchema {
  Location?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['ID']>;
}

export interface LocationHoursSection {
  LocationHourTitle?: Maybe<Scalars['String']>;
  LocationHoursSectionDescription?: Maybe<Scalars['String']>;
  LocationList?: Maybe<Scalars['Boolean']>;
  LocationSelectionRequired?: Maybe<Scalars['Boolean']>;
  OpenHoursVisibility?: Maybe<Scalars['Boolean']>;
  Title?: Maybe<Scalars['String']>;
}

export interface LocationHoursSectionInput {
  LocationHourTitle?: InputMaybe<Scalars['String']>;
  LocationHoursSectionDescription?: InputMaybe<Scalars['String']>;
  LocationList?: InputMaybe<Scalars['Boolean']>;
  LocationSelectionRequired?: InputMaybe<Scalars['Boolean']>;
  OpenHoursVisibility?: InputMaybe<Scalars['Boolean']>;
  Title?: InputMaybe<Scalars['String']>;
}

export interface LocationInput {
  Address?: InputMaybe<Scalars['String']>;
  AdvancedEmails?: InputMaybe<AdvancedEmailAliasInput>;
  AreaIDs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  City?: InputMaybe<Scalars['String']>;
  CurrencyCode?: InputMaybe<Scalars['String']>;
  CustomerID?: InputMaybe<Scalars['String']>;
  Customization?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  DeletedAt?: InputMaybe<Scalars['Date']>;
  Description?: InputMaybe<Scalars['String']>;
  Geolocation?: InputMaybe<Scalars['String']>;
  IsActive?: InputMaybe<Scalars['Boolean']>;
  Label?: InputMaybe<Scalars['String']>;
  Latitude?: InputMaybe<Scalars['Float']>;
  Location?: InputMaybe<Scalars['String']>;
  Longitude?: InputMaybe<Scalars['Float']>;
  Rule?: InputMaybe<RuleInput>;
  Searchable?: InputMaybe<Scalars['Boolean']>;
  ShortName?: InputMaybe<Scalars['String']>;
  State?: InputMaybe<Scalars['String']>;
  Tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  TimeZone?: InputMaybe<Scalars['String']>;
  UpdatedBy?: InputMaybe<Scalars['String']>;
  Zip?: InputMaybe<Scalars['String']>;
}

export interface LocationsResponse {
  location?: Maybe<Array<Maybe<Location>>>;
  total?: Maybe<Scalars['Int']>;
}

export interface LoggingInput {
  Action?: InputMaybe<Scalars['String']>;
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  UpdatedBy?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
}

export interface LoggingSchema {
  Action?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['String']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  _id?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['String']>;
}

export interface LoggingsResponse {
  logging?: Maybe<Array<Maybe<LoggingSchema>>>;
  total?: Maybe<Scalars['Int']>;
}

export interface LoginInput {
  Domain?: InputMaybe<Scalars['String']>;
  LoginOption?: InputMaybe<Scalars['String']>;
  Password?: InputMaybe<Scalars['String']>;
  Username?: InputMaybe<Scalars['String']>;
}

export enum LoginOptionsEnum {
  CardNumber = 'CardNumber',
  GuestName = 'Guest_Name',
  LoginFromIdentityProviders = 'Login_from_Identity_Providers',
  Pin = 'Pin',
  ReleaseCode = 'Release_Code',
  Username = 'Username'
}

export interface LoginOptionsInput {
  ExternalCardIdp?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  ExternalCardValidation?: InputMaybe<Scalars['Boolean']>;
  LoginLabelText?: InputMaybe<Scalars['String']>;
  LoginOptionType?: InputMaybe<LoginOptionsEnum>;
}

export interface LoginOptionsSchema {
  ExternalCardIdp?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ExternalCardValidation?: Maybe<Scalars['Boolean']>;
  LoginLabelText?: Maybe<Scalars['String']>;
  LoginOptionType?: Maybe<LoginOptionsEnum>;
}

export interface LoginSchema {
  Domain?: Maybe<Scalars['String']>;
  LoginOption?: Maybe<Scalars['String']>;
  Password?: Maybe<Scalars['String']>;
  Username?: Maybe<Scalars['String']>;
}

export enum LoginTypePolaris {
  BarcodeOnly = 'BarcodeOnly',
  BarcodeWithPin = 'BarcodeWithPin'
}

export enum LoginTypeSip2 {
  BarcodeOnly = 'BarcodeOnly',
  BarcodeWithPin = 'BarcodeWithPin'
}

export interface LogoAttributes {
  contentType: Scalars['String'];
  customerId: Scalars['ID'];
  extension: Scalars['String'];
  logoType: Scalars['String'];
}

export interface LogoMobile {
  Logo?: Maybe<Scalars['String']>;
  Url?: Maybe<Scalars['String']>;
}

export interface LogoMobileInput {
  Logo?: InputMaybe<Scalars['String']>;
  Url?: InputMaybe<Scalars['String']>;
}

export interface MainCustomerData {
  CustomerName?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  DisplayName?: Maybe<Scalars['String']>;
}

export interface MainSection {
  Description?: Maybe<DescriptionSchema>;
  TopSection?: Maybe<TopSectionSchema>;
}

export interface MainSectionInput {
  Description?: InputMaybe<DescriptionInput>;
  TopSection?: InputMaybe<TopSectionInput>;
}

export interface Mapping {
  AccountID?: Maybe<Scalars['String']>;
  AccountName?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
}

export interface MappingInput {
  AccountID: Scalars['String'];
  AccountName?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
}

export interface MappingsInput {
  Account?: InputMaybe<Scalars['String']>;
  CardNumber: Scalars['String'];
  FirstName: Scalars['String'];
  GroupName: Scalars['String'];
  LastName: Scalars['String'];
  Mobile: Scalars['String'];
  PrimaryEmail: Scalars['String'];
  Username: Scalars['String'];
}

export interface MappingsSchema {
  Account?: Maybe<Scalars['String']>;
  CardNumber?: Maybe<Scalars['String']>;
  FirstName?: Maybe<Scalars['String']>;
  GroupName?: Maybe<Scalars['String']>;
  LastName?: Maybe<Scalars['String']>;
  Mobile?: Maybe<Scalars['String']>;
  PrimaryEmail?: Maybe<Scalars['String']>;
  Username?: Maybe<Scalars['String']>;
}

export interface MessageInput {
  MessageID?: InputMaybe<Scalars['String']>;
}

export interface MessageSchema {
  MessageID?: Maybe<Scalars['String']>;
}

export interface MobileConfigurationInput {
  AccountOnly?: InputMaybe<Scalars['Boolean']>;
  AccountOnlyLock?: InputMaybe<Scalars['Boolean']>;
  CloudStorage?: InputMaybe<CloudStorageInput>;
  CloudStorageToggle?: InputMaybe<Scalars['Boolean']>;
  DisableNewAccount?: InputMaybe<Scalars['Boolean']>;
  EmailOption?: InputMaybe<Scalars['Boolean']>;
  FileOption?: InputMaybe<Scalars['Boolean']>;
  LocationConfiguration?: InputMaybe<Scalars['ID']>;
  LockLocationChange?: InputMaybe<Scalars['Boolean']>;
  LoginInstructions?: InputMaybe<Scalars['String']>;
  LoginRequired?: InputMaybe<Scalars['Boolean']>;
  MultipleLocationConfiguration?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  PictureOption?: InputMaybe<Scalars['Boolean']>;
  QRScanning?: InputMaybe<Scalars['Boolean']>;
}

export interface MobileConfigurationSchema {
  AccountOnly?: Maybe<Scalars['Boolean']>;
  AccountOnlyLock?: Maybe<Scalars['Boolean']>;
  CloudStorage?: Maybe<CloudStorageSchema>;
  CloudStorageToggle?: Maybe<Scalars['Boolean']>;
  DisableNewAccount?: Maybe<Scalars['Boolean']>;
  EmailOption?: Maybe<Scalars['Boolean']>;
  FileOption?: Maybe<Scalars['Boolean']>;
  LocationConfiguration?: Maybe<LocationDataSchema>;
  LockLocationChange?: Maybe<Scalars['Boolean']>;
  LoginInstructions?: Maybe<Scalars['String']>;
  LoginRequired?: Maybe<Scalars['Boolean']>;
  MultipleLocationConfiguration?: Maybe<Array<Maybe<LocationDataSchema>>>;
  PictureOption?: Maybe<Scalars['Boolean']>;
  QRScanning?: Maybe<Scalars['Boolean']>;
}

export interface MonerisCheckoutInput {
  CustomerID?: InputMaybe<Scalars['String']>;
  Image?: InputMaybe<Scalars['String']>;
  PaymentID?: InputMaybe<Scalars['String']>;
  Price?: InputMaybe<Scalars['Float']>;
  ProductName?: InputMaybe<Scalars['String']>;
}

export interface MonerisInput {
  ApiToken?: InputMaybe<Scalars['String']>;
  CheckoutId?: InputMaybe<Scalars['String']>;
  StoreId?: InputMaybe<Scalars['String']>;
}

export interface MonerisResponse {
  Message?: Maybe<Scalars['String']>;
  StatusCode?: Maybe<Scalars['Int']>;
  Ticket?: Maybe<Scalars['String']>;
}

export interface MonerisSchema {
  ApiToken?: Maybe<Scalars['String']>;
  CheckoutId?: Maybe<Scalars['String']>;
  StoreId?: Maybe<Scalars['String']>;
}

export interface Mutation {
  _empty?: Maybe<Scalars['String']>;
  accountSyncStatus?: Maybe<Response>;
  addAbby?: Maybe<Abby>;
  addAccount?: Maybe<Account>;
  addAccountSync?: Maybe<AccountSync>;
  addArea?: Maybe<Area>;
  /** Add Audit logs API to store errors for printing, quota balance updates, quota reset, and conversion errors */
  addAuditLogs?: Maybe<AuditLogs>;
  addAuthProvider?: Maybe<AuthProvider>;
  addCustomizationText?: Maybe<CustomizationText>;
  addDevice?: Maybe<Device>;
  addEmail?: Maybe<Email>;
  addFTP?: Maybe<Ftp>;
  addFax?: Maybe<Fax>;
  addFaxIntegration?: Maybe<FaxIntegration>;
  addGroup?: Maybe<Group>;
  addHandWriteRecognition?: Maybe<HandWriteRecognition>;
  addIlliad?: Maybe<Illiad>;
  addLocation?: Maybe<Location>;
  addLogging?: Maybe<LoggingSchema>;
  addNetwork?: Maybe<Network>;
  addPartner?: Maybe<Partner>;
  addPaymentConfiguration?: Maybe<Payment>;
  addPermission?: Maybe<Permission>;
  addProfile?: Maybe<Profile>;
  addProton?: Maybe<Proton>;
  addPublicUpload?: Maybe<PublicUpload>;
  addRestorePictures?: Maybe<RestorePictures>;
  addRole?: Maybe<Role>;
  addSetting?: Maybe<Setting>;
  addSmartphone?: Maybe<Smartphone>;
  addThing?: Maybe<Thing>;
  addUsage?: Maybe<Usage>;
  addUser?: Maybe<Response>;
  addValidator?: Maybe<Validator>;
  addVersion?: Maybe<Version>;
  adminChangePassword?: Maybe<Response>;
  approvedSignup?: Maybe<Response>;
  areaDeleted?: Maybe<Response>;
  areaStatus?: Maybe<Response>;
  authProviderDeleted?: Maybe<Response>;
  authProviderStatus?: Maybe<Response>;
  changePassword?: Maybe<Response>;
  confirmFileUpload?: Maybe<ConfirmFileUploadSchema>;
  confirmFileUploadV2?: Maybe<ConfirmFileUploadV2Response>;
  customerDeleted?: Maybe<Response>;
  customerStatus?: Maybe<Response>;
  customizationDeleted?: Maybe<Response>;
  customizationStatus?: Maybe<Response>;
  customizationTextDeleted?: Maybe<Response>;
  customizationTextStatus?: Maybe<Response>;
  deleteAbby?: Maybe<Response>;
  deleteAccount?: Maybe<Response>;
  deleteAccountSync?: Maybe<Response>;
  deleteFTP?: Maybe<Response>;
  deleteFaxIntegration?: Maybe<Response>;
  deleteFile?: Maybe<Response>;
  deleteHandWriteRecognition?: Maybe<Response>;
  deleteIlliad?: Maybe<Response>;
  deleteNetwork?: Maybe<Response>;
  deleteRestorePictures?: Maybe<Response>;
  deviceDeleted?: Maybe<Response>;
  deviceStatus?: Maybe<Response>;
  emailDeleted?: Maybe<Response>;
  emailService?: Maybe<Response>;
  emailStatus?: Maybe<Response>;
  faxDeleted?: Maybe<Response>;
  faxStatus?: Maybe<Response>;
  generateEmail?: Maybe<AdvancedEmailSupportSchema>;
  generateEmailForLocation?: Maybe<Response>;
  groupDeleted?: Maybe<Response>;
  groupStatus?: Maybe<Response>;
  ippJobStatus?: Maybe<Response>;
  jobListDeleted?: Maybe<Response>;
  jobListStatus?: Maybe<Response>;
  /** API to delete license */
  licenseDeleted?: Maybe<Response>;
  /** API to make the license status as active or inactive */
  licenseStatus?: Maybe<Response>;
  locationDeleted?: Maybe<Response>;
  locationStatus?: Maybe<Response>;
  loggingDeleted?: Maybe<Response>;
  loggingStatus?: Maybe<Response>;
  networkStatus?: Maybe<Response>;
  onboardCustomer?: Maybe<OnboardCustomerResponse>;
  partnerDeleted?: Maybe<Response>;
  partnerStatus?: Maybe<Response>;
  paymentConfigurationDeleted?: Maybe<Response>;
  paymentConfigurationStatus?: Maybe<Response>;
  processPayment?: Maybe<Response>;
  profileDeleted?: Maybe<Response>;
  profileStatus?: Maybe<Response>;
  protonDeleted?: Maybe<Response>;
  protonStatus?: Maybe<Response>;
  requestChangePassword?: Maybe<Response>;
  /** Reset quota balances of the users based on the parameters */
  resetQuotaBalance?: Maybe<Response>;
  roleDeleted?: Maybe<Response>;
  roleStatus?: Maybe<Response>;
  saveIppPrinterAttributes?: Maybe<Response>;
  sendSrFaxRequest?: Maybe<Response>;
  settingDeleted?: Maybe<Response>;
  settingStatus?: Maybe<Response>;
  signedUrl?: Maybe<File>;
  smartphoneDeleted?: Maybe<Response>;
  smartphoneStatus?: Maybe<Response>;
  thingDeleted?: Maybe<Response>;
  thingStatus?: Maybe<Response>;
  updateAbby?: Maybe<Response>;
  updateAbbyStatus?: Maybe<Response>;
  updateAccount?: Maybe<Response>;
  updateAccountStatus?: Maybe<Response>;
  updateAccountSync?: Maybe<Response>;
  updateArea?: Maybe<Response>;
  updateAuthProvider?: Maybe<Response>;
  updateCustomer?: Maybe<Response>;
  updateCustomization?: Maybe<Customization>;
  updateCustomizationText?: Maybe<Response>;
  updateDevice?: Maybe<Response>;
  updateEmail?: Maybe<Response>;
  updateFTP?: Maybe<Response>;
  updateFTPStatus?: Maybe<Response>;
  updateFax?: Maybe<Response>;
  updateFaxIntegration?: Maybe<Response>;
  updateFaxIntegrationStatus?: Maybe<Response>;
  updateGroup?: Maybe<Response>;
  updateHandWriteRecognition?: Maybe<Response>;
  updateHandWriteRecognitionStatus?: Maybe<Response>;
  updateIlliad?: Maybe<Response>;
  updateIlliadStatus?: Maybe<Response>;
  updateJobList?: Maybe<Response>;
  /** API to update license */
  updateLicense?: Maybe<Response>;
  updateLocation?: Maybe<Response>;
  updateLogging?: Maybe<Response>;
  updateNetwork?: Maybe<Response>;
  updatePartner?: Maybe<Response>;
  updatePaymentConfiguration?: Maybe<Response>;
  updateProfile?: Maybe<Response>;
  updateProton?: Maybe<Response>;
  updatePublicUpload?: Maybe<Response>;
  updateRestorePictures?: Maybe<Response>;
  updateRestorePicturesStatus?: Maybe<Response>;
  updateRole?: Maybe<Response>;
  updateSetting?: Maybe<Response>;
  updateSmartphone?: Maybe<Response>;
  updateThing?: Maybe<Response>;
  updateUser?: Maybe<Response>;
  updateUserBalance?: Maybe<Response>;
  updateUserV2?: Maybe<Response>;
  updateValidator?: Maybe<Response>;
  updateVersion?: Maybe<Response>;
  uploadMultipleFiles?: Maybe<FileResponse>;
  uploadVersion?: Maybe<UploadVersionSchema>;
  userDeleted?: Maybe<Response>;
  validateCardNumber?: Maybe<UserSession>;
  validateCardNumberPin?: Maybe<UserSession>;
  validatorDeleted?: Maybe<Response>;
  validatorStatus?: Maybe<Response>;
  versionDeleted?: Maybe<Response>;
}


export interface MutationAccountSyncStatusArgs {
  IsActive?: InputMaybe<Scalars['Boolean']>;
  customerId: Scalars['ID'];
}


export interface MutationAddAbbyArgs {
  addAbbyInput?: InputMaybe<AbbyInput>;
}


export interface MutationAddAccountArgs {
  addAccountInput?: InputMaybe<AccountInput>;
}


export interface MutationAddAccountSyncArgs {
  addAccountSyncInput?: InputMaybe<AccountSyncInput>;
}


export interface MutationAddAreaArgs {
  addAreaInput?: InputMaybe<AreaInput>;
}


export interface MutationAddAuditLogsArgs {
  addAuditLogInput?: InputMaybe<AuditLogsInput>;
}


export interface MutationAddAuthProviderArgs {
  addAuthProviderInput?: InputMaybe<AuthProviderInput>;
}


export interface MutationAddCustomizationTextArgs {
  addCustomizationTextInput?: InputMaybe<CustomizationTextInput>;
}


export interface MutationAddDeviceArgs {
  addDeviceInput?: InputMaybe<DeviceInput>;
}


export interface MutationAddEmailArgs {
  addEmailInput?: InputMaybe<EmailInput>;
}


export interface MutationAddFtpArgs {
  addFTPInput?: InputMaybe<FtpInput>;
}


export interface MutationAddFaxArgs {
  addFaxInput?: InputMaybe<FaxInput>;
}


export interface MutationAddFaxIntegrationArgs {
  addFaxIntegrationInput?: InputMaybe<FaxIntegrationInput>;
}


export interface MutationAddGroupArgs {
  addGroupInput?: InputMaybe<GroupInput>;
}


export interface MutationAddHandWriteRecognitionArgs {
  addHandWriteRecognitionInput?: InputMaybe<HandWriteRecognitionInput>;
}


export interface MutationAddIlliadArgs {
  addIlliadInput?: InputMaybe<IlliadInput>;
}


export interface MutationAddLocationArgs {
  addLocationInput?: InputMaybe<LocationInput>;
}


export interface MutationAddLoggingArgs {
  addLoggingInput?: InputMaybe<LoggingInput>;
}


export interface MutationAddNetworkArgs {
  addNetworkInput?: InputMaybe<NetworkInput>;
}


export interface MutationAddPartnerArgs {
  addPartnerInput?: InputMaybe<PartnerInput>;
}


export interface MutationAddPaymentConfigurationArgs {
  addPaymentInput?: InputMaybe<PaymentInput>;
}


export interface MutationAddPermissionArgs {
  addPermissionInput?: InputMaybe<PermissionInput>;
}


export interface MutationAddProfileArgs {
  addProfileInput?: InputMaybe<ProfileInput>;
}


export interface MutationAddProtonArgs {
  addProtonInput?: InputMaybe<ProtonInput>;
}


export interface MutationAddPublicUploadArgs {
  addPublicUploadInput?: InputMaybe<PublicUploadInput>;
}


export interface MutationAddRestorePicturesArgs {
  addRestorePicturesInput?: InputMaybe<RestorePicturesInput>;
}


export interface MutationAddRoleArgs {
  addRoleInput?: InputMaybe<RoleInput>;
}


export interface MutationAddSettingArgs {
  addSettingInput?: InputMaybe<SettingInput>;
}


export interface MutationAddSmartphoneArgs {
  addSmartphoneInput?: InputMaybe<SmartphoneInput>;
}


export interface MutationAddThingArgs {
  addThingInput?: InputMaybe<ThingInput>;
}


export interface MutationAddUsageArgs {
  addUsageInput?: InputMaybe<UsageInput>;
}


export interface MutationAddUserArgs {
  addUserInput?: InputMaybe<UserInput>;
}


export interface MutationAddValidatorArgs {
  addValidatorInput?: InputMaybe<ValidatorInput>;
}


export interface MutationAddVersionArgs {
  addVersionInput?: InputMaybe<VersionInput>;
}


export interface MutationAdminChangePasswordArgs {
  adminChangePasswordInput?: InputMaybe<AdminPasswordInput>;
  customerId?: InputMaybe<Scalars['ID']>;
  userId: Scalars['ID'];
}


export interface MutationApprovedSignupArgs {
  CustomerID?: InputMaybe<Scalars['ID']>;
  approvedSignupInput?: InputMaybe<ApprovedCustomer>;
}


export interface MutationAreaDeletedArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  areaId?: InputMaybe<Scalars['ID']>;
  customerId?: InputMaybe<Scalars['ID']>;
}


export interface MutationAreaStatusArgs {
  IsActive?: InputMaybe<Scalars['Boolean']>;
  areaId?: InputMaybe<Scalars['ID']>;
  customerId?: InputMaybe<Scalars['ID']>;
}


export interface MutationAuthProviderDeletedArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  authProviderId?: InputMaybe<Scalars['ID']>;
  customerId?: InputMaybe<Scalars['ID']>;
}


export interface MutationAuthProviderStatusArgs {
  IsActive?: InputMaybe<Scalars['Boolean']>;
  authProviderId?: InputMaybe<Scalars['ID']>;
  customerId?: InputMaybe<Scalars['ID']>;
}


export interface MutationChangePasswordArgs {
  changePasswordInput?: InputMaybe<PasswordInput>;
  customerId?: InputMaybe<Scalars['ID']>;
}


export interface MutationConfirmFileUploadArgs {
  confirmFileUploadData?: InputMaybe<ConfirmFileUpload>;
  customerId?: InputMaybe<Scalars['ID']>;
  recordId?: InputMaybe<Scalars['ID']>;
}


export interface MutationConfirmFileUploadV2Args {
  confirmFileUploadData?: InputMaybe<ConfirmFileUploadV2Input>;
  customerId?: InputMaybe<Scalars['ID']>;
  recordId?: InputMaybe<Scalars['ID']>;
}


export interface MutationCustomerDeletedArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ID']>;
}


export interface MutationCustomerStatusArgs {
  IsActive?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ID']>;
}


export interface MutationCustomizationDeletedArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ID']>;
  customizationId?: InputMaybe<Scalars['ID']>;
}


export interface MutationCustomizationStatusArgs {
  IsActive?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ID']>;
  customizationId?: InputMaybe<Scalars['ID']>;
}


export interface MutationCustomizationTextDeletedArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ID']>;
  customizationTextId?: InputMaybe<Scalars['ID']>;
}


export interface MutationCustomizationTextStatusArgs {
  IsActive?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ID']>;
  customizationTextId?: InputMaybe<Scalars['ID']>;
}


export interface MutationDeleteAbbyArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerId: Scalars['ID'];
}


export interface MutationDeleteAccountArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  accountId?: InputMaybe<Scalars['ID']>;
}


export interface MutationDeleteAccountSyncArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerId: Scalars['ID'];
}


export interface MutationDeleteFtpArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerId: Scalars['ID'];
}


export interface MutationDeleteFaxIntegrationArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerId: Scalars['ID'];
}


export interface MutationDeleteFileArgs {
  DeleteFilesInput?: InputMaybe<DeleteInfo>;
}


export interface MutationDeleteHandWriteRecognitionArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerId: Scalars['ID'];
}


export interface MutationDeleteIlliadArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerId: Scalars['ID'];
}


export interface MutationDeleteNetworkArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerId: Scalars['ID'];
}


export interface MutationDeleteRestorePicturesArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerId: Scalars['ID'];
}


export interface MutationDeviceDeletedArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ID']>;
  deviceId?: InputMaybe<Scalars['ID']>;
}


export interface MutationDeviceStatusArgs {
  IsActive?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ID']>;
  deviceId?: InputMaybe<Scalars['ID']>;
}


export interface MutationEmailDeletedArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerId: Scalars['ID'];
}


export interface MutationEmailServiceArgs {
  customerId?: InputMaybe<Scalars['ID']>;
  emailBody?: InputMaybe<EmailBodyInput>;
  serviceName?: InputMaybe<ServiceType>;
}


export interface MutationEmailStatusArgs {
  IsActive?: InputMaybe<Scalars['Boolean']>;
  customerId: Scalars['ID'];
}


export interface MutationFaxDeletedArgs {
  FaxId?: InputMaybe<Scalars['ID']>;
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ID']>;
}


export interface MutationFaxStatusArgs {
  FaxId?: InputMaybe<Scalars['ID']>;
  IsActive?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ID']>;
}


export interface MutationGenerateEmailArgs {
  combination?: InputMaybe<AdvanceEmailOptions>;
  customerId?: InputMaybe<Scalars['String']>;
}


export interface MutationGenerateEmailForLocationArgs {
  combination: AdvanceEmailOptions;
  customerId: Scalars['ID'];
  locationId: Scalars['ID'];
}


export interface MutationGroupDeletedArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ID']>;
  groupId?: InputMaybe<Scalars['ID']>;
}


export interface MutationGroupStatusArgs {
  IsActive?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ID']>;
  groupId?: InputMaybe<Scalars['ID']>;
}


export interface MutationIppJobStatusArgs {
  customerId?: InputMaybe<Scalars['ID']>;
  message?: InputMaybe<Scalars['String']>;
  releaseCode?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
}


export interface MutationJobListDeletedArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ID']>;
  jobListId?: InputMaybe<Scalars['ID']>;
}


export interface MutationJobListStatusArgs {
  IsActive?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ID']>;
  jobListId?: InputMaybe<Scalars['ID']>;
}


export interface MutationLicenseDeletedArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ID']>;
  licenseId?: InputMaybe<Scalars['ID']>;
}


export interface MutationLicenseStatusArgs {
  IsActive?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ID']>;
  licenseId?: InputMaybe<Scalars['ID']>;
}


export interface MutationLocationDeletedArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ID']>;
  locationId?: InputMaybe<Scalars['ID']>;
}


export interface MutationLocationStatusArgs {
  IsActive?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ID']>;
  locationId?: InputMaybe<Scalars['ID']>;
}


export interface MutationLoggingDeletedArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  loggingId?: InputMaybe<Scalars['ID']>;
}


export interface MutationLoggingStatusArgs {
  IsActive?: InputMaybe<Scalars['Boolean']>;
  loggingId?: InputMaybe<Scalars['ID']>;
}


export interface MutationNetworkStatusArgs {
  IsActive?: InputMaybe<Scalars['Boolean']>;
  customerId: Scalars['ID'];
}


export interface MutationOnboardCustomerArgs {
  OnboardCustomerInput?: InputMaybe<OnboardCustomer>;
}


export interface MutationPartnerDeletedArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
}


export interface MutationPartnerStatusArgs {
  IsActive?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
}


export interface MutationPaymentConfigurationDeletedArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ID']>;
  paymentId?: InputMaybe<Scalars['ID']>;
}


export interface MutationPaymentConfigurationStatusArgs {
  IsActive?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ID']>;
  paymentId?: InputMaybe<Scalars['ID']>;
}


export interface MutationProcessPaymentArgs {
  customerId?: InputMaybe<Scalars['ID']>;
  paymentId?: InputMaybe<Scalars['ID']>;
  transactionInput?: InputMaybe<TransactionInput>;
}


export interface MutationProfileDeletedArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ID']>;
  profileId?: InputMaybe<Scalars['ID']>;
}


export interface MutationProfileStatusArgs {
  IsActive?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ID']>;
  profileId?: InputMaybe<Scalars['ID']>;
}


export interface MutationProtonDeletedArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerId: Scalars['ID'];
}


export interface MutationProtonStatusArgs {
  IsActive?: InputMaybe<Scalars['Boolean']>;
  customerId: Scalars['ID'];
}


export interface MutationRequestChangePasswordArgs {
  customerId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
}


export interface MutationResetQuotaBalanceArgs {
  amount?: InputMaybe<Scalars['Float']>;
  customerId?: InputMaybe<Scalars['ID']>;
  groupId?: InputMaybe<Scalars['ID']>;
}


export interface MutationRoleDeletedArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ID']>;
  roleId?: InputMaybe<Scalars['ID']>;
}


export interface MutationRoleStatusArgs {
  IsActive?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ID']>;
  roleId?: InputMaybe<Scalars['ID']>;
}


export interface MutationSaveIppPrinterAttributesArgs {
  attributes: Scalars['String'];
  customerId: Scalars['ID'];
  deviceId: Scalars['ID'];
}


export interface MutationSendSrFaxRequestArgs {
  customerId?: InputMaybe<Scalars['ID']>;
  domainName?: InputMaybe<Scalars['String']>;
  faxBody?: InputMaybe<FaxRequestInput>;
}


export interface MutationSettingDeletedArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  settingId?: InputMaybe<Scalars['ID']>;
}


export interface MutationSettingStatusArgs {
  IsActive?: InputMaybe<Scalars['Boolean']>;
  settingId?: InputMaybe<Scalars['ID']>;
}


export interface MutationSignedUrlArgs {
  fileInput?: InputMaybe<FileInput>;
}


export interface MutationSmartphoneDeletedArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerId: Scalars['ID'];
}


export interface MutationSmartphoneStatusArgs {
  IsActive?: InputMaybe<Scalars['Boolean']>;
  customerId: Scalars['ID'];
}


export interface MutationThingDeletedArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ID']>;
  thingId?: InputMaybe<Scalars['ID']>;
}


export interface MutationThingStatusArgs {
  IsActive?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ID']>;
  thingId?: InputMaybe<Scalars['ID']>;
}


export interface MutationUpdateAbbyArgs {
  customerId: Scalars['ID'];
  updateAbbyInput?: InputMaybe<AbbyInput>;
}


export interface MutationUpdateAbbyStatusArgs {
  IsActive?: InputMaybe<Scalars['Boolean']>;
  customerId: Scalars['ID'];
}


export interface MutationUpdateAccountArgs {
  accountId: Scalars['ID'];
  updateAccountInput?: InputMaybe<AccountInput>;
}


export interface MutationUpdateAccountStatusArgs {
  IsActive?: InputMaybe<Scalars['Boolean']>;
  accountId?: InputMaybe<Scalars['ID']>;
}


export interface MutationUpdateAccountSyncArgs {
  customerId: Scalars['ID'];
  updateAccountSyncInput?: InputMaybe<AccountSyncInput>;
}


export interface MutationUpdateAreaArgs {
  areaId: Scalars['ID'];
  updateAreaInput?: InputMaybe<AreaInput>;
}


export interface MutationUpdateAuthProviderArgs {
  authProviderId: Scalars['ID'];
  customerId?: InputMaybe<Scalars['ID']>;
  updateAuthProviderInput?: InputMaybe<AuthProviderInput>;
}


export interface MutationUpdateCustomerArgs {
  CustomerID: Scalars['ID'];
  updateCustomerInput?: InputMaybe<CustomerInput>;
}


export interface MutationUpdateCustomizationArgs {
  customerId?: InputMaybe<Scalars['String']>;
  updateCustomizationInput?: InputMaybe<CustomizationInput>;
}


export interface MutationUpdateCustomizationTextArgs {
  customerId?: InputMaybe<Scalars['String']>;
  customizationTextId?: InputMaybe<Scalars['String']>;
  updateCustomizationTextInput?: InputMaybe<CustomizationTextInput>;
}


export interface MutationUpdateDeviceArgs {
  deviceId: Scalars['ID'];
  updateDeviceInput?: InputMaybe<DeviceInput>;
}


export interface MutationUpdateEmailArgs {
  customerId: Scalars['ID'];
  updateEmailInput?: InputMaybe<EmailInput>;
}


export interface MutationUpdateFtpArgs {
  customerId: Scalars['ID'];
  updateFTPInput?: InputMaybe<FtpInput>;
}


export interface MutationUpdateFtpStatusArgs {
  IsActive?: InputMaybe<Scalars['Boolean']>;
  customerId: Scalars['ID'];
}


export interface MutationUpdateFaxArgs {
  FaxId: Scalars['ID'];
  updateFaxInput?: InputMaybe<FaxInput>;
}


export interface MutationUpdateFaxIntegrationArgs {
  customerId: Scalars['ID'];
  updateFaxIntegrationInput?: InputMaybe<FaxIntegrationInput>;
}


export interface MutationUpdateFaxIntegrationStatusArgs {
  IsActive?: InputMaybe<Scalars['Boolean']>;
  customerId: Scalars['ID'];
}


export interface MutationUpdateGroupArgs {
  groupId: Scalars['ID'];
  updateGroupInput?: InputMaybe<GroupInput>;
}


export interface MutationUpdateHandWriteRecognitionArgs {
  customerId: Scalars['ID'];
  updateHandWriteRecognitionInput?: InputMaybe<HandWriteRecognitionInput>;
}


export interface MutationUpdateHandWriteRecognitionStatusArgs {
  IsActive?: InputMaybe<Scalars['Boolean']>;
  customerId: Scalars['ID'];
}


export interface MutationUpdateIlliadArgs {
  customerId: Scalars['ID'];
  updateIlliadInput?: InputMaybe<IlliadInput>;
}


export interface MutationUpdateIlliadStatusArgs {
  IsActive?: InputMaybe<Scalars['Boolean']>;
  customerId: Scalars['ID'];
}


export interface MutationUpdateJobListArgs {
  jobListId: Scalars['ID'];
  updateJobListInput?: InputMaybe<JobListInput>;
}


export interface MutationUpdateLicenseArgs {
  licenseId: Scalars['ID'];
  updateLicenseInput?: InputMaybe<LicenseInput>;
}


export interface MutationUpdateLocationArgs {
  locationId: Scalars['ID'];
  updateLocationInput?: InputMaybe<LocationInput>;
}


export interface MutationUpdateLoggingArgs {
  loggingId: Scalars['ID'];
  updateLoggingInput?: InputMaybe<LoggingInput>;
}


export interface MutationUpdateNetworkArgs {
  customerId: Scalars['ID'];
  updateNetworkInput?: InputMaybe<NetworkInput>;
}


export interface MutationUpdatePartnerArgs {
  partnerId: Scalars['ID'];
  updatePartnerInput?: InputMaybe<PartnerInput>;
}


export interface MutationUpdatePaymentConfigurationArgs {
  customerId?: InputMaybe<Scalars['ID']>;
  paymentId: Scalars['ID'];
  updatePaymentInput?: InputMaybe<PaymentInput>;
}


export interface MutationUpdateProfileArgs {
  customerId?: InputMaybe<Scalars['ID']>;
  profileId: Scalars['ID'];
  updateProfileInput?: InputMaybe<ProfileInput>;
}


export interface MutationUpdateProtonArgs {
  customerId: Scalars['ID'];
  updateProtonInput?: InputMaybe<ProtonInput>;
}


export interface MutationUpdatePublicUploadArgs {
  updatePublicUploadInput?: InputMaybe<PublicUploadInput>;
  uploadId: Scalars['ID'];
}


export interface MutationUpdateRestorePicturesArgs {
  customerId: Scalars['ID'];
  updateRestorePicturesInput?: InputMaybe<RestorePicturesInput>;
}


export interface MutationUpdateRestorePicturesStatusArgs {
  IsActive?: InputMaybe<Scalars['Boolean']>;
  customerId: Scalars['ID'];
}


export interface MutationUpdateRoleArgs {
  roleId: Scalars['ID'];
  updateRoleInput?: InputMaybe<RoleInput>;
}


export interface MutationUpdateSettingArgs {
  settingId: Scalars['ID'];
  updateSettingInput?: InputMaybe<SettingInput>;
}


export interface MutationUpdateSmartphoneArgs {
  customerId: Scalars['ID'];
  updateSmartphoneInput?: InputMaybe<SmartphoneInput>;
}


export interface MutationUpdateThingArgs {
  thingId: Scalars['ID'];
  updateThingInput?: InputMaybe<ThingInput>;
}


export interface MutationUpdateUserArgs {
  authId?: InputMaybe<Scalars['ID']>;
  updateUserInput?: InputMaybe<UpdateInput>;
  userId: Scalars['ID'];
}


export interface MutationUpdateUserBalanceArgs {
  updateBalance?: InputMaybe<UpdateBalanceUserInput>;
}


export interface MutationUpdateUserV2Args {
  authId?: InputMaybe<Scalars['ID']>;
  updateUserInput?: InputMaybe<UpdateInputV2>;
  userId: Scalars['ID'];
}


export interface MutationUpdateValidatorArgs {
  updateValidatorInput?: InputMaybe<ValidatorInput>;
  validatorId: Scalars['ID'];
}


export interface MutationUpdateVersionArgs {
  updateVersionInput?: InputMaybe<VersionInput>;
  versionId: Scalars['ID'];
}


export interface MutationUploadMultipleFilesArgs {
  customerId?: InputMaybe<Scalars['ID']>;
  fileInput?: InputMaybe<Array<InputMaybe<FileMetaData>>>;
  path?: InputMaybe<ServiceName>;
}


export interface MutationUploadVersionArgs {
  versionUploadInput?: InputMaybe<VersionAttributes>;
}


export interface MutationUserDeletedArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
}


export interface MutationValidateCardNumberArgs {
  cardNumber?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['ID']>;
}


export interface MutationValidateCardNumberPinArgs {
  cardNumber: Scalars['String'];
  customerId: Scalars['ID'];
  pin: Scalars['String'];
}


export interface MutationValidatorDeletedArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  validatorId?: InputMaybe<Scalars['ID']>;
}


export interface MutationValidatorStatusArgs {
  IsActive?: InputMaybe<Scalars['Boolean']>;
  validatorId?: InputMaybe<Scalars['ID']>;
}


export interface MutationVersionDeletedArgs {
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ID']>;
  versionId?: InputMaybe<Scalars['ID']>;
}

export interface NayaxCheckoutInput {
  Amount?: InputMaybe<Scalars['Float']>;
  CustomerID: Scalars['String'];
  Device?: InputMaybe<Scalars['String']>;
  TerminalID?: InputMaybe<Scalars['String']>;
}

export interface NayaxCheckoutResponse {
  Message?: Maybe<Scalars['String']>;
  StatusCode?: Maybe<Scalars['Int']>;
  TransactionID?: Maybe<Scalars['String']>;
}

export interface Network {
  CreatedBy?: Maybe<Scalars['String']>;
  CustomerID?: Maybe<Scalars['ID']>;
  CustomerName?: Maybe<Scalars['String']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  Password?: Maybe<Scalars['String']>;
  Path?: Maybe<Scalars['String']>;
  Server?: Maybe<Scalars['String']>;
  Tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  ThirdPartySoftwareName?: Maybe<Scalars['String']>;
  ThirdPartySoftwareType?: Maybe<ThirdPartySoftwareType>;
  Username?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['ID']>;
}

export interface NetworkInput {
  CustomerID: Scalars['ID'];
  IsActive?: InputMaybe<Scalars['Boolean']>;
  Password?: InputMaybe<Scalars['String']>;
  Path?: InputMaybe<Scalars['String']>;
  Server?: InputMaybe<Scalars['String']>;
  Tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ThirdPartySoftwareName: Scalars['String'];
  ThirdPartySoftwareType: ThirdPartySoftwareType;
  Username?: InputMaybe<Scalars['String']>;
}

export interface NotificationInput {
  Email?: InputMaybe<Scalars['String']>;
  Text?: InputMaybe<Scalars['String']>;
}

export interface NotificationSchema {
  Email?: Maybe<Scalars['String']>;
  Text?: Maybe<Scalars['String']>;
}

export interface OnboardCustomer {
  CustomerData?: InputMaybe<CustomerInput>;
  CustomizationData?: InputMaybe<CustomizationInput>;
  CustomizationTextData?: InputMaybe<CustomizationTextInput>;
  GroupData?: InputMaybe<GroupInput>;
  JobListData?: InputMaybe<JobListInput>;
  LicenseData?: InputMaybe<LicenseInput>;
  LocationData?: InputMaybe<LocationInput>;
  UserData?: InputMaybe<OnboardUserInput>;
}

export interface OnboardCustomerResponse {
  customerId?: Maybe<Scalars['String']>;
  customizationTextId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  statusCode?: Maybe<Scalars['Int']>;
}

export interface OnboardUserInput {
  ApiKey?: InputMaybe<Scalars['String']>;
  ApprovedUser?: InputMaybe<Scalars['Boolean']>;
  Balance?: InputMaybe<BalanceInputUser>;
  BarcodeNumber?: InputMaybe<Scalars['Int']>;
  CardNumber?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  CustomerID?: InputMaybe<Scalars['String']>;
  DeletedAt?: InputMaybe<Scalars['Date']>;
  DeletedBy?: InputMaybe<Scalars['String']>;
  EbBlocked?: InputMaybe<EbBlockedInput>;
  EbExpiryDate?: InputMaybe<Scalars['Date']>;
  Email?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  FirstName?: InputMaybe<Scalars['String']>;
  FullName?: InputMaybe<Scalars['String']>;
  GroupID?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  GroupOverride?: InputMaybe<Scalars['String']>;
  IsActive?: InputMaybe<Scalars['Boolean']>;
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  LMSInformation?: InputMaybe<LmsInformationInput>;
  Label?: InputMaybe<Scalars['String']>;
  LastName?: InputMaybe<Scalars['String']>;
  Mfa?: InputMaybe<Scalars['Boolean']>;
  MfaOption?: InputMaybe<OptionsMfa>;
  Mobile?: InputMaybe<Scalars['String']>;
  Notes?: InputMaybe<Scalars['String']>;
  PIN?: InputMaybe<Scalars['String']>;
  Password?: InputMaybe<Scalars['String']>;
  PhoneNumber?: InputMaybe<Scalars['String']>;
  PrimaryEmail?: InputMaybe<Scalars['String']>;
  Tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  TenantDomain?: InputMaybe<Scalars['String']>;
  Tier?: InputMaybe<Scalars['String']>;
  UpdatedBy?: InputMaybe<Scalars['String']>;
  UserRole?: InputMaybe<Scalars['String']>;
  UserType?: InputMaybe<Scalars['String']>;
  Username?: InputMaybe<Scalars['String']>;
}

export interface OpenIdConfigInput {
  AcrValues?: InputMaybe<Scalars['String']>;
  AdditionalScope?: InputMaybe<Scalars['String']>;
  Authn?: InputMaybe<Scalars['String']>;
  Authz?: InputMaybe<Scalars['String']>;
  BaseUrl?: InputMaybe<Scalars['String']>;
  CallbackPath?: InputMaybe<Scalars['String']>;
  ClientID?: InputMaybe<Scalars['String']>;
  ClientSecret?: InputMaybe<Scalars['String']>;
  CustomAuthorizationEndpoint?: InputMaybe<Scalars['String']>;
  DiscoveryDocument?: InputMaybe<Scalars['String']>;
  Display?: InputMaybe<DisplayEnum>;
  Distribution?: InputMaybe<Scalars['String']>;
  GrantType?: InputMaybe<Scalars['String']>;
  MaxAge?: InputMaybe<Scalars['Int']>;
  NonceEnabled?: InputMaybe<Scalars['Boolean']>;
  PrivateKey?: InputMaybe<Scalars['String']>;
  Prompt?: InputMaybe<Array<InputMaybe<PromptEnum>>>;
  PublicKey?: InputMaybe<Scalars['String']>;
  RedirectUri?: InputMaybe<Scalars['String']>;
  ResponseType?: InputMaybe<Scalars['String']>;
  Scope?: InputMaybe<Scalars['String']>;
  SessionDuration?: InputMaybe<Scalars['String']>;
}

export interface OpenIdConfigSchema {
  AcrValues?: Maybe<Scalars['String']>;
  AdditionalScope?: Maybe<Scalars['String']>;
  Authn?: Maybe<Scalars['String']>;
  Authz?: Maybe<Scalars['String']>;
  BaseUrl?: Maybe<Scalars['String']>;
  CallbackPath?: Maybe<Scalars['String']>;
  ClientID?: Maybe<Scalars['String']>;
  ClientSecret?: Maybe<Scalars['String']>;
  CustomAuthorizationEndpoint?: Maybe<Scalars['String']>;
  DiscoveryDocument?: Maybe<Scalars['String']>;
  Display?: Maybe<DisplayEnum>;
  Distribution?: Maybe<Scalars['String']>;
  GrantType?: Maybe<Scalars['String']>;
  MaxAge?: Maybe<Scalars['Int']>;
  NonceEnabled?: Maybe<Scalars['Boolean']>;
  PrivateKey?: Maybe<Scalars['String']>;
  Prompt?: Maybe<Array<Maybe<PromptEnum>>>;
  PublicKey?: Maybe<Scalars['String']>;
  RedirectUri?: Maybe<Scalars['String']>;
  ResponseType?: Maybe<Scalars['String']>;
  Scope?: Maybe<Scalars['String']>;
  SessionDuration?: Maybe<Scalars['String']>;
}

export interface OpenTimesInput {
  DayHours?: InputMaybe<Array<InputMaybe<DayHoursInput>>>;
  Description?: InputMaybe<Scalars['String']>;
  Label?: InputMaybe<Scalars['String']>;
  OpenTimeName?: InputMaybe<Scalars['String']>;
  Tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
}

export interface OpenTimesSchema {
  DayHours?: Maybe<Array<Maybe<DayHoursSchema>>>;
  Description?: Maybe<Scalars['String']>;
  Label?: Maybe<Scalars['String']>;
  OpenTimeName?: Maybe<Scalars['String']>;
  Tags?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export interface OptionsMfa {
  Email?: InputMaybe<Scalars['Boolean']>;
  Mobile?: InputMaybe<Scalars['Boolean']>;
}

export interface OptionsMfaSchema {
  Email?: Maybe<Scalars['Boolean']>;
  Mobile?: Maybe<Scalars['Boolean']>;
}

export interface Orientation {
  AsSaved?: Maybe<Scalars['Boolean']>;
  Enabled?: Maybe<Scalars['Boolean']>;
  Landscape?: Maybe<Scalars['Boolean']>;
  Portrait?: Maybe<Scalars['Boolean']>;
}

export interface OrientationInput {
  AsSaved?: InputMaybe<Scalars['Boolean']>;
  Enabled?: InputMaybe<Scalars['Boolean']>;
  Landscape?: InputMaybe<Scalars['Boolean']>;
  Portrait?: InputMaybe<Scalars['Boolean']>;
}

export interface OverRideInput {
  DefaultToOverRide?: InputMaybe<Scalars['Boolean']>;
  OverRideCharge?: InputMaybe<Scalars['Boolean']>;
  PromptOverRide?: InputMaybe<Scalars['Boolean']>;
}

export interface OverRideSchema {
  DefaultToOverRide?: Maybe<Scalars['Boolean']>;
  OverRideCharge?: Maybe<Scalars['Boolean']>;
  PromptOverRide?: Maybe<Scalars['Boolean']>;
}

export interface PageRange {
  Enabled?: Maybe<Scalars['Boolean']>;
  Limit?: Maybe<Scalars['Int']>;
}

export interface PageRangeInput {
  Enabled?: InputMaybe<Scalars['Boolean']>;
  Limit?: InputMaybe<Scalars['Int']>;
}

export interface PaginationData {
  authProviderType?: InputMaybe<Array<InputMaybe<AuthProviderOptions>>>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  pattern?: InputMaybe<Scalars['String']>;
  searchKey?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  sortKey?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
}

export interface PaperSize {
  A3?: Maybe<A3>;
  A4?: Maybe<A4>;
  AdditionalPaperSize?: Maybe<Array<Maybe<AddPaperSize>>>;
  AsSaved?: Maybe<Scalars['Boolean']>;
  Enabled?: Maybe<Scalars['Boolean']>;
  Ledger?: Maybe<Ledger>;
  Legal?: Maybe<Legal>;
  Letter?: Maybe<Letter>;
  Tabloid?: Maybe<Tabloid>;
}

export interface PaperSizeInput {
  A3?: InputMaybe<A3Input>;
  A4?: InputMaybe<A4Input>;
  AdditionalPaperSize?: InputMaybe<Array<InputMaybe<AddPaperSizeInput>>>;
  AsSaved?: InputMaybe<Scalars['Boolean']>;
  Enabled?: InputMaybe<Scalars['Boolean']>;
  Ledger?: InputMaybe<LedgerInput>;
  Legal?: InputMaybe<LegalInput>;
  Letter?: InputMaybe<LetterInput>;
  Tabloid?: InputMaybe<TabloidInput>;
}

export enum PaperSizeType {
  A3 = 'A3',
  A4 = 'A4',
  AsSaved = 'AsSaved',
  Ledger = 'Ledger',
  Legal = 'Legal',
  Letter = 'Letter',
  Tabloid = 'Tabloid'
}

export interface PaperSizes {
  Height?: Maybe<Scalars['Int']>;
  PaperName?: Maybe<Scalars['String']>;
  Value?: Maybe<Scalars['Int']>;
  Width?: Maybe<Scalars['Int']>;
  _id?: Maybe<Scalars['ID']>;
}

export interface PaperSizesDeviceInput {
  A3?: InputMaybe<Scalars['Boolean']>;
  A4?: InputMaybe<Scalars['Boolean']>;
  Ledger?: InputMaybe<Scalars['Boolean']>;
  Legal?: InputMaybe<Scalars['Boolean']>;
  Letter?: InputMaybe<Scalars['Boolean']>;
  Tabloid?: InputMaybe<Scalars['Boolean']>;
}

export interface PaperSizesDeviceSchema {
  A3?: Maybe<Scalars['Boolean']>;
  A4?: Maybe<Scalars['Boolean']>;
  Ledger?: Maybe<Scalars['Boolean']>;
  Legal?: Maybe<Scalars['Boolean']>;
  Letter?: Maybe<Scalars['Boolean']>;
  Tabloid?: Maybe<Scalars['Boolean']>;
}

export interface IppPrintOptionsDeviceShem {
  IpAddress?: Maybe<Scalars['String']>;
  IppPrint?: Maybe<Scalars['Boolean']>;
  Password?: Maybe<Scalars['String']>;
  Port?: Maybe<Scalars['String']>;
  Tls?: Maybe<Scalars['Boolean']>;
  Username?: Maybe<Scalars['String']>;
}

export interface ParentChildPermission {
  ChildPerms?: Maybe<Array<Maybe<CustomPermission>>>;
  PermissionName?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['ID']>;
}

export interface Partner {
  ApiKey?: Maybe<Scalars['String']>;
  CreatedAt?: Maybe<Scalars['Date']>;
  CustomerID?: Maybe<Scalars['ID']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  Read?: Maybe<Scalars['Boolean']>;
  Secret?: Maybe<Scalars['String']>;
  Write?: Maybe<Scalars['Boolean']>;
  _id?: Maybe<Scalars['ID']>;
}

export interface PartnerInput {
  CustomerID?: InputMaybe<Scalars['ID']>;
  IsActive?: InputMaybe<Scalars['Boolean']>;
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  Read?: InputMaybe<Scalars['Boolean']>;
  Write?: InputMaybe<Scalars['Boolean']>;
}

export interface PartnerRes {
  CustomerID?: Maybe<Scalars['ID']>;
  CustomerName?: Maybe<Scalars['String']>;
  Keys?: Maybe<Array<Maybe<Keys>>>;
}

export interface PartnersResponse {
  partner?: Maybe<Array<Maybe<PartnerRes>>>;
  total?: Maybe<Scalars['Int']>;
}

export interface PasswordInput {
  Password: Scalars['String'];
  Username?: InputMaybe<Scalars['String']>;
  newPassword: Scalars['String'];
}

export interface Pay88Input {
  Endpoint?: InputMaybe<Scalars['String']>;
  MerchantCode?: InputMaybe<Scalars['String']>;
  PaymentId?: InputMaybe<Scalars['String']>;
  ProdDesc?: InputMaybe<Scalars['String']>;
  ResponseUrlPrefix?: InputMaybe<Scalars['String']>;
  SecretKey?: InputMaybe<Scalars['String']>;
}

export interface Pay88Response {
  Amount?: Maybe<Scalars['String']>;
  ApprovalURL?: Maybe<Scalars['String']>;
  BackendURL?: Maybe<Scalars['String']>;
  Currency?: Maybe<Scalars['String']>;
  Lang?: Maybe<Scalars['String']>;
  MerchantCode?: Maybe<Scalars['String']>;
  Message?: Maybe<Scalars['String']>;
  PaymentId?: Maybe<Scalars['String']>;
  ProdDesc?: Maybe<Scalars['String']>;
  RefNo?: Maybe<Scalars['String']>;
  ResponseURL?: Maybe<Scalars['String']>;
  Signature?: Maybe<Scalars['String']>;
  StatusCode?: Maybe<Scalars['Int']>;
  UnApprovalURL?: Maybe<Scalars['String']>;
  UserEmail?: Maybe<Scalars['String']>;
  UserName?: Maybe<Scalars['String']>;
}

export interface Pay88Schema {
  Endpoint?: Maybe<Scalars['String']>;
  MerchantCode?: Maybe<Scalars['String']>;
  PaymentId?: Maybe<Scalars['ID']>;
  PaymentName?: Maybe<Scalars['String']>;
  ProdDesc?: Maybe<Scalars['String']>;
  ResponseUrlPrefix?: Maybe<Scalars['String']>;
  SecretKey?: Maybe<Scalars['String']>;
}

export interface Payment {
  AuthorizeNet?: Maybe<AuthorizeNetSchema>;
  Braintree?: Maybe<BraintreeSchema>;
  CreatedBy?: Maybe<Scalars['String']>;
  CustomerData?: Maybe<CustomerDataSchema>;
  CustomerID?: Maybe<Scalars['String']>;
  DeletedAt?: Maybe<Scalars['Date']>;
  DeletedBy?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  Enabled?: Maybe<Scalars['String']>;
  Heartland?: Maybe<HeartlandSchema>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  Moneris?: Maybe<MonerisSchema>;
  Pay88?: Maybe<Pay88Schema>;
  PaymentName?: Maybe<Scalars['String']>;
  PaymentType: Scalars['String'];
  Paytm?: Maybe<PaytmSchema>;
  Stripe?: Maybe<StripeSchema>;
  Tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  UpdatedBy?: Maybe<Scalars['String']>;
  Xendit?: Maybe<XenditSchema>;
  _id?: Maybe<Scalars['ID']>;
  eGHL?: Maybe<EGhlSchema>;
}

export interface PaymentByInput {
  Account?: InputMaybe<Scalars['Float']>;
  CBORD?: InputMaybe<Scalars['Float']>;
  Cash?: InputMaybe<Scalars['Float']>;
  CreditCard?: InputMaybe<Scalars['Float']>;
}

export interface PaymentBySchema {
  Account?: Maybe<Scalars['Float']>;
  CBORD?: Maybe<Scalars['Float']>;
  Cash?: Maybe<Scalars['Float']>;
  CreditCard?: Maybe<Scalars['Float']>;
}

export enum PaymentCategories {
  Quota = 'quota',
  Real = 'real',
  Realtime = 'realtime'
}

export interface PaymentInput {
  AuthorizeNet?: InputMaybe<AuthorizeNetInput>;
  Braintree?: InputMaybe<BraintreeInput>;
  CreatedBy?: InputMaybe<Scalars['String']>;
  CustomerID?: InputMaybe<Scalars['String']>;
  DeletedAt?: InputMaybe<Scalars['Date']>;
  DeletedBy?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  Enabled?: InputMaybe<Scalars['String']>;
  Heartland?: InputMaybe<HeartlandInput>;
  IsActive?: InputMaybe<Scalars['Boolean']>;
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  Moneris?: InputMaybe<MonerisInput>;
  Pay88?: InputMaybe<Pay88Input>;
  PaymentName?: InputMaybe<Scalars['String']>;
  PaymentType?: InputMaybe<Scalars['String']>;
  Paytm?: InputMaybe<PaytmInput>;
  Stripe?: InputMaybe<StripeInput>;
  Tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  UpdatedBy?: InputMaybe<Scalars['String']>;
  Xendit?: InputMaybe<XenditInput>;
  eGHL?: InputMaybe<EGhlInput>;
}

export interface PaymentOptionsThings {
  AccountMode?: Maybe<Scalars['String']>;
  AccountNumber?: Maybe<Scalars['Int']>;
  AtriumEndpoint?: Maybe<Scalars['String']>;
  Class?: Maybe<Scalars['String']>;
  CodeAccountType?: Maybe<Scalars['String']>;
  Location?: Maybe<Scalars['String']>;
  MediaEntry?: Maybe<Scalars['String']>;
  MessageBox?: Maybe<Scalars['String']>;
  PaymentOptionType?: Maybe<ThingPaymentOption>;
  PortNumber?: Maybe<Scalars['Int']>;
  Provider?: Maybe<Scalars['String']>;
  TerminalID?: Maybe<Scalars['String']>;
  Timer?: Maybe<Scalars['Int']>;
  URL?: Maybe<Scalars['String']>;
  VendMode?: Maybe<Scalars['Boolean']>;
}

export interface PaymentOptionsThingsInput {
  AccountMode?: InputMaybe<Scalars['String']>;
  AccountNumber?: InputMaybe<Scalars['Int']>;
  AtriumEndpoint?: InputMaybe<Scalars['String']>;
  Class?: InputMaybe<Scalars['String']>;
  CodeAccountType?: InputMaybe<Scalars['String']>;
  Location?: InputMaybe<Scalars['String']>;
  MediaEntry?: InputMaybe<Scalars['String']>;
  MessageBox?: InputMaybe<Scalars['String']>;
  PaymentOptionType?: InputMaybe<ThingPaymentOption>;
  PortNumber?: InputMaybe<Scalars['Int']>;
  Provider?: InputMaybe<Scalars['String']>;
  TerminalID?: InputMaybe<Scalars['String']>;
  Timer?: InputMaybe<Scalars['Int']>;
  URL?: InputMaybe<Scalars['String']>;
  VendMode?: InputMaybe<Scalars['Boolean']>;
}

export interface PaymentsResponse {
  payment?: Maybe<Array<Maybe<Payment>>>;
  total?: Maybe<Scalars['Int']>;
}

export interface PaytmInput {
  PaymentName?: InputMaybe<Scalars['String']>;
  QrCodeUrl?: InputMaybe<Scalars['String']>;
  TransactionStatusUrl?: InputMaybe<Scalars['String']>;
}

export interface PaytmSchema {
  PaymentName?: Maybe<Scalars['String']>;
  QrCodeUrl?: Maybe<Scalars['String']>;
  TransactionStatusUrl?: Maybe<Scalars['String']>;
}

export interface Permission {
  CreatedAt?: Maybe<Scalars['Date']>;
  CreatedBy?: Maybe<Scalars['String']>;
  CustomerLevel?: Maybe<Scalars['Boolean']>;
  InnerParent?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  Order?: Maybe<Scalars['Int']>;
  ParentPermission?: Maybe<Scalars['Boolean']>;
  PermissionCategoryId?: Maybe<Scalars['String']>;
  PermissionMenuID?: Maybe<Scalars['String']>;
  PermissionName?: Maybe<Scalars['String']>;
  ProductLevel?: Maybe<Scalars['String']>;
  RootLevel?: Maybe<Scalars['Boolean']>;
  UpdatedBy?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['ID']>;
}

export interface PermissionInput {
  Add?: InputMaybe<Scalars['Boolean']>;
  CreatedAt?: InputMaybe<Scalars['Date']>;
  CreatedBy?: InputMaybe<Scalars['String']>;
  CustomerLevel?: InputMaybe<Scalars['Boolean']>;
  InnerParent?: InputMaybe<Scalars['Boolean']>;
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  List?: InputMaybe<Scalars['Boolean']>;
  Order?: InputMaybe<Scalars['Int']>;
  ParentPermission?: InputMaybe<Scalars['Boolean']>;
  PermissionCategoryId?: InputMaybe<Scalars['String']>;
  PermissionMenuID?: InputMaybe<Scalars['String']>;
  PermissionName?: InputMaybe<Scalars['String']>;
  ProductLevel?: InputMaybe<Scalars['String']>;
  RootLevel?: InputMaybe<Scalars['Boolean']>;
  UpdatedBy?: InputMaybe<Scalars['String']>;
}

export interface PermissionSchema {
  CustomerLevel?: Maybe<Scalars['Boolean']>;
  InnerParent?: Maybe<Scalars['Boolean']>;
  ParentPermission?: Maybe<Scalars['Boolean']>;
  PermissionCategoryId?: Maybe<Scalars['String']>;
  PermissionMenuID?: Maybe<Scalars['String']>;
  PermissionName?: Maybe<Scalars['String']>;
  ProductLevel?: Maybe<Scalars['String']>;
  RootLevel?: Maybe<Scalars['Boolean']>;
  _id?: Maybe<Scalars['ID']>;
  child?: Maybe<Array<Maybe<ChildPermissionSchema>>>;
}

export interface PolarisConfigInput {
  BarCodeLabelText?: InputMaybe<Scalars['String']>;
  Domain?: InputMaybe<Scalars['String']>;
  Host: Scalars['String'];
  LoginType: LoginTypePolaris;
  PAPIAccessId: Scalars['String'];
  PAPIAccessKey: Scalars['String'];
  Password?: InputMaybe<Scalars['String']>;
  PinLabelText?: InputMaybe<Scalars['String']>;
  Username?: InputMaybe<Scalars['String']>;
}

export interface PolarisConfigSchema {
  BarCodeLabelText?: Maybe<Scalars['String']>;
  Domain?: Maybe<Scalars['String']>;
  Host?: Maybe<Scalars['String']>;
  LoginType?: Maybe<LoginTypePolaris>;
  PAPIAccessId?: Maybe<Scalars['String']>;
  PAPIAccessKey?: Maybe<Scalars['String']>;
  Password?: Maybe<Scalars['String']>;
  PinLabelText?: Maybe<Scalars['String']>;
  Username?: Maybe<Scalars['String']>;
}

export interface PoliciesInput {
  FutureDaysAdvance?: InputMaybe<Scalars['Int']>;
  MaxNumberSessionsPerWeek?: InputMaybe<Scalars['Int']>;
  MaxOutstandingBookings?: InputMaybe<Scalars['Int']>;
  MaxOutstandingTime?: InputMaybe<Scalars['Int']>;
  MaxSessionsPerday?: InputMaybe<Scalars['Int']>;
  MaxTimePerDay?: InputMaybe<Scalars['Int']>;
  MaxTimePerWeek?: InputMaybe<Scalars['Int']>;
}

export interface PoliciesSchema {
  FutureDaysAdvance?: Maybe<Scalars['Int']>;
  MaxNumberSessionsPerWeek?: Maybe<Scalars['Int']>;
  MaxOutstandingBookings?: Maybe<Scalars['Int']>;
  MaxOutstandingTime?: Maybe<Scalars['Int']>;
  MaxSessionsPerday?: Maybe<Scalars['Int']>;
  MaxTimePerDay?: Maybe<Scalars['Int']>;
  MaxTimePerWeek?: Maybe<Scalars['Int']>;
}

export interface Price {
  Color?: Maybe<Scalars['Float']>;
  ColorDuplex?: Maybe<Scalars['Float']>;
  Grayscale?: Maybe<Scalars['Float']>;
  GrayscaleDuplex?: Maybe<Scalars['Float']>;
}

export interface PriceInput {
  Color?: InputMaybe<Scalars['Float']>;
  ColorDuplex?: InputMaybe<Scalars['Float']>;
  Grayscale?: InputMaybe<Scalars['Float']>;
  GrayscaleDuplex?: InputMaybe<Scalars['Float']>;
}

export interface Print {
  ColorCost?: Maybe<Scalars['Float']>;
  ColorPages?: Maybe<Scalars['Int']>;
  ColorType?: Maybe<Scalars['String']>;
  Copies?: Maybe<Scalars['Int']>;
  Device?: Maybe<Scalars['String']>;
  DeviceID?: Maybe<Scalars['String']>;
  DocumentName?: Maybe<Scalars['String']>;
  DocumentSize?: Maybe<Scalars['Int']>;
  Duplex?: Maybe<Scalars['Boolean']>;
  GrayscaleCost?: Maybe<Scalars['Float']>;
  GrayscalePages?: Maybe<Scalars['Int']>;
  JobComment?: Maybe<Scalars['String']>;
  JobDeliveryMethod?: Maybe<Scalars['String']>;
  JobPrinted?: Maybe<Scalars['Boolean']>;
  JobPrintedBy?: Maybe<Scalars['String']>;
  JobPrintedFrom?: Maybe<Scalars['String']>;
  JobType?: Maybe<Scalars['String']>;
  Orientation?: Maybe<Scalars['String']>;
  PaperSize?: Maybe<Scalars['String']>;
  PaymentBy?: Maybe<PaymentBySchema>;
  PaymentCategory?: Maybe<PaymentCategories>;
  PaymentType?: Maybe<Scalars['String']>;
  PrintCancelled?: Maybe<Scalars['Boolean']>;
  PrintJobSubmitted?: Maybe<Scalars['Date']>;
  ReasonCancelled?: Maybe<Scalars['String']>;
  ReleaseCode?: Maybe<Scalars['String']>;
  Staple?: Maybe<Scalars['String']>;
  SystemFileName?: Maybe<Scalars['String']>;
  TotalCost?: Maybe<Scalars['Float']>;
  TotalPages?: Maybe<Scalars['Int']>;
}

export interface PrintConfigInput {
  ComputerName?: InputMaybe<Scalars['Boolean']>;
  Cost?: InputMaybe<Scalars['Boolean']>;
  Email?: InputMaybe<Scalars['Boolean']>;
  GuestName?: InputMaybe<Scalars['Boolean']>;
  MaskFileNames?: InputMaybe<Scalars['Boolean']>;
  ReleaseCode?: InputMaybe<Scalars['Boolean']>;
  Username?: InputMaybe<Scalars['Boolean']>;
}

export interface PrintConfigSchema {
  ComputerName?: Maybe<Scalars['Boolean']>;
  Cost?: Maybe<Scalars['Boolean']>;
  Email?: Maybe<Scalars['Boolean']>;
  GuestName?: Maybe<Scalars['Boolean']>;
  MaskFileNames?: Maybe<Scalars['Boolean']>;
  ReleaseCode?: Maybe<Scalars['Boolean']>;
  Username?: Maybe<Scalars['Boolean']>;
}

export interface PrintGroupsInput {
  DeviceId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  Enabled?: InputMaybe<Scalars['Boolean']>;
  OverRideSettings?: InputMaybe<OverRideInput>;
  PrinterGroupName?: InputMaybe<Scalars['String']>;
  _id?: InputMaybe<Scalars['ID']>;
}

export interface PrintGroupsSchema {
  DeviceId?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Enabled?: Maybe<Scalars['Boolean']>;
  OverRideSettings?: Maybe<OverRideSchema>;
  PrinterGroupName?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['ID']>;
}

export interface PrintInput {
  ColorCost?: InputMaybe<Scalars['Float']>;
  ColorPages?: InputMaybe<Scalars['Int']>;
  ColorType?: InputMaybe<Scalars['String']>;
  Copies?: InputMaybe<Scalars['Int']>;
  Device?: InputMaybe<Scalars['String']>;
  DeviceID?: InputMaybe<Scalars['String']>;
  DocumentName?: InputMaybe<Scalars['String']>;
  DocumentSize?: InputMaybe<Scalars['Int']>;
  Duplex?: InputMaybe<Scalars['Boolean']>;
  GrayscaleCost?: InputMaybe<Scalars['Float']>;
  GrayscalePages?: InputMaybe<Scalars['Int']>;
  JobComment?: InputMaybe<Scalars['String']>;
  JobDeliveryMethod?: InputMaybe<Scalars['String']>;
  JobPrinted?: InputMaybe<Scalars['Boolean']>;
  JobPrintedBy?: InputMaybe<Scalars['String']>;
  JobPrintedFrom?: InputMaybe<Scalars['String']>;
  JobType?: InputMaybe<Scalars['String']>;
  Orientation?: InputMaybe<Scalars['String']>;
  PaperSize?: InputMaybe<Scalars['String']>;
  PaymentBy?: InputMaybe<PaymentByInput>;
  PaymentType?: InputMaybe<Scalars['String']>;
  PrintCancelled?: InputMaybe<Scalars['Boolean']>;
  PrintJobSubmitted?: InputMaybe<Scalars['Date']>;
  ReasonCancelled?: InputMaybe<Scalars['String']>;
  ReleaseCode?: InputMaybe<Scalars['String']>;
  Staple?: InputMaybe<Scalars['String']>;
  SystemFileName?: InputMaybe<Scalars['String']>;
  TotalCost?: InputMaybe<Scalars['Float']>;
  TotalPages?: InputMaybe<Scalars['Int']>;
}

export interface Profile {
  AutoUpdate?: Maybe<Scalars['Boolean']>;
  CreatedBy?: Maybe<Scalars['String']>;
  CustomerData?: Maybe<CustomerDataSchema>;
  CustomerID?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  Driver?: Maybe<DriverSchema>;
  HideFromList?: Maybe<Scalars['Boolean']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  Login?: Maybe<LoginSchema>;
  Priority?: Maybe<Scalars['Int']>;
  Profile?: Maybe<Scalars['String']>;
  ProfileSetting?: Maybe<ProfileSettingSchema>;
  ProfileType?: Maybe<Scalars['String']>;
  Tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  _id?: Maybe<Scalars['ID']>;
}

export interface ProfileInput {
  AutoUpdate?: InputMaybe<Scalars['Boolean']>;
  CustomerID?: InputMaybe<Scalars['String']>;
  DeletedAt?: InputMaybe<Scalars['Date']>;
  DeletedBy?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  Driver?: InputMaybe<DriverInput>;
  HideFromList?: InputMaybe<Scalars['Boolean']>;
  IsActive?: InputMaybe<Scalars['Boolean']>;
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  Login?: InputMaybe<LoginInput>;
  Priority?: InputMaybe<Scalars['Int']>;
  Profile?: InputMaybe<Scalars['String']>;
  ProfileSetting?: InputMaybe<ProfileSettingInput>;
  ProfileType?: InputMaybe<Scalars['String']>;
  Tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  UpdatedBy?: InputMaybe<Scalars['String']>;
}

export interface ProfileSettingInput {
  AutomaticPrintDelivery?: InputMaybe<Scalars['Boolean']>;
  Description?: InputMaybe<Scalars['String']>;
  DisableConfirmation?: InputMaybe<Scalars['Boolean']>;
  PrintConfigurationGroup?: InputMaybe<Scalars['ID']>;
  PromptForPrinter?: InputMaybe<Scalars['Boolean']>;
}

export interface ProfileSettingSchema {
  AutomaticPrintDelivery?: Maybe<Scalars['Boolean']>;
  Description?: Maybe<Scalars['String']>;
  DisableConfirmation?: Maybe<Scalars['Boolean']>;
  PrintConfigurationGroup?: Maybe<Group>;
  PromptForPrinter?: Maybe<Scalars['Boolean']>;
}

export enum ProfileValidationType {
  ComputerName = 'ComputerName',
  Envisionware = 'Envisionware',
  GuestName = 'GuestName',
  LmsValidate = 'LMSValidate',
  Login = 'Login',
  MyPc = 'MyPC',
  ReleaseCode = 'ReleaseCode',
  Sso = 'SSO'
}

export interface ProfilesResponse {
  profile?: Maybe<Array<Maybe<Profile>>>;
  total?: Maybe<Scalars['Int']>;
}

export enum PromptEnum {
  Consent = 'consent',
  Login = 'login',
  None = 'none',
  SelectAccount = 'select_account'
}

export interface Proton {
  ClientId?: Maybe<Scalars['String']>;
  ClientSecret?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['String']>;
  CustomerID?: Maybe<Scalars['ID']>;
  CustomerName?: Maybe<Scalars['String']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  OcpApimSubscriptionKey?: Maybe<Scalars['String']>;
  Tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  ThirdPartySoftwareName?: Maybe<Scalars['String']>;
  ThirdPartySoftwareType?: Maybe<ThirdPartySoftwareType>;
  TokenAPIEndpoint?: Maybe<Scalars['String']>;
  TransactionOcpApimSubscriptionKey?: Maybe<Scalars['String']>;
  TransactionServicesAPIEndpoint?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['ID']>;
}

export interface ProtonInput {
  ClientId?: InputMaybe<Scalars['String']>;
  ClientSecret?: InputMaybe<Scalars['String']>;
  CustomerID: Scalars['ID'];
  IsActive?: InputMaybe<Scalars['Boolean']>;
  OcpApimSubscriptionKey?: InputMaybe<Scalars['String']>;
  Tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ThirdPartySoftwareName: Scalars['String'];
  ThirdPartySoftwareType: ThirdPartySoftwareType;
  TokenAPIEndpoint?: InputMaybe<Scalars['String']>;
  TransactionOcpApimSubscriptionKey?: InputMaybe<Scalars['String']>;
  TransactionServicesAPIEndpoint?: InputMaybe<Scalars['String']>;
}

export interface ProviderLanguages {
  Abby?: Maybe<Array<Maybe<ThirdPartyLanguage>>>;
  Google?: Maybe<Array<Maybe<ThirdPartyLanguage>>>;
  Microsoft?: Maybe<Array<Maybe<ThirdPartyLanguage>>>;
}

export interface PublicUpload {
  AutomaticPrintDelivery?: Maybe<Scalars['Boolean']>;
  ComputerName?: Maybe<Scalars['String']>;
  CreatedAt?: Maybe<Scalars['Date']>;
  CustomerData?: Maybe<CustomerDataSchema>;
  CustomerID?: Maybe<Scalars['ID']>;
  Email?: Maybe<Scalars['String']>;
  FileLink?: Maybe<Scalars['String']>;
  GuestName?: Maybe<Scalars['String']>;
  IsDelivered?: Maybe<Scalars['Boolean']>;
  IsPrinted?: Maybe<Scalars['Boolean']>;
  IsProcessedFileName?: Maybe<Array<Maybe<IsProcessedFileNameSchema>>>;
  JobExpired?: Maybe<Scalars['Boolean']>;
  JobList?: Maybe<JobListFieldSchema>;
  LibraryCard?: Maybe<Scalars['String']>;
  LocationData?: Maybe<LocationDataSchema>;
  PrintCounter?: Maybe<Scalars['Int']>;
  ReleaseCode?: Maybe<Scalars['String']>;
  Text?: Maybe<Scalars['String']>;
  TotalCost?: Maybe<Scalars['Float']>;
  Username?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['ID']>;
}

export interface PublicUploadInput {
  AutomaticPrintDelivery?: InputMaybe<Scalars['Boolean']>;
  ComputerName?: InputMaybe<Scalars['String']>;
  CustomerID: Scalars['ID'];
  Email?: InputMaybe<Scalars['String']>;
  GuestName?: InputMaybe<Scalars['String']>;
  IsDelivered?: InputMaybe<Scalars['Boolean']>;
  IsPrinted?: InputMaybe<Scalars['Boolean']>;
  IsProcessedFileName?: InputMaybe<Array<InputMaybe<IsProcessedFileNameSchemaInput>>>;
  JobExpired?: InputMaybe<Scalars['Boolean']>;
  JobList?: InputMaybe<Array<InputMaybe<JobListFieldSchemaInput>>>;
  LibraryCard?: InputMaybe<Scalars['String']>;
  PrintCounter?: InputMaybe<Scalars['Int']>;
  ReleaseCode?: InputMaybe<Scalars['String']>;
  Text?: InputMaybe<Scalars['String']>;
  TotalCost?: InputMaybe<Scalars['Float']>;
  Username?: InputMaybe<Scalars['String']>;
}

export interface PublicUploadResponse {
  publicUpload?: Maybe<Array<Maybe<PublicUpload>>>;
  total?: Maybe<Scalars['Int']>;
}

export interface Query {
  _empty?: Maybe<Scalars['String']>;
  buildIdPMetadata?: Maybe<Response>;
  csvReport?: Maybe<CsvReportData>;
  dashboard?: Maybe<DashboardReports>;
  findDataExisting?: Maybe<Response>;
  generateActivationCode?: Maybe<Response>;
  getAbby?: Maybe<Abby>;
  getAccount?: Maybe<Account>;
  getAccountSync?: Maybe<AccountSync>;
  getAccounts?: Maybe<AccountsResponse>;
  getArea?: Maybe<Area>;
  getAreas?: Maybe<AreasResponse>;
  getAtriumBalance?: Maybe<AtriumBalanceResponse>;
  /** API to fetch the audit logs. This api has pagination enabled. */
  getAuditLogs?: Maybe<AuditLogsResponse>;
  getAuthProvider?: Maybe<AuthProvider>;
  getAuthProviders?: Maybe<AuthProvidersResponse>;
  getAuthorizeNetClientToken?: Maybe<AuthorizeNetPaymentResponse>;
  getBalance?: Maybe<GetBalanceResponse>;
  getBillingServices?: Maybe<BillingServicesResponse>;
  getBrainTreeClientToken?: Maybe<BraintreeTokenResponse>;
  getChildPermission?: Maybe<Array<Maybe<Permission>>>;
  getCustomPermission?: Maybe<CustomPermission>;
  getCustomPermissions?: Maybe<CustomPermissionResponse>;
  getCustomer?: Maybe<Customer>;
  getCustomerLevelPermission?: Maybe<Array<Maybe<Permission>>>;
  getCustomers?: Maybe<CustomersResponse>;
  getCustomization?: Maybe<Customization>;
  getCustomizationText?: Maybe<CustomizationText>;
  getCustomizationTexts?: Maybe<CustomizationTextsResponse>;
  getDevice?: Maybe<Device>;
  getDevices?: Maybe<DevicesResponse>;
  getDropdowns?: Maybe<Dropdown>;
  getEghlHash?: Maybe<EGhlHashResponse>;
  getEmail?: Maybe<Email>;
  getFTP?: Maybe<Ftp>;
  getFax?: Maybe<Fax>;
  getFaxIntegration?: Maybe<FaxIntegration>;
  getFaxes?: Maybe<FaxesResponse>;
  getGroup?: Maybe<Group>;
  getGroups?: Maybe<GroupsResponse>;
  getHandWriteRecognition?: Maybe<HandWriteRecognition>;
  getHeartlandHash?: Maybe<HeartlandResponse>;
  getIlliad?: Maybe<Illiad>;
  getInternalAuthProvider?: Maybe<Scalars['Boolean']>;
  getJobList?: Maybe<JobList>;
  getJobListByCustomerID?: Maybe<JobList>;
  getJobLists?: Maybe<JobListsResponse>;
  getLanguages?: Maybe<Array<Maybe<Language>>>;
  /** API to get license by customer id */
  getLicense?: Maybe<License>;
  /** API to get licenses with pagination and customer id filter */
  getLicenses?: Maybe<LicensesResponse>;
  getLocation?: Maybe<Location>;
  getLocations?: Maybe<LocationsResponse>;
  getLocationsByCustomerID?: Maybe<Array<Maybe<Location>>>;
  getLogging?: Maybe<LoggingSchema>;
  getLoggings?: Maybe<LoggingsResponse>;
  getMonerisTicket?: Maybe<MonerisResponse>;
  getNayaxCheckout?: Maybe<NayaxCheckoutResponse>;
  getNetwork?: Maybe<Network>;
  getPaperSizes?: Maybe<Array<Maybe<PaperSizes>>>;
  getParentChildPermission?: Maybe<Array<Maybe<PermissionSchema>>>;
  getParentPermission?: Maybe<Array<Maybe<Permission>>>;
  getPartner?: Maybe<Partner>;
  getPartnerById?: Maybe<ApiKeyResponse>;
  getPartners?: Maybe<PartnersResponse>;
  getPay88Signature?: Maybe<Pay88Response>;
  getPaymentConfiguration?: Maybe<Payment>;
  getPaymentConfigurations?: Maybe<PaymentsResponse>;
  getProfile?: Maybe<Profile>;
  getProfiles?: Maybe<ProfilesResponse>;
  getProton?: Maybe<Proton>;
  getPublicUpload?: Maybe<PublicUpload>;
  getPublicUploads?: Maybe<PublicUploadResponse>;
  getRestorePictures?: Maybe<RestorePictures>;
  getRole?: Maybe<Role>;
  getRoles?: Maybe<RolesResponse>;
  getRootLevelPermission?: Maybe<Array<Maybe<Permission>>>;
  getSetting?: Maybe<Setting>;
  getSettings?: Maybe<SettingsResponse>;
  getSmartphone?: Maybe<Smartphone>;
  getStripeRedirectUrl?: Maybe<StripeCheckoutResponse>;
  getSubCustomers?: Maybe<CustomersResponse>;
  getThing?: Maybe<Thing>;
  getThingCertificates?: Maybe<CertData>;
  getThings?: Maybe<ThingsResponse>;
  getThirdPartySoftware?: Maybe<ThirdPartySoftwareResponse>;
  getThirdPartySupportedLanguages?: Maybe<ThirdPartySupportedLanguages>;
  getUsage?: Maybe<Usage>;
  getUsages?: Maybe<UsagesResponse>;
  getUser?: Maybe<User>;
  getUserOverview?: Maybe<UserOverviewResponse>;
  getUsers?: Maybe<UsersResponse>;
  getValidator?: Maybe<Validator>;
  getValidators?: Maybe<ValidatorsResponse>;
  getVersion?: Maybe<Version>;
  getVersions?: Maybe<VersionsResponse>;
  getXenditInvoiceURL?: Maybe<XenditResponse>;
  importAccount?: Maybe<Response>;
  importDevice?: Maybe<Response>;
  importLocation?: Maybe<Response>;
  importThing?: Maybe<Response>;
  /** API to fetch license expiring soon */
  licenseExpiringCustomers?: Maybe<CsvReportData>;
  sendAtriumTransaction?: Maybe<Response>;
  sendTransaction?: Maybe<Response>;
  uploadLogo?: Maybe<UploadLogoSchema>;
  userBalance?: Maybe<Array<Maybe<AccountInfoSchema>>>;
  userPortalDashboard?: Maybe<UserDashboardReports>;
}


export interface QueryBuildIdPMetadataArgs {
  authProviderId?: InputMaybe<Scalars['ID']>;
  customerId?: InputMaybe<Scalars['ID']>;
}


export interface QueryCsvReportArgs {
  customerId?: InputMaybe<Scalars['ID']>;
  filters?: InputMaybe<Filters>;
}


export interface QueryDashboardArgs {
  timeZone?: InputMaybe<Scalars['String']>;
}


export interface QueryFindDataExistingArgs {
  ValidationCheckInput?: InputMaybe<ValidationCheckInput>;
  customerId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGenerateActivationCodeArgs {
  customerId: Scalars['ID'];
  thingId: Scalars['ID'];
}


export interface QueryGetAbbyArgs {
  customerId: Scalars['ID'];
}


export interface QueryGetAccountArgs {
  accountId: Scalars['ID'];
}


export interface QueryGetAccountSyncArgs {
  customerId: Scalars['ID'];
}


export interface QueryGetAccountsArgs {
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  paginationInput?: InputMaybe<PaginationData>;
}


export interface QueryGetAreaArgs {
  areaId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetAreasArgs {
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  paginationInput?: InputMaybe<PaginationData>;
}


export interface QueryGetAtriumBalanceArgs {
  accountMode?: InputMaybe<Scalars['String']>;
  accountNumber?: InputMaybe<Scalars['String']>;
  atriumEndpoint?: InputMaybe<Scalars['String']>;
  cardNumber?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['ID']>;
  terminalId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetAuditLogsArgs {
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  message?: InputMaybe<Scalars['String']>;
  paginationInput?: InputMaybe<PaginationData>;
  timezone?: InputMaybe<Scalars['String']>;
  typeOf?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
}


export interface QueryGetAuthProviderArgs {
  authProviderId?: InputMaybe<Scalars['ID']>;
  customerId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetAuthProvidersArgs {
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  paginationInput?: InputMaybe<PaginationData>;
}


export interface QueryGetAuthorizeNetClientTokenArgs {
  authorizeNetInput?: InputMaybe<AuthorizeNetTokenInput>;
}


export interface QueryGetBalanceArgs {
  getBalanceInput?: InputMaybe<GetBalanceInput>;
}


export interface QueryGetBillingServicesArgs {
  paginationInput?: InputMaybe<PaginationData>;
}


export interface QueryGetBrainTreeClientTokenArgs {
  braintreeTokenInput?: InputMaybe<BraintreeTokenInput>;
}


export interface QueryGetChildPermissionArgs {
  permissionID?: InputMaybe<Scalars['String']>;
}


export interface QueryGetCustomPermissionArgs {
  customId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetCustomPermissionsArgs {
  paginationInput?: InputMaybe<PaginationData>;
}


export interface QueryGetCustomerArgs {
  customerId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetCustomersArgs {
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  isPartner?: InputMaybe<Scalars['Boolean']>;
  paginationInput?: InputMaybe<PaginationData>;
}


export interface QueryGetCustomizationArgs {
  customerId?: InputMaybe<Scalars['ID']>;
  customizationId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetCustomizationTextArgs {
  customerId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetCustomizationTextsArgs {
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  paginationInput?: InputMaybe<PaginationData>;
}


export interface QueryGetDeviceArgs {
  customerId?: InputMaybe<Scalars['ID']>;
  deviceId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetDevicesArgs {
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  deviceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  isAssigned?: InputMaybe<Scalars['Boolean']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  online?: InputMaybe<Scalars['Boolean']>;
  paginationInput?: InputMaybe<PaginationData>;
}


export interface QueryGetDropdownsArgs {
  customerId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetEghlHashArgs {
  eGHLHashInput?: InputMaybe<EGhlHashInput>;
}


export interface QueryGetEmailArgs {
  customerId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetFtpArgs {
  customerId: Scalars['ID'];
}


export interface QueryGetFaxArgs {
  FaxId?: InputMaybe<Scalars['ID']>;
  customerId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetFaxIntegrationArgs {
  customerId: Scalars['ID'];
}


export interface QueryGetFaxesArgs {
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  paginationInput?: InputMaybe<PaginationData>;
}


export interface QueryGetGroupArgs {
  customerId?: InputMaybe<Scalars['ID']>;
  groupId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetGroupsArgs {
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  paginationInput?: InputMaybe<PaginationData>;
}


export interface QueryGetHandWriteRecognitionArgs {
  customerId: Scalars['ID'];
}


export interface QueryGetHeartlandHashArgs {
  heartlandHashInput?: InputMaybe<HeartlandHashInput>;
}


export interface QueryGetIlliadArgs {
  customerId: Scalars['ID'];
}


export interface QueryGetInternalAuthProviderArgs {
  customerId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetJobListArgs {
  customerId?: InputMaybe<Scalars['ID']>;
  jobListId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetJobListByCustomerIdArgs {
  customerId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetJobListsArgs {
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  paginationInput?: InputMaybe<PaginationData>;
}


export interface QueryGetLicenseArgs {
  customerId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetLicensesArgs {
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  paginationInput?: InputMaybe<PaginationData>;
}


export interface QueryGetLocationArgs {
  customerId?: InputMaybe<Scalars['ID']>;
  locationId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetLocationsArgs {
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  paginationInput?: InputMaybe<PaginationData>;
}


export interface QueryGetLocationsByCustomerIdArgs {
  customerId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetLoggingArgs {
  loggingId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetLoggingsArgs {
  paginationInput?: InputMaybe<PaginationData>;
}


export interface QueryGetMonerisTicketArgs {
  monerisCheckoutInput?: InputMaybe<MonerisCheckoutInput>;
}


export interface QueryGetNayaxCheckoutArgs {
  nayaxCheckoutInput?: InputMaybe<NayaxCheckoutInput>;
}


export interface QueryGetNetworkArgs {
  customerId: Scalars['ID'];
}


export interface QueryGetPartnerArgs {
  customerId?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetPartnerByIdArgs {
  customerId?: InputMaybe<Scalars['ID']>;
  paginationInput?: InputMaybe<PaginationData>;
}


export interface QueryGetPartnersArgs {
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  paginationInput?: InputMaybe<PaginationData>;
}


export interface QueryGetPay88SignatureArgs {
  pay88SignatureInput?: InputMaybe<Pay88SignatureInput>;
}


export interface QueryGetPaymentConfigurationArgs {
  customerId?: InputMaybe<Scalars['ID']>;
  paymentId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetPaymentConfigurationsArgs {
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  paginationInput?: InputMaybe<PaginationData>;
}


export interface QueryGetProfileArgs {
  customerId?: InputMaybe<Scalars['ID']>;
  profileId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetProfilesArgs {
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  paginationInput?: InputMaybe<PaginationData>;
}


export interface QueryGetProtonArgs {
  customerId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetPublicUploadArgs {
  customerId?: InputMaybe<Scalars['ID']>;
  fileName?: InputMaybe<Scalars['String']>;
  uploadId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetPublicUploadsArgs {
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  email?: InputMaybe<Scalars['String']>;
  guestName?: InputMaybe<Scalars['String']>;
  isPrinted?: InputMaybe<Scalars['Boolean']>;
  isProcessed?: InputMaybe<Scalars['Boolean']>;
  libraryCard?: InputMaybe<Scalars['String']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  paginationInput?: InputMaybe<PaginationData>;
  releaseCode?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
}


export interface QueryGetRestorePicturesArgs {
  customerId: Scalars['ID'];
}


export interface QueryGetRoleArgs {
  customerId?: InputMaybe<Scalars['ID']>;
  roleId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetRolesArgs {
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  paginationInput?: InputMaybe<PaginationData>;
}


export interface QueryGetSettingArgs {
  settingId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetSettingsArgs {
  paginationInput?: InputMaybe<PaginationData>;
}


export interface QueryGetSmartphoneArgs {
  customerId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetStripeRedirectUrlArgs {
  stripeInput?: InputMaybe<StripeCheckoutInput>;
}


export interface QueryGetSubCustomersArgs {
  customerId?: InputMaybe<Scalars['ID']>;
  paginationInput?: InputMaybe<PaginationData>;
}


export interface QueryGetThingArgs {
  customerId?: InputMaybe<Scalars['ID']>;
  thingId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetThingCertificatesArgs {
  certId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetThingsArgs {
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  paginationInput?: InputMaybe<PaginationData>;
}


export interface QueryGetThirdPartySoftwareArgs {
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  paginationInput?: InputMaybe<PaginationData>;
}


export interface QueryGetThirdPartySupportedLanguagesArgs {
  thirdPartySupportedLanguagesInput?: InputMaybe<ThirdPartySupportedLanguagesInput>;
}


export interface QueryGetUsageArgs {
  customerId?: InputMaybe<Scalars['ID']>;
  usageId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetUsagesArgs {
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  filters?: InputMaybe<FilterUsage>;
  paginationInput?: InputMaybe<PaginationData>;
}


export interface QueryGetUserArgs {
  customerId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetUserOverviewArgs {
  customerId?: InputMaybe<Scalars['ID']>;
  transactionFilters?: InputMaybe<FilterUsage>;
  transactionPaginationInput?: InputMaybe<PaginationData>;
  usageFilters?: InputMaybe<FilterUsage>;
  usagePaginationInput?: InputMaybe<PaginationData>;
  userId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetUsersArgs {
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  paginationInput?: InputMaybe<PaginationData>;
}


export interface QueryGetValidatorArgs {
  validatorId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetValidatorsArgs {
  paginationInput?: InputMaybe<PaginationData>;
}


export interface QueryGetVersionArgs {
  customerId?: InputMaybe<Scalars['ID']>;
  versionId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetVersionsArgs {
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  paginationInput?: InputMaybe<PaginationData>;
}


export interface QueryGetXenditInvoiceUrlArgs {
  xenditInvoiceInput?: InputMaybe<XenditInvoiceInput>;
}


export interface QueryImportAccountArgs {
  customerId?: InputMaybe<Scalars['ID']>;
}


export interface QueryImportDeviceArgs {
  customerId?: InputMaybe<Scalars['ID']>;
}


export interface QueryImportLocationArgs {
  customerId?: InputMaybe<Scalars['ID']>;
}


export interface QueryImportThingArgs {
  customerId?: InputMaybe<Scalars['ID']>;
}


export interface QueryLicenseExpiringCustomersArgs {
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  endDate?: InputMaybe<Scalars['Date']>;
  startDate?: InputMaybe<Scalars['Date']>;
  timezone?: InputMaybe<Scalars['String']>;
}


export interface QuerySendAtriumTransactionArgs {
  accountMode?: InputMaybe<Scalars['String']>;
  accountNumber?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['Float']>;
  atriumEndpoint?: InputMaybe<Scalars['String']>;
  cardNumber?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['ID']>;
  device?: InputMaybe<Scalars['String']>;
  terminalId?: InputMaybe<Scalars['String']>;
}


export interface QuerySendTransactionArgs {
  sendTransactionInput?: InputMaybe<SendTransactionInput>;
}


export interface QueryUploadLogoArgs {
  logoMetaData?: InputMaybe<LogoAttributes>;
}


export interface QueryUserBalanceArgs {
  username?: InputMaybe<Scalars['String']>;
}


export interface QueryUserPortalDashboardArgs {
  timeZone?: InputMaybe<Scalars['String']>;
}

export interface QuotaBalanceInput {
  Amount?: InputMaybe<Scalars['Float']>;
  Dates?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  Day?: InputMaybe<Scalars['String']>;
  Frequency?: InputMaybe<Scalars['String']>;
  MaxBalance?: InputMaybe<Scalars['Float']>;
  Scheduled?: InputMaybe<Scalars['Boolean']>;
}

export interface QuotaBalanceSchema {
  Amount?: Maybe<Scalars['Float']>;
  Dates?: Maybe<Array<Maybe<Scalars['Date']>>>;
  Day?: Maybe<Scalars['String']>;
  Frequency?: Maybe<Scalars['String']>;
  MaxBalance?: Maybe<Scalars['Float']>;
  Scheduled?: Maybe<Scalars['Boolean']>;
}

export interface QuotaInput {
  AddValuetoBalance?: InputMaybe<Scalars['String']>;
  AddedtoGroup?: InputMaybe<Scalars['Boolean']>;
  Amount?: InputMaybe<Scalars['Int']>;
  Frequency?: InputMaybe<Scalars['String']>;
  InitialSetup?: InputMaybe<Scalars['String']>;
  Oncreated?: InputMaybe<Scalars['Boolean']>;
  Schedule?: InputMaybe<Scalars['Boolean']>;
}

export interface QuotaSchema {
  AddValuetoBalance?: Maybe<Scalars['String']>;
  AddedtoGroup?: Maybe<Scalars['Boolean']>;
  Amount?: Maybe<Scalars['Int']>;
  Frequency?: Maybe<Scalars['String']>;
  InitialSetup?: Maybe<Scalars['String']>;
  Oncreated?: Maybe<Scalars['Boolean']>;
  Schedule?: Maybe<Scalars['Boolean']>;
}

export interface RedundancySettingInput {
  Primary?: InputMaybe<Scalars['Boolean']>;
  PrimaryThingID?: InputMaybe<Scalars['ID']>;
  Redundancy?: InputMaybe<Scalars['Boolean']>;
  ThingsAssociated?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
}

export interface RedundancySettingSchema {
  Primary?: Maybe<Scalars['Boolean']>;
  PrimaryThingID?: Maybe<Scalars['ID']>;
  Redundancy?: Maybe<Scalars['Boolean']>;
  ThingsAssociated?: Maybe<Array<Maybe<Scalars['ID']>>>;
}

export interface RelaxedTimeInput {
  Extensions?: InputMaybe<ExtentionsInput>;
  ExtentionTime?: InputMaybe<Scalars['Int']>;
  InitialSession?: InputMaybe<Scalars['Int']>;
  LoginWaitTimeRelaxedTime?: InputMaybe<Scalars['Int']>;
  MoreThanXPCsAvailable?: InputMaybe<Scalars['Int']>;
  RelaxedTimeType?: InputMaybe<Scalars['String']>;
  RelaxedTimeWhen?: InputMaybe<RelaxedTimeWhenInput>;
}

export interface RelaxedTimeSchema {
  Extensions?: Maybe<ExtentionsSchema>;
  ExtentionTime?: Maybe<Scalars['Int']>;
  InitialSession?: Maybe<Scalars['Int']>;
  LoginWaitTimeRelaxedTime?: Maybe<Scalars['Int']>;
  MoreThanXPCsAvailable?: Maybe<Scalars['Int']>;
  RelaxedTimeType?: Maybe<Scalars['String']>;
  RelaxedTimeWhen?: Maybe<RelaxedTimeWhenSchema>;
}

export interface RelaxedTimeWhenInput {
  Days?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  Time?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
}

export interface RelaxedTimeWhenSchema {
  Days?: Maybe<Array<Maybe<Scalars['String']>>>;
  Time?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export interface ReleaseCodeInput {
  EmailConfirmationBox?: InputMaybe<Scalars['Boolean']>;
  EmailConfirmationTextBox?: InputMaybe<Scalars['String']>;
  ReleaseCodeDisplayText?: InputMaybe<Scalars['String']>;
  ReleaseCodeText?: InputMaybe<Scalars['String']>;
  TextConfirmationBox?: InputMaybe<Scalars['Boolean']>;
  TextConfirmationTextBox?: InputMaybe<Scalars['String']>;
}

export interface ReleaseCodeSchema {
  EmailConfirmationBox?: Maybe<Scalars['Boolean']>;
  EmailConfirmationTextBox?: Maybe<Scalars['String']>;
  ReleaseCodeDisplayText?: Maybe<Scalars['String']>;
  ReleaseCodeText?: Maybe<Scalars['String']>;
  TextConfirmationBox?: Maybe<Scalars['Boolean']>;
  TextConfirmationTextBox?: Maybe<Scalars['String']>;
}

export interface Response {
  message?: Maybe<Scalars['String']>;
  statusCode?: Maybe<Scalars['Int']>;
}

export interface RestorePictures {
  CreatedBy?: Maybe<Scalars['String']>;
  CustomerID?: Maybe<Scalars['ID']>;
  CustomerName?: Maybe<Scalars['String']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  RestoreExePath?: Maybe<Scalars['String']>;
  Tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  ThirdPartySoftwareName?: Maybe<Scalars['String']>;
  ThirdPartySoftwareType: ThirdPartySoftwareType;
  _id?: Maybe<Scalars['ID']>;
}

export interface RestorePicturesInput {
  CustomerID: Scalars['ID'];
  IsActive?: InputMaybe<Scalars['Boolean']>;
  RestoreExePath?: InputMaybe<Scalars['String']>;
  Tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ThirdPartySoftwareName?: InputMaybe<Scalars['String']>;
  ThirdPartySoftwareType: ThirdPartySoftwareType;
}

export interface Role {
  CustomPermissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  CustomerData?: Maybe<CustomerDataSchema>;
  CustomerID?: Maybe<Scalars['ID']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  NavigationPermissionID?: Maybe<Scalars['ID']>;
  Permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  RoleName?: Maybe<Scalars['String']>;
  Root?: Maybe<Scalars['Boolean']>;
  _id?: Maybe<Scalars['ID']>;
}

export interface RoleData {
  RoleName?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['ID']>;
}

export interface RoleInput {
  CustomPermissions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  CustomerID?: InputMaybe<Scalars['ID']>;
  IsActive?: InputMaybe<Scalars['Boolean']>;
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  NavigationPermissionID?: InputMaybe<Scalars['ID']>;
  Permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  RoleName?: InputMaybe<Scalars['String']>;
  Root?: InputMaybe<Scalars['Boolean']>;
}

export interface RolesResponse {
  role?: Maybe<Array<Maybe<Role>>>;
  total?: Maybe<Scalars['Int']>;
}

export interface RuleInput {
  AllowsGuest?: InputMaybe<Scalars['Boolean']>;
  BlockBookingPersistence?: InputMaybe<Scalars['Boolean']>;
  BusyTime?: InputMaybe<BusyTimeInput>;
  Chargeable?: InputMaybe<ChargeableInput>;
  DeviceUsagePolicy?: InputMaybe<DeviceUsagePolicyInput>;
  EndOfDay?: InputMaybe<EndOfDayInput>;
  InactivityTimeout?: InputMaybe<Scalars['Int']>;
  LockTimeout?: InputMaybe<Scalars['Int']>;
  LoginWaitTime?: InputMaybe<Scalars['Int']>;
  NoReturnTime?: InputMaybe<Scalars['Int']>;
  OpenTimes?: InputMaybe<OpenTimesInput>;
  Priority?: InputMaybe<Scalars['Int']>;
  RelaxedTime?: InputMaybe<RelaxedTimeInput>;
  SessionType?: InputMaybe<SessionTypeInput>;
  Settings?: InputMaybe<SettingsInput>;
  StaffFutureBooking?: InputMaybe<Scalars['Int']>;
  Validation?: InputMaybe<ValidationInput>;
  WarningMessagesInterval?: InputMaybe<WarningMessagesIntervalInput>;
  WelcomeMessage?: InputMaybe<MessageInput>;
}

export interface RuleSchema {
  AllowsGuest?: Maybe<Scalars['Boolean']>;
  BlockBookingPersistence?: Maybe<Scalars['Boolean']>;
  BusyTime?: Maybe<BusyTimeSchema>;
  Chargeable?: Maybe<ChargeableSchema>;
  DeviceUsagePolicy?: Maybe<DeviceUsagePolicySchema>;
  EndOfDay?: Maybe<EndOfDaySchema>;
  InactivityTimeout?: Maybe<Scalars['Int']>;
  LockTimeout?: Maybe<Scalars['Int']>;
  LoginWaitTime?: Maybe<Scalars['Int']>;
  NoReturnTime?: Maybe<Scalars['Int']>;
  OpenTimes?: Maybe<OpenTimesSchema>;
  Priority?: Maybe<Scalars['Int']>;
  RelaxedTime?: Maybe<RelaxedTimeSchema>;
  SessionType?: Maybe<SessionTypeSchema>;
  Settings?: Maybe<SettingsSchema>;
  StaffFutureBooking?: Maybe<Scalars['Int']>;
  Validation?: Maybe<ValidationSchema>;
  WarningMessagesInterval?: Maybe<WarningMessagesIntervalSchema>;
  WelcomeMessage?: Maybe<MessageSchema>;
}

export interface RulesInput {
  Condition?: InputMaybe<TypeCondition>;
  Field?: InputMaybe<Scalars['String']>;
  Match?: InputMaybe<TypeMatch>;
  Value?: InputMaybe<Scalars['String']>;
}

export interface RulesSchema {
  Condition?: Maybe<TypeCondition>;
  Field?: Maybe<Scalars['String']>;
  Match?: Maybe<TypeMatch>;
  Value?: Maybe<Scalars['String']>;
}

export interface SamlConfigInput {
  Certificate?: InputMaybe<Scalars['String']>;
  LoginUrl?: InputMaybe<Scalars['String']>;
  NameIdFormat?: InputMaybe<Scalars['String']>;
}

export interface SamlConfigSchema {
  Certificate?: Maybe<Scalars['String']>;
  LoginUrl?: Maybe<Scalars['String']>;
  NameIdFormat?: Maybe<Scalars['String']>;
}

export interface SelectFileSection {
  ColorCostText?: Maybe<Scalars['String']>;
  ColorCostVisibility?: Maybe<Scalars['Boolean']>;
  CostPerPage?: Maybe<CostPerPageSchema>;
  CostPerPageVisibility?: Maybe<Scalars['Boolean']>;
  GrayscaleText?: Maybe<Scalars['String']>;
  GrayscaleVisibility?: Maybe<Scalars['Boolean']>;
  MaxFileSize?: Maybe<Scalars['Int']>;
  SupportedFileTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export interface SelectFileSectionInput {
  ColorCostText?: InputMaybe<Scalars['String']>;
  ColorCostVisibility?: InputMaybe<Scalars['Boolean']>;
  CostPerPage?: InputMaybe<CostPerPageInput>;
  CostPerPageVisibility?: InputMaybe<Scalars['Boolean']>;
  GrayscaleText?: InputMaybe<Scalars['String']>;
  GrayscaleVisibility?: InputMaybe<Scalars['Boolean']>;
  MaxFileSize?: InputMaybe<Scalars['Int']>;
  SupportedFileTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
}

export interface SendTransactionInput {
  Amount?: InputMaybe<Scalars['Float']>;
  CardNumber: Scalars['String'];
  Currency?: InputMaybe<Scalars['String']>;
  CustomerId: Scalars['String'];
  Device?: InputMaybe<Scalars['String']>;
  PaymentType: ThingPaymentOption;
  ThingID: Scalars['ID'];
}

export enum ServiceName {
  EmailService = 'EmailService',
  FaxService = 'FaxService',
  ImportAccounts = 'ImportAccounts',
  ImportDevices = 'ImportDevices',
  ImportLocations = 'ImportLocations',
  ImportThings = 'ImportThings',
  TranslationService = 'TranslationService'
}

export enum ServiceNameType {
  SrFax = 'SrFax'
}

export enum ServiceType {
  EmailService = 'EmailService'
}

export interface SessionTypeInput {
  Device?: InputMaybe<Scalars['Boolean']>;
  Future?: InputMaybe<Scalars['Boolean']>;
  Queuing?: InputMaybe<Scalars['Boolean']>;
}

export interface SessionTypeSchema {
  Device?: Maybe<Scalars['Boolean']>;
  Future?: Maybe<Scalars['Boolean']>;
  Queuing?: Maybe<Scalars['Boolean']>;
}

export interface Setting {
  CreatedBy?: Maybe<Scalars['String']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  Label?: Maybe<Scalars['String']>;
  Setting?: Maybe<Scalars['String']>;
  Tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  _id?: Maybe<Scalars['ID']>;
}

export interface SettingInput {
  DeletedAt?: InputMaybe<Scalars['Date']>;
  DeletedBy?: InputMaybe<Scalars['String']>;
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  Label?: InputMaybe<Scalars['String']>;
  Setting?: InputMaybe<Scalars['String']>;
  Tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  UpdatedBy?: InputMaybe<Scalars['String']>;
}

export interface SettingsInput {
  AutoExtendSession?: InputMaybe<Scalars['Boolean']>;
  ExtensionIncrements?: InputMaybe<Scalars['Int']>;
  Extensions?: InputMaybe<Scalars['Boolean']>;
  InitialSessionLength?: InputMaybe<Scalars['Int']>;
  MinimumSessionTime?: InputMaybe<Scalars['Int']>;
  NumberOfExtensions?: InputMaybe<Scalars['Int']>;
}

export interface SettingsResponse {
  setting?: Maybe<Array<Maybe<Setting>>>;
  total?: Maybe<Scalars['Int']>;
}

export interface SettingsSchema {
  AutoExtendSession?: Maybe<Scalars['Boolean']>;
  ExtensionIncrements?: Maybe<Scalars['Int']>;
  Extensions?: Maybe<Scalars['Boolean']>;
  InitialSessionLength?: Maybe<Scalars['Int']>;
  MinimumSessionTime?: Maybe<Scalars['Int']>;
  NumberOfExtensions?: Maybe<Scalars['Int']>;
}

export interface Sip2ConfigInput {
  BarCodeLabelText?: InputMaybe<Scalars['String']>;
  Host: Scalars['String'];
  InstitutionID?: InputMaybe<Scalars['String']>;
  LocationCode?: InputMaybe<Scalars['String']>;
  LoginEnabled?: InputMaybe<Scalars['Boolean']>;
  LoginType: LoginTypeSip2;
  Password?: InputMaybe<Scalars['String']>;
  PinLabelText?: InputMaybe<Scalars['String']>;
  Port: Scalars['String'];
  SslEnabled?: InputMaybe<Scalars['Boolean']>;
  UseBiblionixClientCert?: InputMaybe<Scalars['Boolean']>;
  TerminalPassword?: InputMaybe<Scalars['String']>;
  Username?: InputMaybe<Scalars['String']>;
}

export interface Sip2ConfigSchema {
  BarCodeLabelText?: Maybe<Scalars['String']>;
  Host?: Maybe<Scalars['String']>;
  InstitutionID?: Maybe<Scalars['String']>;
  LocationCode?: Maybe<Scalars['String']>;
  LoginEnabled?: Maybe<Scalars['Boolean']>;
  LoginType?: Maybe<LoginTypeSip2>;
  Password?: Maybe<Scalars['String']>;
  PinLabelText?: Maybe<Scalars['String']>;
  Port?: Maybe<Scalars['String']>;
  SslEnabled?: Maybe<Scalars['Boolean']>;
  UseBiblionixClientCert?: Maybe<Scalars['Boolean']>;
  TerminalPassword?: Maybe<Scalars['String']>;
  Username?: Maybe<Scalars['String']>;
}

export interface SirsiConfigInput {
  AppId?: InputMaybe<Scalars['String']>;
  BarCode?: InputMaybe<Scalars['String']>;
  BarCodeLabelText?: InputMaybe<Scalars['String']>;
  ClientId?: InputMaybe<Scalars['String']>;
  LoginType?: InputMaybe<Scalars['String']>;
  Password?: InputMaybe<Scalars['String']>;
  Pin?: InputMaybe<Scalars['String']>;
  PinLabelText?: InputMaybe<Scalars['String']>;
  ServerBaseURL?: InputMaybe<Scalars['String']>;
  Username?: InputMaybe<Scalars['String']>;
}

export interface SirsiConfigSchema {
  AppId?: Maybe<Scalars['String']>;
  BarCode?: Maybe<Scalars['String']>;
  BarCodeLabelText?: Maybe<Scalars['String']>;
  ClientId?: Maybe<Scalars['String']>;
  LoginType?: Maybe<Scalars['String']>;
  Password?: Maybe<Scalars['String']>;
  Pin?: Maybe<Scalars['String']>;
  PinLabelText?: Maybe<Scalars['String']>;
  ServerBaseURL?: Maybe<Scalars['String']>;
  Username?: Maybe<Scalars['String']>;
}

export interface Smartphone {
  CreatedBy?: Maybe<Scalars['String']>;
  CustomerID?: Maybe<Scalars['ID']>;
  CustomerName?: Maybe<Scalars['String']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  Pin?: Maybe<SmartphonePin>;
  Tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  ThirdPartySoftwareName?: Maybe<Scalars['String']>;
  ThirdPartySoftwareType?: Maybe<ThirdPartySoftwareType>;
  _id?: Maybe<Scalars['ID']>;
}

export interface SmartphoneInput {
  CustomerID?: InputMaybe<Scalars['ID']>;
  IsActive?: InputMaybe<Scalars['Boolean']>;
  Pin?: InputMaybe<SmartphonePin>;
  Tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ThirdPartySoftwareName: Scalars['String'];
  ThirdPartySoftwareType: ThirdPartySoftwareType;
}

export enum SmartphonePin {
  Disabled = 'Disabled',
  Optional = 'Optional',
  Required = 'Required'
}

export interface StapleDataInput {
  Enable?: InputMaybe<Scalars['Boolean']>;
  StapleBottomLeft?: InputMaybe<Scalars['Boolean']>;
  StapleBottomRight?: InputMaybe<Scalars['Boolean']>;
  StapleOptionDefaultType?: InputMaybe<StapleOptionType>;
  StapleTopLeft?: InputMaybe<Scalars['Boolean']>;
  StapleTopRight?: InputMaybe<Scalars['Boolean']>;
}

export interface StapleDataSchema {
  Enable?: Maybe<Scalars['Boolean']>;
  StapleBottomLeft?: Maybe<Scalars['Boolean']>;
  StapleBottomRight?: Maybe<Scalars['Boolean']>;
  StapleOptionDefaultType?: Maybe<StapleOptionType>;
  StapleTopLeft?: Maybe<Scalars['Boolean']>;
  StapleTopRight?: Maybe<Scalars['Boolean']>;
}

export enum StapleOptionType {
  None = 'None',
  StapleBottomLeft = 'StapleBottomLeft',
  StapleBottomRight = 'StapleBottomRight',
  StapleTopLeft = 'StapleTopLeft',
  StapleTopRight = 'StapleTopRight'
}

export interface StripeCheckoutInput {
  CancelUrl?: InputMaybe<Scalars['String']>;
  Currency?: InputMaybe<Scalars['String']>;
  CustomerID: Scalars['String'];
  Image?: InputMaybe<Scalars['String']>;
  PaymentID?: InputMaybe<Scalars['String']>;
  Price?: InputMaybe<Scalars['Float']>;
  ProductName?: InputMaybe<Scalars['String']>;
  SuccessUrl?: InputMaybe<Scalars['String']>;
}

export interface StripeCheckoutResponse {
  message?: Maybe<Scalars['String']>;
  statusCode?: Maybe<Scalars['String']>;
}

export interface StripeInput {
  PublicKey?: InputMaybe<Scalars['String']>;
  SecretKey?: InputMaybe<Scalars['String']>;
  WebhookURL?: InputMaybe<Scalars['String']>;
}

export interface StripeSchema {
  PublicKey?: Maybe<Scalars['String']>;
  SecretKey?: Maybe<Scalars['String']>;
  WebhookID?: Maybe<Scalars['String']>;
  WebhookSecret?: Maybe<Scalars['String']>;
  WebhookURL?: Maybe<Scalars['String']>;
}

export interface SubCustomerData {
  CustomerName?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  DisplayName?: Maybe<Scalars['String']>;
}

export interface SubCustomersPaginationData {
  pattern?: InputMaybe<Scalars['String']>;
}

export interface SubGroupInput {
  Active?: InputMaybe<Scalars['Boolean']>;
  Name?: InputMaybe<Scalars['String']>;
  Rules?: InputMaybe<Array<InputMaybe<RulesInput>>>;
}

export interface SubGroupSchema {
  Active?: Maybe<Scalars['Boolean']>;
  Name?: Maybe<Scalars['String']>;
  Rules?: Maybe<Array<Maybe<RulesSchema>>>;
}

export interface Tabloid {
  Enabled?: Maybe<Scalars['Boolean']>;
  Price?: Maybe<Price>;
}

export interface TabloidInput {
  Enabled?: InputMaybe<Scalars['Boolean']>;
  Price?: InputMaybe<PriceInput>;
}

export interface TcpPrintOptionsInput {
  IpAddress?: InputMaybe<Scalars['String']>;
  Port?: InputMaybe<Scalars['Int']>;
  TcpPrint?: InputMaybe<Scalars['Boolean']>;
}

export interface TcpPrintOptionsSchema {
  IpAddress?: Maybe<Scalars['String']>;
  Port?: Maybe<Scalars['Int']>;
  TcpPrint?: Maybe<Scalars['Boolean']>;
}

export interface Thing {
  ActivationCode?: Maybe<Scalars['String']>;
  ActivationStatus?: Maybe<Scalars['String']>;
  AppVersion?: Maybe<Scalars['String']>;
  Application?: Maybe<Scalars['String']>;
  AreaID?: Maybe<Scalars['ID']>;
  AutoSelectPrinter?: Maybe<Scalars['Boolean']>;
  AutomaticSoftwareUpdate?: Maybe<Scalars['Boolean']>;
  ClearLogsAfter?: Maybe<Scalars['Int']>;
  ComputerName?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['String']>;
  CustomerData?: Maybe<CustomerDataSchema>;
  CustomerID?: Maybe<Scalars['ID']>;
  CustomerName?: Maybe<Scalars['String']>;
  CustomizationID?: Maybe<Scalars['String']>;
  DebugLog?: Maybe<Scalars['Boolean']>;
  DefaultDevice?: Maybe<Scalars['ID']>;
  Description?: Maybe<Scalars['String']>;
  DeviceData?: Maybe<Array<Maybe<Device>>>;
  DeviceID?: Maybe<Array<Maybe<Scalars['ID']>>>;
  DisconnectReason?: Maybe<Scalars['String']>;
  DisplayQrCode?: Maybe<Scalars['Boolean']>;
  EmailAsReleaseCode?: Maybe<Scalars['Boolean']>;
  Enabled?: Maybe<Scalars['Boolean']>;
  Firmware?: Maybe<Scalars['String']>;
  GuestCopy?: Maybe<Scalars['Boolean']>;
  GuestScan?: Maybe<Scalars['Boolean']>;
  IpAddress?: Maybe<Scalars['String']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  Label?: Maybe<Scalars['String']>;
  LocationData?: Maybe<LocationDataSchema>;
  LocationID?: Maybe<Scalars['ID']>;
  LoginOptions?: Maybe<Array<Maybe<LoginOptionsSchema>>>;
  MacAddress?: Maybe<Scalars['String']>;
  MessageBox?: Maybe<Scalars['String']>;
  MultithreadPrint?: Maybe<Scalars['Boolean']>;
  OnlineStatus?: Maybe<Scalars['Boolean']>;
  PJLPrint?: Maybe<Scalars['Boolean']>;
  PaymentOptions?: Maybe<Array<Maybe<PaymentOptionsThings>>>;
  PdfiumPrint?: Maybe<Scalars['Boolean']>;
  PrimaryRegion?: Maybe<IotRegionDetails>;
  PrintUSBAsGuest?: Maybe<Scalars['Boolean']>;
  PrintUSBWithAccount?: Maybe<Scalars['Boolean']>;
  ProfileID?: Maybe<Scalars['String']>;
  PromptForAccount?: Maybe<Scalars['Boolean']>;
  RedundancySetting?: Maybe<RedundancySettingSchema>;
  SecondaryRegion?: Maybe<IotRegionDetails>;
  SerialNumber?: Maybe<Scalars['String']>;
  SupportedIdentityProviderID?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  Thing?: Maybe<Scalars['String']>;
  ThingType?: Maybe<Scalars['String']>;
  TimeOut?: Maybe<Scalars['Int']>;
  Topic?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['ID']>;
}

export interface ThingDataSchema {
  OnlineStatus?: Maybe<Scalars['Boolean']>;
  Thing?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['ID']>;
}

export interface ThingInput {
  ActivationCode?: InputMaybe<Scalars['String']>;
  ActivationStatus?: InputMaybe<Scalars['String']>;
  AppVersion?: InputMaybe<Scalars['String']>;
  Application?: InputMaybe<Scalars['String']>;
  AreaID?: InputMaybe<Scalars['ID']>;
  AutoSelectPrinter?: InputMaybe<Scalars['Boolean']>;
  AutomaticSoftwareUpdate?: InputMaybe<Scalars['Boolean']>;
  ClearLogsAfter?: InputMaybe<Scalars['Int']>;
  ComputerName?: InputMaybe<Scalars['String']>;
  CustomerID: Scalars['ID'];
  CustomizationID?: InputMaybe<Scalars['String']>;
  DebugLog?: InputMaybe<Scalars['Boolean']>;
  DefaultDevice?: InputMaybe<Scalars['ID']>;
  DeletedAt?: InputMaybe<Scalars['Date']>;
  DeletedBy?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  DeviceID?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  DisplayQrCode?: InputMaybe<Scalars['Boolean']>;
  EmailAsReleaseCode?: InputMaybe<Scalars['Boolean']>;
  Enabled?: InputMaybe<Scalars['Boolean']>;
  Firmware?: InputMaybe<Scalars['String']>;
  GuestCopy?: InputMaybe<Scalars['Boolean']>;
  GuestScan?: InputMaybe<Scalars['Boolean']>;
  IpAddress?: InputMaybe<Scalars['String']>;
  IsActive?: InputMaybe<Scalars['Boolean']>;
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  Label?: InputMaybe<Scalars['String']>;
  LocationID: Scalars['ID'];
  LoginOptions?: InputMaybe<Array<InputMaybe<LoginOptionsInput>>>;
  MacAddress?: InputMaybe<Scalars['String']>;
  MessageBox?: InputMaybe<Scalars['String']>;
  MultithreadPrint?: InputMaybe<Scalars['Boolean']>;
  OnlineStatus?: InputMaybe<Scalars['Boolean']>;
  PJLPrint?: InputMaybe<Scalars['Boolean']>;
  PaymentOptions?: InputMaybe<Array<InputMaybe<PaymentOptionsThingsInput>>>;
  PdfiumPrint?: InputMaybe<Scalars['Boolean']>;
  PrintUSBAsGuest?: InputMaybe<Scalars['Boolean']>;
  PrintUSBWithAccount?: InputMaybe<Scalars['Boolean']>;
  ProfileID?: InputMaybe<Scalars['String']>;
  PromptForAccount?: InputMaybe<Scalars['Boolean']>;
  RedundancySetting?: InputMaybe<RedundancySettingInput>;
  SerialNumber?: InputMaybe<Scalars['String']>;
  SupportedIdentityProviderID?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  Tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  Thing: Scalars['String'];
  ThingArn?: InputMaybe<Scalars['String']>;
  ThingName?: InputMaybe<Scalars['String']>;
  ThingType?: InputMaybe<Scalars['String']>;
  TimeOut?: InputMaybe<Scalars['Int']>;
  Topic?: InputMaybe<Scalars['String']>;
  UpdatedBy?: InputMaybe<Scalars['String']>;
}

export enum ThingPaymentOption {
  Atrium = 'Atrium',
  Cbord = 'CBORD',
  CoinBox = 'CoinBox',
  NayaxCloud = 'Nayax_Cloud',
  NayaxCreditCard = 'Nayax_Credit_Card',
  None = 'None'
}

export interface ThingsLimit {
  ThingNumber?: Maybe<Scalars['Int']>;
  ThingType?: Maybe<Scalars['String']>;
}

export interface ThingsLimitInput {
  ThingNumber?: InputMaybe<Scalars['Int']>;
  ThingType?: InputMaybe<Scalars['String']>;
}

export interface ThingsResponse {
  thing?: Maybe<Array<Maybe<Thing>>>;
  total?: Maybe<Scalars['Int']>;
}

export interface ThirdPartyLanguage {
  Code?: Maybe<Scalars['String']>;
  Language?: Maybe<Scalars['String']>;
}

export interface ThirdPartySoftware {
  CustomerID?: Maybe<Scalars['ID']>;
  CustomerName?: Maybe<Scalars['String']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  Tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  ThirdPartySoftwareName?: Maybe<Scalars['String']>;
  ThirdPartySoftwareType?: Maybe<ThirdPartySoftwareType>;
  _id?: Maybe<Scalars['ID']>;
}

export interface ThirdPartySoftwareResponse {
  thirdPartySoftware?: Maybe<Array<Maybe<ThirdPartySoftware>>>;
  total?: Maybe<Scalars['Int']>;
}

export enum ThirdPartySoftwareType {
  AbbyIntegration = 'AbbyIntegration',
  AudioIntegration = 'AudioIntegration',
  AccountSyncIntegration = 'AccountSyncIntegration',
  Audio = 'Audio',
  EmailIntegration = 'EmailIntegration',
  FtpIntegration = 'FTPIntegration',
  FaxIntegration = 'FaxIntegration',
  HandwriteRecognitionIntegration = 'HandwriteRecognitionIntegration',
  IlliadIntegration = 'IlliadIntegration',
  NetworkIntegration = 'NetworkIntegration',
  ProtonIntegration = 'ProtonIntegration',
  RestorePicturesIntegration = 'RestorePicturesIntegration',
  SmartphoneIntegration = 'SmartphoneIntegration',
  TextTranslationIntegration = 'TextTranslationIntegration',
  NayaxCloudIntegration = 'NayaxCloudIntegration'
}

export interface ThirdPartySupportedLanguages {
  Languages?: Maybe<ProviderLanguages>;
  ThirdPartySoftwareType: Scalars['String'];
  _id?: Maybe<Scalars['ID']>;
}

export interface ThirdPartySupportedLanguagesInput {
  ThirdPartySoftwareType: ThirdPartySoftwareType;
}

export interface TopSectionInput {
  CustomerLogo?: InputMaybe<Scalars['String']>;
}

export interface TopSectionSchema {
  CustomerLogo?: Maybe<Scalars['String']>;
}

export interface TransactionInput {
  Amount?: InputMaybe<Scalars['String']>;
  PaymentMethodNonce?: InputMaybe<Scalars['String']>;
}

export interface TranslationServiceInput {
  Audio?: InputMaybe<Scalars['Boolean']>;
  Text?: InputMaybe<Scalars['Boolean']>;
}

export interface TranslationServiceSchema {
  Audio?: Maybe<Scalars['Boolean']>;
  Text?: Maybe<Scalars['Boolean']>;
}

export enum TypeCondition {
  BetweenAge = 'between_age',
  EqualTo = 'equal_to',
  NotEqualTo = 'not_equal_to',
  OlderThanAge = 'older_than_age',
  YoungerThanAge = 'younger_than_age'
}

export enum TypeMatch {
  Multi = 'multi',
  Single = 'single'
}

export interface UpdateInput {
  CardNumber?: InputMaybe<Scalars['String']>;
  CustomerID?: InputMaybe<Scalars['ID']>;
  Email?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  FirstName: Scalars['String'];
  GroupID?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  IsActive?: InputMaybe<Scalars['Boolean']>;
  LastName: Scalars['String'];
  Mfa?: InputMaybe<Scalars['Boolean']>;
  MfaOption?: InputMaybe<OptionsMfa>;
  Mobile?: InputMaybe<Scalars['String']>;
  PIN?: InputMaybe<Scalars['String']>;
  PrimaryEmail?: InputMaybe<Scalars['String']>;
  Tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
}

export interface UpdateInputV2 {
  CardNumber?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  CustomerID?: InputMaybe<Scalars['ID']>;
  Email?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  FirstName: Scalars['String'];
  GroupID?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  IsActive?: InputMaybe<Scalars['Boolean']>;
  LastName: Scalars['String'];
  Mfa?: InputMaybe<Scalars['Boolean']>;
  MfaOption?: InputMaybe<OptionsMfa>;
  Mobile?: InputMaybe<Scalars['String']>;
  PIN?: InputMaybe<Scalars['String']>;
  PrimaryEmail?: InputMaybe<Scalars['String']>;
  Tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
}

export interface UploadLogoSchema {
  customerId?: Maybe<Scalars['ID']>;
  expiryTime?: Maybe<Scalars['String']>;
  logoType?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  signedUrl?: Maybe<Scalars['String']>;
}

export interface UploadVersionSchema {
  VersionType?: Maybe<Scalars['String']>;
  expiryTime?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  signedUrl?: Maybe<Scalars['String']>;
}

export interface Usage {
  AddValue?: Maybe<AddValue>;
  Area?: Maybe<Scalars['String']>;
  AreaID?: Maybe<Scalars['String']>;
  Balance?: Maybe<Balance>;
  BarcodeNumber?: Maybe<Scalars['String']>;
  BillingAccountId?: Maybe<Scalars['String']>;
  BillingAccountName?: Maybe<Scalars['String']>;
  Booking?: Maybe<Booking>;
  CurrencyCode?: Maybe<Scalars['String']>;
  Customer?: Maybe<Scalars['String']>;
  CustomerID?: Maybe<Scalars['String']>;
  DeductBalance?: Maybe<Array<Maybe<DeductBalanceSchema>>>;
  DeductValue?: Maybe<DeductValue>;
  EmailAddress?: Maybe<Scalars['String']>;
  Fax?: Maybe<FaxSchema>;
  FinePayment?: Maybe<FinePayment>;
  FullName?: Maybe<Scalars['String']>;
  Group?: Maybe<Scalars['String']>;
  GroupID?: Maybe<Scalars['String']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  Location?: Maybe<Scalars['String']>;
  LocationID?: Maybe<Scalars['String']>;
  Print?: Maybe<Print>;
  ReleaseCode?: Maybe<Scalars['String']>;
  Thing?: Maybe<Scalars['String']>;
  ThingID?: Maybe<Scalars['String']>;
  ThirdPartyTrackID?: Maybe<Scalars['String']>;
  TimeZone?: Maybe<Scalars['String']>;
  TransactionDate?: Maybe<Scalars['Date']>;
  TransactionEndTime?: Maybe<Scalars['Date']>;
  TransactionID?: Maybe<Scalars['String']>;
  TransactionStartTime?: Maybe<Scalars['Date']>;
  Type?: Maybe<Scalars['String']>;
  UserID?: Maybe<Scalars['ID']>;
  UserType?: Maybe<Scalars['String']>;
  Username?: Maybe<Scalars['String']>;
  _id: Scalars['ID'];
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  deletedBy?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['String']>;
}

export interface UsageInput {
  AddValue?: InputMaybe<AddValueInput>;
  Area?: InputMaybe<Scalars['String']>;
  AreaID?: InputMaybe<Scalars['String']>;
  Balance?: InputMaybe<Array<InputMaybe<BalanceInput>>>;
  BarcodeNumber?: InputMaybe<Scalars['String']>;
  BillingAccountId?: InputMaybe<Scalars['String']>;
  BillingAccountName?: InputMaybe<Scalars['String']>;
  Booking?: InputMaybe<BookingInput>;
  CurrencyCode?: InputMaybe<Scalars['String']>;
  Customer?: InputMaybe<Scalars['String']>;
  CustomerID?: InputMaybe<Scalars['String']>;
  DeductBalance?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  DeductValue?: InputMaybe<DeductValueInput>;
  EmailAddress?: InputMaybe<Scalars['String']>;
  Fax?: InputMaybe<FaxInputUsage>;
  FinePayment?: InputMaybe<FinePaymentInput>;
  FullName?: InputMaybe<Scalars['String']>;
  Group?: InputMaybe<Scalars['String']>;
  GroupID?: InputMaybe<Scalars['String']>;
  Location?: InputMaybe<Scalars['String']>;
  LocationID?: InputMaybe<Scalars['String']>;
  Print?: InputMaybe<PrintInput>;
  ReleaseCode?: InputMaybe<Scalars['String']>;
  Thing?: InputMaybe<Scalars['String']>;
  ThingID?: InputMaybe<Scalars['String']>;
  TimeZone?: InputMaybe<Scalars['String']>;
  TransactionDate?: InputMaybe<Scalars['Date']>;
  TransactionEndTime?: InputMaybe<Scalars['Date']>;
  TransactionID?: InputMaybe<Scalars['String']>;
  TransactionStartTime?: InputMaybe<Scalars['Date']>;
  Type?: InputMaybe<ReportType>;
  UserID?: InputMaybe<Scalars['ID']>;
  UserType?: InputMaybe<Scalars['String']>;
  Username?: InputMaybe<Scalars['String']>;
}

export interface UsagesResponse {
  total?: Maybe<Scalars['Int']>;
  usage?: Maybe<Array<Maybe<Usage>>>;
}

export interface User {
  ApiKey?: Maybe<Scalars['String']>;
  ApprovedUser?: Maybe<Scalars['String']>;
  AuthProvideData?: Maybe<AuthProvideDataSchema>;
  Balance?: Maybe<BalanceSchema>;
  BarcodeNumber?: Maybe<Scalars['Int']>;
  CardNumber?: Maybe<Array<Maybe<Scalars['String']>>>;
  CustomerData?: Maybe<CustomerDataSchema>;
  CustomerID?: Maybe<Scalars['String']>;
  CustomerName?: Maybe<Scalars['String']>;
  DebitBalance?: Maybe<Scalars['Float']>;
  EbBlocked?: Maybe<EbBlockedSchema>;
  EbExpiryDate?: Maybe<Scalars['Date']>;
  Email?: Maybe<Array<Maybe<Scalars['String']>>>;
  FirstName?: Maybe<Scalars['String']>;
  FullName?: Maybe<Scalars['String']>;
  GroupData?: Maybe<Array<Maybe<GroupDataSchema>>>;
  GroupID?: Maybe<Array<Maybe<Scalars['String']>>>;
  GroupOverride?: Maybe<Scalars['String']>;
  GroupQuotas?: Maybe<Array<Maybe<GroupQuotaSchema>>>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  LMSInformation?: Maybe<LmsInformationSchema>;
  Label?: Maybe<Scalars['String']>;
  LastName?: Maybe<Scalars['String']>;
  Mfa?: Maybe<Scalars['Boolean']>;
  MfaOption?: Maybe<OptionsMfaSchema>;
  Mobile?: Maybe<Scalars['String']>;
  Notes?: Maybe<Scalars['String']>;
  PIN?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  PrimaryEmail?: Maybe<Scalars['String']>;
  Tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  TenantDomain?: Maybe<Scalars['String']>;
  Tier?: Maybe<Scalars['String']>;
  UserRole?: Maybe<Scalars['String']>;
  UserType?: Maybe<Scalars['String']>;
  Username?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['ID']>;
}

export interface UserDashboardReports {
  AccountInfo?: Maybe<Array<Maybe<AccountInfoSchema>>>;
  Balance?: Maybe<Scalars['Float']>;
  DayWiseData?: Maybe<Array<Maybe<DayWiseData>>>;
  PrintJobs?: Maybe<UserTotalJobs>;
  PrintPages?: Maybe<UserTotalPages>;
}

export interface UserInformationSection {
  GuestVisibility?: Maybe<Scalars['Boolean']>;
  Options?: Maybe<UserOptionsSchema>;
  OptionsVisibility?: Maybe<Scalars['Boolean']>;
  ReleaseCodeVisibility?: Maybe<Scalars['Boolean']>;
  Title?: Maybe<Scalars['String']>;
  ValidationVisibility?: Maybe<Scalars['Boolean']>;
}

export interface UserInformationSectionInput {
  GuestVisibility?: InputMaybe<Scalars['Boolean']>;
  Options?: InputMaybe<UserOptionsInput>;
  OptionsVisibility?: InputMaybe<Scalars['Boolean']>;
  ReleaseCodeVisibility?: InputMaybe<Scalars['Boolean']>;
  Title?: InputMaybe<Scalars['String']>;
  ValidationVisibility?: InputMaybe<Scalars['Boolean']>;
}

export interface UserInput {
  ApiKey?: InputMaybe<Scalars['String']>;
  ApprovedUser?: InputMaybe<Scalars['Boolean']>;
  Balance?: InputMaybe<BalanceInputUser>;
  BarcodeNumber?: InputMaybe<Scalars['Int']>;
  CardNumber?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  CustomerID: Scalars['String'];
  DebitBalance?: InputMaybe<Scalars['Float']>;
  DeletedAt?: InputMaybe<Scalars['Date']>;
  DeletedBy?: InputMaybe<Scalars['String']>;
  EbBlocked?: InputMaybe<EbBlockedInput>;
  EbExpiryDate?: InputMaybe<Scalars['Date']>;
  Email?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  FirstName?: InputMaybe<Scalars['String']>;
  FullName?: InputMaybe<Scalars['String']>;
  GroupID?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  GroupOverride?: InputMaybe<Scalars['String']>;
  GroupQuotas?: InputMaybe<Array<InputMaybe<GroupQuotaInput>>>;
  IsActive?: InputMaybe<Scalars['Boolean']>;
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  LMSInformation?: InputMaybe<LmsInformationInput>;
  Label?: InputMaybe<Scalars['String']>;
  LastName?: InputMaybe<Scalars['String']>;
  Mfa?: InputMaybe<Scalars['Boolean']>;
  MfaOption?: InputMaybe<OptionsMfa>;
  Mobile?: InputMaybe<Scalars['String']>;
  Notes?: InputMaybe<Scalars['String']>;
  PIN?: InputMaybe<Scalars['String']>;
  Password?: InputMaybe<Scalars['String']>;
  PhoneNumber?: InputMaybe<Scalars['String']>;
  PrimaryEmail: Scalars['String'];
  Tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  TenantDomain: Scalars['String'];
  Tier: Scalars['String'];
  UpdatedBy?: InputMaybe<Scalars['String']>;
  UserRole?: InputMaybe<Scalars['String']>;
  UserType?: InputMaybe<Scalars['String']>;
  Username?: InputMaybe<Scalars['String']>;
}

export interface UserOptionsInput {
  Guest?: InputMaybe<GuestInput>;
  ReleaseCode?: InputMaybe<ReleaseCodeInput>;
  Validation?: InputMaybe<UserValidationInput>;
}

export interface UserOptionsSchema {
  Guest?: Maybe<GuestSchema>;
  ReleaseCode?: Maybe<ReleaseCodeSchema>;
  Validation?: Maybe<UserValidationSchema>;
}

export interface UserOverviewResponse {
  transaction?: Maybe<UsagesResponse>;
  usage?: Maybe<UsagesResponse>;
  user?: Maybe<User>;
}

export interface UserSession {
  CustomerID?: Maybe<Scalars['String']>;
  FirstName?: Maybe<Scalars['String']>;
  LastName?: Maybe<Scalars['String']>;
  PinExists?: Maybe<Scalars['Boolean']>;
  PrimaryEmail?: Maybe<Scalars['String']>;
  TenantDomain?: Maybe<Scalars['String']>;
  Token?: Maybe<Scalars['String']>;
  Username?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['String']>;
  isKiosk?: Maybe<Scalars['Boolean']>;
  userExists?: Maybe<Scalars['Boolean']>;
}

export interface UserTotalJobs {
  Jobs?: Maybe<Scalars['Int']>;
  Username?: Maybe<Scalars['String']>;
}

export interface UserTotalPages {
  Page?: Maybe<Scalars['Int']>;
  Username?: Maybe<Scalars['String']>;
}

export interface UserValidationInput {
  CardNumberBox?: InputMaybe<Scalars['Boolean']>;
  CardNumberTextBox?: InputMaybe<Scalars['String']>;
  EmailConfirmationTextBox?: InputMaybe<Scalars['String']>;
  LoginDisplayText?: InputMaybe<Scalars['String']>;
  PINBox?: InputMaybe<Scalars['Boolean']>;
  PinNumberTextBox?: InputMaybe<Scalars['String']>;
  TextConfirmationTextBox?: InputMaybe<Scalars['String']>;
  ValidationText?: InputMaybe<Scalars['String']>;
}

export interface UserValidationSchema {
  CardNumberBox?: Maybe<Scalars['Boolean']>;
  CardNumberTextBox?: Maybe<Scalars['String']>;
  EmailConfirmationTextBox?: Maybe<Scalars['String']>;
  LoginDisplayText?: Maybe<Scalars['String']>;
  PINBox?: Maybe<Scalars['Boolean']>;
  PinNumberTextBox?: Maybe<Scalars['String']>;
  TextConfirmationTextBox?: Maybe<Scalars['String']>;
  ValidationText?: Maybe<Scalars['String']>;
}

export interface UsersResponse {
  total?: Maybe<Scalars['Int']>;
  user?: Maybe<Array<Maybe<User>>>;
}

export interface ValidationCheckInput {
  collectionName?: InputMaybe<CollectionNameType>;
  fieldName?: InputMaybe<FieldNameType>;
  fieldValue?: InputMaybe<Scalars['String']>;
}

export interface ValidationInput {
  InternalUser?: InputMaybe<Scalars['Boolean']>;
  LMSValidation?: InputMaybe<Scalars['Boolean']>;
}

export interface ValidationSchema {
  InternalUser?: Maybe<Scalars['Boolean']>;
  LMSValidation?: Maybe<Scalars['Boolean']>;
}

export interface Validator {
  ApiKey?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['String']>;
  Customer?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  Enabled?: Maybe<Scalars['Boolean']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  Label?: Maybe<Scalars['String']>;
  PinEnabled?: Maybe<Scalars['Boolean']>;
  Secret?: Maybe<Scalars['String']>;
  Tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  Url?: Maybe<Scalars['String']>;
  Validator?: Maybe<Scalars['String']>;
  ValidatorType?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['ID']>;
}

export interface ValidatorInput {
  ApiKey?: InputMaybe<Scalars['String']>;
  Customer?: InputMaybe<Scalars['String']>;
  DeletedAt?: InputMaybe<Scalars['Date']>;
  DeletedBy?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  Enabled?: InputMaybe<Scalars['Boolean']>;
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  Label?: InputMaybe<Scalars['String']>;
  PinEnabled?: InputMaybe<Scalars['Boolean']>;
  Secret?: InputMaybe<Scalars['String']>;
  Tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  UpdatedBy?: InputMaybe<Scalars['String']>;
  Url?: InputMaybe<Scalars['String']>;
  Validator?: InputMaybe<Scalars['String']>;
  ValidatorType?: InputMaybe<Scalars['String']>;
}

export interface ValidatorsResponse {
  total?: Maybe<Scalars['Int']>;
  validator?: Maybe<Array<Maybe<Validator>>>;
}

export interface Version {
  CreatedAt?: Maybe<Scalars['Date']>;
  CustomerID?: Maybe<Scalars['ID']>;
  Disabled?: Maybe<Scalars['Boolean']>;
  Enabled?: Maybe<Scalars['Boolean']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  Package?: Maybe<Scalars['String']>;
  Release?: Maybe<Scalars['Boolean']>;
  ReleaseDate?: Maybe<Scalars['Date']>;
  Tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  ThingType?: Maybe<Scalars['String']>;
  UpdatedAt?: Maybe<Scalars['Date']>;
  VersionDescription?: Maybe<Scalars['String']>;
  VersionNumber?: Maybe<Scalars['String']>;
  _id?: Maybe<Scalars['ID']>;
}

export interface VersionAttributes {
  contentType: Scalars['String'];
  extension: Scalars['String'];
  fileName: Scalars['String'];
}

export interface VersionInput {
  CreatedAt?: InputMaybe<Scalars['Date']>;
  CustomerID?: InputMaybe<Scalars['ID']>;
  Disabled?: InputMaybe<Scalars['Boolean']>;
  Enabled?: InputMaybe<Scalars['Boolean']>;
  IsActive?: InputMaybe<Scalars['Boolean']>;
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  Package?: InputMaybe<Scalars['String']>;
  Release?: InputMaybe<Scalars['Boolean']>;
  ReleaseDate?: InputMaybe<Scalars['Date']>;
  Tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ThingType?: InputMaybe<Scalars['String']>;
  UpdatedAt?: InputMaybe<Scalars['Date']>;
  VersionDescription?: InputMaybe<Scalars['String']>;
  VersionNumber?: InputMaybe<Scalars['String']>;
}

export interface VersionsResponse {
  total?: Maybe<Scalars['Int']>;
  version?: Maybe<Array<Maybe<Version>>>;
}

export interface WarningMessagesIntervalInput {
  Interval1?: InputMaybe<Scalars['String']>;
  Interval2?: InputMaybe<Scalars['String']>;
  Interval3?: InputMaybe<Scalars['String']>;
  Interval4?: InputMaybe<Scalars['String']>;
  Interval5?: InputMaybe<Scalars['String']>;
}

export interface WarningMessagesIntervalSchema {
  Interval1?: Maybe<Scalars['String']>;
  Interval2?: Maybe<Scalars['String']>;
  Interval3?: Maybe<Scalars['String']>;
  Interval4?: Maybe<Scalars['String']>;
  Interval5?: Maybe<Scalars['String']>;
}

export interface XenditInput {
  SecretKey?: InputMaybe<Scalars['String']>;
  WebhookURL?: InputMaybe<Scalars['String']>;
}

export interface XenditInvoiceInput {
  Amount?: InputMaybe<Scalars['Float']>;
  Currency?: InputMaybe<Scalars['String']>;
  CustomerID?: InputMaybe<Scalars['String']>;
  FailureURL?: InputMaybe<Scalars['String']>;
  PaymentID?: InputMaybe<Scalars['String']>;
  SuccessURL?: InputMaybe<Scalars['String']>;
}

export interface XenditResponse {
  Message?: Maybe<Scalars['String']>;
  PayURL?: Maybe<Scalars['String']>;
  StatusCode?: Maybe<Scalars['Int']>;
}

export interface XenditSchema {
  SecretKey?: Maybe<Scalars['String']>;
  WebhookURL?: Maybe<Scalars['String']>;
}

export interface ApprovedCustomer {
  IsApproved?: InputMaybe<Scalars['Boolean']>;
}

export interface ConfirmFileUploadV2Response {
  CustomerLocation?: Maybe<Scalars['String']>;
  Data?: Maybe<Array<Maybe<JobListFieldSchema>>>;
  GuestName?: Maybe<Scalars['String']>;
  LibraryCard?: Maybe<Scalars['String']>;
  ReleaseCode?: Maybe<Scalars['String']>;
  TotalCost?: Maybe<Scalars['Float']>;
  Username?: Maybe<Scalars['String']>;
}

export interface CsvReportData {
  base64?: Maybe<Scalars['String']>;
}

export interface CustomizationText {
  AddValuePageAmount?: Maybe<Array<Maybe<Scalars['Float']>>>;
  AdvancedEmailConfiguration?: Maybe<AdvancedEmailConfigurationSchema>;
  BrandScheme?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['String']>;
  Currency?: Maybe<Scalars['String']>;
  CustomEmailMessage?: Maybe<Scalars['String']>;
  CustomerID?: Maybe<Scalars['String']>;
  CustomerLanguage?: Maybe<Scalars['String']>;
  DecimalSeparator?: Maybe<Scalars['String']>;
  DeletedAt?: Maybe<Scalars['Date']>;
  DeletedBy?: Maybe<Scalars['String']>;
  DisplayUpload?: Maybe<Scalars['Boolean']>;
  EnableSignUp?: Maybe<Scalars['Boolean']>;
  GlobalDecimalSetting?: Maybe<Scalars['Int']>;
  GroupData?: Maybe<GroupDataSchema>;
  HideEmailPrinting?: Maybe<Scalars['Boolean']>;
  HowToLogoSection?: Maybe<HowToLogoSection>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  Languages?: Maybe<Array<Maybe<Scalars['String']>>>;
  Layout?: Maybe<Scalars['String']>;
  LocationHoursSection?: Maybe<LocationHoursSection>;
  LocationSearchRange?: Maybe<Scalars['Int']>;
  LogoMobile?: Maybe<LogoMobile>;
  MainSection?: Maybe<MainSection>;
  MobileConfiguration?: Maybe<MobileConfigurationSchema>;
  PriceToggle?: Maybe<Scalars['Boolean']>;
  SelectFileSection?: Maybe<SelectFileSection>;
  SignUpGroup?: Maybe<Scalars['ID']>;
  TermsAndServiceAdditions?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['String']>;
  UserInformationSection?: Maybe<UserInformationSection>;
  _id?: Maybe<Scalars['ID']>;
}

export interface CustomizationTextInput {
  AddValuePageAmount?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  AdvancedEmailConfiguration?: InputMaybe<AdvancedEmailConfigurationInput>;
  BrandScheme?: InputMaybe<Scalars['String']>;
  Currency?: InputMaybe<Scalars['String']>;
  CustomEmailMessage?: InputMaybe<Scalars['String']>;
  CustomerID?: InputMaybe<Scalars['String']>;
  CustomerLanguage?: InputMaybe<Scalars['String']>;
  DecimalSeparator?: InputMaybe<Scalars['String']>;
  DisplayUpload?: InputMaybe<Scalars['Boolean']>;
  EnableSignUp?: InputMaybe<Scalars['Boolean']>;
  GlobalDecimalSetting?: InputMaybe<Scalars['Int']>;
  HideEmailPrinting?: InputMaybe<Scalars['Boolean']>;
  HowToLogoSection?: InputMaybe<HowToLogoSectionInput>;
  Languages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  Layout?: InputMaybe<Scalars['String']>;
  LocationHoursSection?: InputMaybe<LocationHoursSectionInput>;
  LocationSearchRange?: InputMaybe<Scalars['Int']>;
  LogoMobile?: InputMaybe<LogoMobileInput>;
  MainSection?: InputMaybe<MainSectionInput>;
  MobileConfiguration?: InputMaybe<MobileConfigurationInput>;
  PriceToggle?: InputMaybe<Scalars['Boolean']>;
  SelectFileSection?: InputMaybe<SelectFileSectionInput>;
  SignUpGroup?: InputMaybe<Scalars['ID']>;
  TermsAndServiceAdditions?: InputMaybe<Scalars['String']>;
  UserInformationSection?: InputMaybe<UserInformationSectionInput>;
}

export interface EGhlHashInput {
  Amount?: InputMaybe<Scalars['Float']>;
  ApprovalURL?: InputMaybe<Scalars['String']>;
  CurrencyCode?: InputMaybe<Scalars['String']>;
  CustomerID?: InputMaybe<Scalars['String']>;
  PaymentID?: InputMaybe<Scalars['String']>;
  ReturnURL?: InputMaybe<Scalars['String']>;
  UnApprovalURL?: InputMaybe<Scalars['String']>;
}

export interface EGhlHashResponse {
  Amount?: Maybe<Scalars['String']>;
  ApprovalURL?: Maybe<Scalars['String']>;
  CallbackURL?: Maybe<Scalars['String']>;
  CurrencyCode?: Maybe<Scalars['String']>;
  Hash?: Maybe<Scalars['String']>;
  Message?: Maybe<Scalars['String']>;
  OrderNumber?: Maybe<Scalars['String']>;
  PageTimeout?: Maybe<Scalars['String']>;
  PaymentID?: Maybe<Scalars['String']>;
  ReturnURL?: Maybe<Scalars['String']>;
  ServiceID?: Maybe<Scalars['String']>;
  StatusCode?: Maybe<Scalars['Int']>;
  UnApprovalURL?: Maybe<Scalars['String']>;
}

export interface EGhlInput {
  Password?: InputMaybe<Scalars['String']>;
  ServiceId?: InputMaybe<Scalars['String']>;
}

export interface EGhlSchema {
  Password?: Maybe<Scalars['String']>;
  ServiceId?: Maybe<Scalars['String']>;
}

export interface Pay88SignatureInput {
  Amount?: InputMaybe<Scalars['String']>;
  ApprovalURL?: InputMaybe<Scalars['String']>;
  Currency?: InputMaybe<Scalars['String']>;
  CustomerID?: InputMaybe<Scalars['String']>;
  PaymentID?: InputMaybe<Scalars['ID']>;
  UnApprovalURL?: InputMaybe<Scalars['String']>;
}

export enum ReportType {
  AddValue = 'add_value',
  Copy = 'copy',
  DeductBalance = 'deduct_balance',
  Print = 'print',
  Scan = 'scan'
}

export enum TransactionTypes {
  Account = 'account',
  Cash = 'cash',
  CreditCard = 'credit_card',
  Internal = 'internal',
  Override = 'override',
  System = 'system'
}

export interface UpdateBalanceUserInput {
  AccountID: Scalars['ID'];
  Amount: Scalars['Float'];
  Comment?: InputMaybe<Scalars['String']>;
  CustomerID: Scalars['ID'];
  Name?: InputMaybe<Scalars['String']>;
  Type: BalanceType;
  UserID: Scalars['ID'];
  Username?: InputMaybe<Scalars['String']>;
}
